//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AstroApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAcquisitionAttributionPost(body: RecordAcquisitionAttributionDto | undefined): Promise<AcquisitionAttributionDto> {
        let url_ = this.baseUrl + "/api/Acquisition/attribution";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAcquisitionAttributionPost(_response);
        });
    }

    protected processApiAcquisitionAttributionPost(response: Response): Promise<AcquisitionAttributionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcquisitionAttributionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcquisitionAttributionDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAcquisitionAttributionGet(): Promise<AcquisitionAttributionDto> {
        let url_ = this.baseUrl + "/api/Acquisition/attribution";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAcquisitionAttributionGet(_response);
        });
    }

    protected processApiAcquisitionAttributionGet(response: Response): Promise<AcquisitionAttributionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcquisitionAttributionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AcquisitionAttributionDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @return OK
     */
    apiAdminAiBudget(date: Date | undefined): Promise<AdminAiBudgetSnapshotDto> {
        let url_ = this.baseUrl + "/api/AdminAiBudget?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminAiBudget(_response);
        });
    }

    protected processApiAdminAiBudget(response: Response): Promise<AdminAiBudgetSnapshotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminAiBudgetSnapshotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminAiBudgetSnapshotDto>(null as any);
    }

    /**
     * @return OK
     */
    adminSocialReports(): Promise<PostReportDto[]> {
        let url_ = this.baseUrl + "/admin/social/reports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminSocialReports(_response);
        });
    }

    protected processAdminSocialReports(response: Response): Promise<PostReportDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostReportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostReportDto[]>(null as any);
    }

    /**
     * @return OK
     */
    adminSocialReportsHide(id: string): Promise<HidePostResponseDto> {
        let url_ = this.baseUrl + "/admin/social/reports/{id}/hide";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminSocialReportsHide(_response);
        });
    }

    protected processAdminSocialReportsHide(response: Response): Promise<HidePostResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HidePostResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HidePostResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    adminSocialReportsRemove(id: string): Promise<PostReportDto> {
        let url_ = this.baseUrl + "/admin/social/reports/{id}/remove";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminSocialReportsRemove(_response);
        });
    }

    protected processAdminSocialReportsRemove(response: Response): Promise<PostReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    adminSocialReportsBan(id: string, body: BanRequestDto | undefined): Promise<PostReportDto> {
        let url_ = this.baseUrl + "/admin/social/reports/{id}/ban";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminSocialReportsBan(_response);
        });
    }

    protected processAdminSocialReportsBan(response: Response): Promise<PostReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostReportDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAdminUsersGet(): Promise<AdminUserListItemDto[]> {
        let url_ = this.baseUrl + "/api/AdminUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersGet(_response);
        });
    }

    protected processApiAdminUsersGet(response: Response): Promise<AdminUserListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminUserListItemDto[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param status (optional) 
     * @param tier (optional) 
     * @return OK
     */
    apiAdminUsersSubscriptionsGet(page: number | undefined, pageSize: number | undefined, status: UserSubscriptionStatus | undefined, tier: SubscriptionTier | undefined): Promise<UserSubscriptionPagedResultDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/subscriptions?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (tier === null)
            throw new globalThis.Error("The parameter 'tier' cannot be null.");
        else if (tier !== undefined)
            url_ += "tier=" + encodeURIComponent("" + tier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersSubscriptionsGet(_response);
        });
    }

    protected processApiAdminUsersSubscriptionsGet(response: Response): Promise<UserSubscriptionPagedResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSubscriptionPagedResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscriptionPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAdminUsersSubscriptionsPut(body: AdminUpdateSubscriptionDto | undefined): Promise<UserSubscription> {
        let url_ = this.baseUrl + "/api/AdminUsers/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersSubscriptionsPut(_response);
        });
    }

    protected processApiAdminUsersSubscriptionsPut(response: Response): Promise<UserSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscription>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    apiAdminUsersRefundRequestsGet(page: number | undefined, pageSize: number | undefined): Promise<AdminSubscriptionRefundRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/refund-requests?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersRefundRequestsGet(_response);
        });
    }

    protected processApiAdminUsersRefundRequestsGet(response: Response): Promise<AdminSubscriptionRefundRequestDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSubscriptionRefundRequestDtoPagedResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminSubscriptionRefundRequestDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAdminUsersRefundRequestsPut(id: string, body: AdminUpdateSubscriptionRefundRequestDto | undefined): Promise<AdminSubscriptionRefundRequestDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/refund-requests/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersRefundRequestsPut(_response);
        });
    }

    protected processApiAdminUsersRefundRequestsPut(response: Response): Promise<AdminSubscriptionRefundRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminSubscriptionRefundRequestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminSubscriptionRefundRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiAdminUsersSubscriptionsManual(body: AdminCreateSubscriptionDto | undefined): Promise<UserSubscription> {
        let url_ = this.baseUrl + "/api/AdminUsers/subscriptions/manual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersSubscriptionsManual(_response);
        });
    }

    protected processApiAdminUsersSubscriptionsManual(response: Response): Promise<UserSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = UserSubscription.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscription>(null as any);
    }

    /**
     * @return OK
     */
    apiAdminUsersSubscriptionsCancel(userId: string): Promise<UserSubscription> {
        let url_ = this.baseUrl + "/api/AdminUsers/subscriptions/{userId}/cancel";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersSubscriptionsCancel(_response);
        });
    }

    protected processApiAdminUsersSubscriptionsCancel(response: Response): Promise<UserSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscription>(null as any);
    }

    /**
     * @return No Content
     */
    apiAdminUsersRevokeSessions(authUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/AdminUsers/{authUserId}/revoke-sessions";
        if (authUserId === undefined || authUserId === null)
            throw new globalThis.Error("The parameter 'authUserId' must be defined.");
        url_ = url_.replace("{authUserId}", encodeURIComponent("" + authUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersRevokeSessions(_response);
        });
    }

    protected processApiAdminUsersRevokeSessions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAdminUsersPut(authUserId: string, body: AdminUserUpdateDto | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/{authUserId}";
        if (authUserId === undefined || authUserId === null)
            throw new globalThis.Error("The parameter 'authUserId' must be defined.");
        url_ = url_.replace("{authUserId}", encodeURIComponent("" + authUserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersPut(_response);
        });
    }

    protected processApiAdminUsersPut(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    apiAdminUsersFailedJobs(page: number | undefined, pageSize: number | undefined): Promise<AdminAiReadingJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/failed-jobs?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersFailedJobs(_response);
        });
    }

    protected processApiAdminUsersFailedJobs(response: Response): Promise<AdminAiReadingJobDtoPagedResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminAiReadingJobDtoPagedResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminAiReadingJobDtoPagedResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAdminUsersFailedJobsRetry(id: string): Promise<AdminAiReadingJobDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/failed-jobs/{id}/retry";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersFailedJobsRetry(_response);
        });
    }

    protected processApiAdminUsersFailedJobsRetry(response: Response): Promise<AdminAiReadingJobDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminAiReadingJobDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminAiReadingJobDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAdminUsersFailedJobsCancel(id: string): Promise<AdminAiReadingJobDto> {
        let url_ = this.baseUrl + "/api/AdminUsers/failed-jobs/{id}/cancel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAdminUsersFailedJobsCancel(_response);
        });
    }

    protected processApiAdminUsersFailedJobsCancel(response: Response): Promise<AdminAiReadingJobDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminAiReadingJobDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminAiReadingJobDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAssetPredictionTrain(body: TrainAssetModelRequestDto | undefined): Promise<AssetModelTrainingResponseDto> {
        let url_ = this.baseUrl + "/api/AssetPrediction/train";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetPredictionTrain(_response);
        });
    }

    protected processApiAssetPredictionTrain(response: Response): Promise<AssetModelTrainingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetModelTrainingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetModelTrainingResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAssets(): Promise<AssetListDto[]> {
        let url_ = this.baseUrl + "/api/Assets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssets(_response);
        });
    }

    protected processApiAssets(response: Response): Promise<AssetListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetListDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsByid(id: string): Promise<AssetDetailDto> {
        let url_ = this.baseUrl + "/api/Assets/byid/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsByid(_response);
        });
    }

    protected processApiAssetsByid(response: Response): Promise<AssetDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDetailDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsTickers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Assets/tickers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsTickers(_response);
        });
    }

    protected processApiAssetsTickers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsByticker(ticker: string): Promise<AssetDetailDto> {
        let url_ = this.baseUrl + "/api/Assets/byticker/{ticker}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsByticker(_response);
        });
    }

    protected processApiAssetsByticker(response: Response): Promise<AssetDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDetailDto>(null as any);
    }

    /**
     * @param q (optional) 
     * @return OK
     */
    apiAssetsSearch(q: string | undefined): Promise<AssetListDto[]> {
        let url_ = this.baseUrl + "/api/Assets/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsSearch(_response);
        });
    }

    protected processApiAssetsSearch(response: Response): Promise<AssetListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetListDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsTransitProfile(ticker: string, profileKey: string, date: string): Promise<TransitEvaluation> {
        let url_ = this.baseUrl + "/api/Assets/transit-profile/{ticker}/{profileKey}/{date}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsTransitProfile(_response);
        });
    }

    protected processApiAssetsTransitProfile(response: Response): Promise<TransitEvaluation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransitEvaluation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransitEvaluation>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsTransitProfileWindow(ticker: string, profileKey: string, startDate: string, endDate: string): Promise<WindowProfileResult> {
        let url_ = this.baseUrl + "/api/Assets/transit-profile-window/{ticker}/{profileKey}/{startDate}/{endDate}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsTransitProfileWindow(_response);
        });
    }

    protected processApiAssetsTransitProfileWindow(response: Response): Promise<WindowProfileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WindowProfileResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WindowProfileResult>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsTransitScoresTop(profileKey: string, date: string, count: number): Promise<AssetTransitScoreSummaryDto> {
        let url_ = this.baseUrl + "/api/Assets/transit-scores-top/{profileKey}/{date}/{count}";
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (count === undefined || count === null)
            throw new globalThis.Error("The parameter 'count' must be defined.");
        url_ = url_.replace("{count}", encodeURIComponent("" + count));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsTransitScoresTop(_response);
        });
    }

    protected processApiAssetsTransitScoresTop(response: Response): Promise<AssetTransitScoreSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetTransitScoreSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetTransitScoreSummaryDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAssetsFavoritesGet(): Promise<AssetListDto[]> {
        let url_ = this.baseUrl + "/api/Assets/favorites";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsFavoritesGet(_response);
        });
    }

    protected processApiAssetsFavoritesGet(response: Response): Promise<AssetListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetListDto[]>(null as any);
    }

    /**
     * @return No Content
     */
    apiAssetsFavoritesPost(ticker: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Assets/favorites/{ticker}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsFavoritesPost(_response);
        });
    }

    protected processApiAssetsFavoritesPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    apiAssetsFavoritesDelete(ticker: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Assets/favorites/{ticker}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAssetsFavoritesDelete(_response);
        });
    }

    protected processApiAssetsFavoritesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyNatalChartMePost(): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-chart/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartMePost(_response);
        });
    }

    protected processApiAstrologyNatalChartMePost(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatalChartResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyNatalChartMeGet(): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-chart/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartMeGet(_response);
        });
    }

    protected processApiAstrologyNatalChartMeGet(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatalChartResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyRetrogrades(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Astrology/retrogrades";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyRetrogrades(_response);
        });
    }

    protected processApiAstrologyRetrogrades(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyNatalReadingMe(): Promise<GetNatalReadingResponseDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-reading/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalReadingMe(_response);
        });
    }

    protected processApiAstrologyNatalReadingMe(response: Response): Promise<GetNatalReadingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNatalReadingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetNatalReadingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiAstrologyNatalChart(body: NatalChartRequestDto | undefined): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChart(_response);
        });
    }

    protected processApiAstrologyNatalChart(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatalChartResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyNatalChartsGet(): Promise<UserNatalChartsResponseDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-charts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartsGet(_response);
        });
    }

    protected processApiAstrologyNatalChartsGet(response: Response): Promise<UserNatalChartsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserNatalChartsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserNatalChartsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    apiAstrologyNatalChartsPost(body: CreateAssociatedNatalChartDto | undefined): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-charts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartsPost(_response);
        });
    }

    protected processApiAstrologyNatalChartsPost(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = NatalChartResultDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 402) {
            return response.text().then((_responseText) => {
            let result402: any = null;
            let resultData402 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result402 = ProblemDetails.fromJS(resultData402);
            return throwException("Payment Required", status, _responseText, _headers, result402);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyNatalChartsById(natalChartId: string): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/Astrology/natal-charts/by-id/{natalChartId}";
        if (natalChartId === undefined || natalChartId === null)
            throw new globalThis.Error("The parameter 'natalChartId' must be defined.");
        url_ = url_.replace("{natalChartId}", encodeURIComponent("" + natalChartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartsById(_response);
        });
    }

    protected processApiAstrologyNatalChartsById(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatalChartResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return No Content
     */
    apiAstrologyNatalChartsDelete(natalChartId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Astrology/natal-charts/{natalChartId}";
        if (natalChartId === undefined || natalChartId === null)
            throw new globalThis.Error("The parameter 'natalChartId' must be defined.");
        url_ = url_.replace("{natalChartId}", encodeURIComponent("" + natalChartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyNatalChartsDelete(_response);
        });
    }

    protected processApiAstrologyNatalChartsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param date (optional) 
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyDailyContextMe(date: string | undefined, profiles: string | undefined): Promise<DailyAstroContextDto> {
        let url_ = this.baseUrl + "/api/Astrology/daily-context/me?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyDailyContextMe(_response);
        });
    }

    protected processApiAstrologyDailyContextMe(response: Response): Promise<DailyAstroContextDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DailyAstroContextDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyAstroContextDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyInsightsLiteMe(date: string | undefined, profiles: string | undefined): Promise<InsightsLiteDto> {
        let url_ = this.baseUrl + "/api/Astrology/insights-lite/me?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyInsightsLiteMe(_response);
        });
    }

    protected processApiAstrologyInsightsLiteMe(response: Response): Promise<InsightsLiteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsightsLiteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InsightsLiteDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyDailyReportMe(): Promise<DailyReportDto> {
        let url_ = this.baseUrl + "/api/Astrology/daily-report/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyDailyReportMe(_response);
        });
    }

    protected processApiAstrologyDailyReportMe(response: Response): Promise<DailyReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DailyReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DailyReportDto>(null as any);
    }

    /**
     * @param date (optional) 
     * @param planet (optional) 
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    apiAstrologyTransitsMe(date: string | undefined, planet: string | undefined, type: string | undefined, startDate: string | undefined, endDate: string | undefined): Promise<TransitDayDto[]> {
        let url_ = this.baseUrl + "/api/Astrology/transits/me?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (planet === null)
            throw new globalThis.Error("The parameter 'planet' cannot be null.");
        else if (planet !== undefined)
            url_ += "planet=" + encodeURIComponent("" + planet) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitsMe(_response);
        });
    }

    protected processApiAstrologyTransitsMe(response: Response): Promise<TransitDayDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransitDayDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransitDayDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyTransitProfileMe(profileKey: string, date: string): Promise<TransitEvaluation> {
        let url_ = this.baseUrl + "/api/Astrology/transit-profile/{profileKey}/{date}/me";
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitProfileMe(_response);
        });
    }

    protected processApiAstrologyTransitProfileMe(response: Response): Promise<TransitEvaluation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransitEvaluation.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransitEvaluation>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyTransitProfileWindowMe(profileKey: string, startDate: string, endDate: string): Promise<WindowProfileResult> {
        let url_ = this.baseUrl + "/api/Astrology/transit-profile-window/{profileKey}/{startDate}/{endDate}/me";
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitProfileWindowMe(_response);
        });
    }

    protected processApiAstrologyTransitProfileWindowMe(response: Response): Promise<WindowProfileResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WindowProfileResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WindowProfileResult>(null as any);
    }

    /**
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyTransitProfilesMe(date: string, profiles: string | undefined): Promise<{ [key: string]: TransitEvaluation; }> {
        let url_ = this.baseUrl + "/api/Astrology/transit-profiles/{date}/me?";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitProfilesMe(_response);
        });
    }

    protected processApiAstrologyTransitProfilesMe(response: Response): Promise<{ [key: string]: TransitEvaluation; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? TransitEvaluation.fromJS(resultData200[key]) : new TransitEvaluation();
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TransitEvaluation; }>(null as any);
    }

    /**
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyTransitProfilesWindowMe(startDate: string, endDate: string, profiles: string | undefined): Promise<{ [key: string]: WindowProfileResult; }> {
        let url_ = this.baseUrl + "/api/Astrology/transit-profiles-window/{startDate}/{endDate}/me?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitProfilesWindowMe(_response);
        });
    }

    protected processApiAstrologyTransitProfilesWindowMe(response: Response): Promise<{ [key: string]: WindowProfileResult; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] ? WindowProfileResult.fromJS(resultData200[key]) : new WindowProfileResult();
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: WindowProfileResult; }>(null as any);
    }

    /**
     * @return OK
     */
    apiAstrologyTransitReadingMe(profileKey: string, date: string): Promise<ProfileSummary> {
        let url_ = this.baseUrl + "/api/Astrology/transit-reading/{profileKey}/{date}/me";
        if (profileKey === undefined || profileKey === null)
            throw new globalThis.Error("The parameter 'profileKey' must be defined.");
        url_ = url_.replace("{profileKey}", encodeURIComponent("" + profileKey));
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitReadingMe(_response);
        });
    }

    protected processApiAstrologyTransitReadingMe(response: Response): Promise<ProfileSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSummary.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileSummary>(null as any);
    }

    /**
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyTransitReadingsMe(date: string, profiles: string | undefined): Promise<ProfileSummaries> {
        let url_ = this.baseUrl + "/api/Astrology/transit-readings/{date}/me?";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitReadingsMe(_response);
        });
    }

    protected processApiAstrologyTransitReadingsMe(response: Response): Promise<ProfileSummaries> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSummaries.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileSummaries>(null as any);
    }

    /**
     * @param profiles (optional) 
     * @return OK
     */
    apiAstrologyTransitHighlightsMe(startDate: string, endDate: string, profiles: string | undefined): Promise<ProfileHighlightSummary> {
        let url_ = this.baseUrl + "/api/Astrology/transit-highlights/{startDate}/{endDate}/me?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        if (profiles === null)
            throw new globalThis.Error("The parameter 'profiles' cannot be null.");
        else if (profiles !== undefined)
            url_ += "profiles=" + encodeURIComponent("" + profiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiAstrologyTransitHighlightsMe(_response);
        });
    }

    protected processApiAstrologyTransitHighlightsMe(response: Response): Promise<ProfileHighlightSummary> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileHighlightSummary.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileHighlightSummary>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiChat(body: ChatRequestDto | undefined): Promise<ChatResponseDto> {
        let url_ = this.baseUrl + "/api/Chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChat(_response);
        });
    }

    protected processApiChat(response: Response): Promise<ChatResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 402) {
            return response.text().then((_responseText) => {
            let result402: any = null;
            let resultData402 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result402 = ProblemDetails.fromJS(resultData402);
            return throwException("Payment Required", status, _responseText, _headers, result402);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 502) {
            return response.text().then((_responseText) => {
            return throwException("Bad Gateway", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    apiChatCompanionPost(body: ChatCompanionRequestDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Chat/companion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChatCompanionPost(_response);
        });
    }

    protected processApiChatCompanionPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiChatCompanionGet(): Promise<ChatCompanionResponseDto> {
        let url_ = this.baseUrl + "/api/Chat/companion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChatCompanionGet(_response);
        });
    }

    protected processApiChatCompanionGet(response: Response): Promise<ChatCompanionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChatCompanionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChatCompanionResponseDto>(null as any);
    }

    /**
     * @return No Content
     */
    apiChatCompanionDelete(): Promise<void> {
        let url_ = this.baseUrl + "/api/Chat/companion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiChatCompanionDelete(_response);
        });
    }

    protected processApiChatCompanionDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiCompatibility(body: CompatibilityRequestDto | undefined): Promise<CompatibilityReportDto> {
        let url_ = this.baseUrl + "/api/Compatibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCompatibility(_response);
        });
    }

    protected processApiCompatibility(response: Response): Promise<CompatibilityReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompatibilityReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompatibilityReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiCompatibilityLite(body: CompatibilityRequestDto | undefined): Promise<CompatibilityLiteReportDto> {
        let url_ = this.baseUrl + "/api/Compatibility/lite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiCompatibilityLite(_response);
        });
    }

    protected processApiCompatibilityLite(response: Response): Promise<CompatibilityLiteReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompatibilityLiteReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompatibilityLiteReportDto>(null as any);
    }

    /**
     * @param q (optional) 
     * @param country (optional) 
     * @return OK
     */
    apiGeoLocationSearch(q: string | undefined, country: string | undefined): Promise<LocationSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/GeoLocation/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (country === null)
            throw new globalThis.Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiGeoLocationSearch(_response);
        });
    }

    protected processApiGeoLocationSearch(response: Response): Promise<LocationSuggestionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            let resultData429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result429 = ProblemDetails.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            let resultData503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Service Unavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationSuggestionDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiMarketDataTickers(ticker: string): Promise<TickerDetailsResponse> {
        let url_ = this.baseUrl + "/api/MarketData/tickers/{ticker}";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiMarketDataTickers(_response);
        });
    }

    protected processApiMarketDataTickers(response: Response): Promise<TickerDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TickerDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TickerDetailsResponse>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param btcCsvPath (optional) 
     * @param iterations (optional) 
     * @param seed (optional) 
     * @param tryLags (optional) 
     * @param movingAverageDays (optional) 
     * @param movingAverageType (optional) 
     * @return OK
     */
    apiOptimizerInvestment(ticker: string, start: Date | undefined, end: Date | undefined, btcCsvPath: string | undefined, iterations: number | undefined, seed: number | undefined, tryLags: boolean | undefined, movingAverageDays: number | undefined, movingAverageType: MovingAverageType | undefined): Promise<InvestmentOptimizeResult> {
        let url_ = this.baseUrl + "/api/Optimizer/investment/{ticker}?";
        if (ticker === undefined || ticker === null)
            throw new globalThis.Error("The parameter 'ticker' must be defined.");
        url_ = url_.replace("{ticker}", encodeURIComponent("" + ticker));
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (btcCsvPath === null)
            throw new globalThis.Error("The parameter 'btcCsvPath' cannot be null.");
        else if (btcCsvPath !== undefined)
            url_ += "btcCsvPath=" + encodeURIComponent("" + btcCsvPath) + "&";
        if (iterations === null)
            throw new globalThis.Error("The parameter 'iterations' cannot be null.");
        else if (iterations !== undefined)
            url_ += "iterations=" + encodeURIComponent("" + iterations) + "&";
        if (seed === null)
            throw new globalThis.Error("The parameter 'seed' cannot be null.");
        else if (seed !== undefined)
            url_ += "seed=" + encodeURIComponent("" + seed) + "&";
        if (tryLags === null)
            throw new globalThis.Error("The parameter 'tryLags' cannot be null.");
        else if (tryLags !== undefined)
            url_ += "tryLags=" + encodeURIComponent("" + tryLags) + "&";
        if (movingAverageDays === null)
            throw new globalThis.Error("The parameter 'movingAverageDays' cannot be null.");
        else if (movingAverageDays !== undefined)
            url_ += "movingAverageDays=" + encodeURIComponent("" + movingAverageDays) + "&";
        if (movingAverageType === null)
            throw new globalThis.Error("The parameter 'movingAverageType' cannot be null.");
        else if (movingAverageType !== undefined)
            url_ += "movingAverageType=" + encodeURIComponent("" + movingAverageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOptimizerInvestment(_response);
        });
    }

    protected processApiOptimizerInvestment(response: Response): Promise<InvestmentOptimizeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentOptimizeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentOptimizeResult>(null as any);
    }

    /**
     * @param start (optional) 
     * @param end (optional) 
     * @param btcCsvPath (optional) 
     * @param iterations (optional) 
     * @param seed (optional) 
     * @param tryLags (optional) 
     * @param movingAverageDays (optional) 
     * @param movingAverageType (optional) 
     * @return OK
     */
    apiOptimizerInvestmentMe(start: Date | undefined, end: Date | undefined, btcCsvPath: string | undefined, iterations: number | undefined, seed: number | undefined, tryLags: boolean | undefined, movingAverageDays: number | undefined, movingAverageType: MovingAverageType | undefined): Promise<InvestmentOptimizeResult> {
        let url_ = this.baseUrl + "/api/Optimizer/investment/me?";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new globalThis.Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (btcCsvPath === null)
            throw new globalThis.Error("The parameter 'btcCsvPath' cannot be null.");
        else if (btcCsvPath !== undefined)
            url_ += "btcCsvPath=" + encodeURIComponent("" + btcCsvPath) + "&";
        if (iterations === null)
            throw new globalThis.Error("The parameter 'iterations' cannot be null.");
        else if (iterations !== undefined)
            url_ += "iterations=" + encodeURIComponent("" + iterations) + "&";
        if (seed === null)
            throw new globalThis.Error("The parameter 'seed' cannot be null.");
        else if (seed !== undefined)
            url_ += "seed=" + encodeURIComponent("" + seed) + "&";
        if (tryLags === null)
            throw new globalThis.Error("The parameter 'tryLags' cannot be null.");
        else if (tryLags !== undefined)
            url_ += "tryLags=" + encodeURIComponent("" + tryLags) + "&";
        if (movingAverageDays === null)
            throw new globalThis.Error("The parameter 'movingAverageDays' cannot be null.");
        else if (movingAverageDays !== undefined)
            url_ += "movingAverageDays=" + encodeURIComponent("" + movingAverageDays) + "&";
        if (movingAverageType === null)
            throw new globalThis.Error("The parameter 'movingAverageType' cannot be null.");
        else if (movingAverageType !== undefined)
            url_ += "movingAverageType=" + encodeURIComponent("" + movingAverageType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiOptimizerInvestmentMe(_response);
        });
    }

    protected processApiOptimizerInvestmentMe(response: Response): Promise<InvestmentOptimizeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestmentOptimizeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestmentOptimizeResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPaymentsPost(body: CreatePaymentRequestDto | undefined): Promise<CreatePaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsPost(_response);
        });
    }

    protected processApiPaymentsPost(response: Response): Promise<CreatePaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePaymentResponse>(null as any);
    }

    /**
     * @return OK
     */
    apiPaymentsGet(paymentId: string): Promise<GetPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments/{paymentId}";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsGet(_response);
        });
    }

    protected processApiPaymentsGet(response: Response): Promise<GetPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPaymentsCancel(body: CancelPaymentRequest | undefined): Promise<CancelPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsCancel(_response);
        });
    }

    protected processApiPaymentsCancel(response: Response): Promise<CancelPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CancelPaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPaymentsRefund(body: RefundPaymentRequest | undefined): Promise<RefundPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments/refund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsRefund(_response);
        });
    }

    protected processApiPaymentsRefund(response: Response): Promise<RefundPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefundPaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefundPaymentResponse>(null as any);
    }

    /**
     * @return OK
     */
    apiPaymentsReconcile(paymentId: string): Promise<ReconcilePaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments/{paymentId}/reconcile";
        if (paymentId === undefined || paymentId === null)
            throw new globalThis.Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsReconcile(_response);
        });
    }

    protected processApiPaymentsReconcile(response: Response): Promise<ReconcilePaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconcilePaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReconcilePaymentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPaymentsStart(body: StartPaymentRequest | undefined): Promise<StartPaymentResponse> {
        let url_ = this.baseUrl + "/api/Payments/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsStart(_response);
        });
    }

    protected processApiPaymentsStart(response: Response): Promise<StartPaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartPaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartPaymentResponse>(null as any);
    }

    /**
     * Calculates a transient birth chart without an account or AI readings.
     * @param body (optional) Local birth date, time and coordinates, used only for this calculation.
     * @return OK
     */
    apiPublicNatalChart(body: PublicNatalChartRequestDto | undefined): Promise<NatalChartResultDto> {
        let url_ = this.baseUrl + "/api/public/natal-chart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPublicNatalChart(_response);
        });
    }

    protected processApiPublicNatalChart(response: Response): Promise<NatalChartResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NatalChartResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NatalChartResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiSocialProfile(userId: string): Promise<ProfilePublicDto> {
        let url_ = this.baseUrl + "/api/Social/profile/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialProfile(_response);
        });
    }

    protected processApiSocialProfile(response: Response): Promise<ProfilePublicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfilePublicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfilePublicDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiSocialProfileMe(body: ProfilePublicDto | undefined): Promise<ProfilePublicDto> {
        let url_ = this.baseUrl + "/api/Social/profile/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialProfileMe(_response);
        });
    }

    protected processApiSocialProfileMe(response: Response): Promise<ProfilePublicDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfilePublicDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfilePublicDto>(null as any);
    }

    /**
     * @param q (optional) 
     * @return OK
     */
    apiSocialSearch(q: string | undefined): Promise<SearchUsersResponseDto[]> {
        let url_ = this.baseUrl + "/api/Social/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialSearch(_response);
        });
    }

    protected processApiSocialSearch(response: Response): Promise<SearchUsersResponseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchUsersResponseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchUsersResponseDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiSocialPostsPublic(): Promise<PostDto[]> {
        let url_ = this.baseUrl + "/api/Social/posts/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialPostsPublic(_response);
        });
    }

    protected processApiSocialPostsPublic(response: Response): Promise<PostDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiSocialFeedMe(): Promise<PostDto[]> {
        let url_ = this.baseUrl + "/api/Social/feed/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialFeedMe(_response);
        });
    }

    protected processApiSocialFeedMe(response: Response): Promise<PostDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiSocialPostsMePost(body: Post | undefined): Promise<PostDto> {
        let url_ = this.baseUrl + "/api/Social/posts/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialPostsMePost(_response);
        });
    }

    protected processApiSocialPostsMePost(response: Response): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * @return No Content
     */
    apiSocialPostsMeDelete(id: string): Promise<PostDto> {
        let url_ = this.baseUrl + "/api/Social/posts/{id}/me";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialPostsMeDelete(_response);
        });
    }

    protected processApiSocialPostsMeDelete(response: Response): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = PostDto.fromJS(resultData204);
            return result204;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = PostDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = PostDto.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PostDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiSocialPostsReportMe(id: string, body: string | undefined): Promise<PostDto> {
        let url_ = this.baseUrl + "/api/Social/posts/{id}/report/me";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialPostsReportMe(_response);
        });
    }

    protected processApiSocialPostsReportMe(response: Response): Promise<PostDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = PostDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PostDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PostDto>(null as any);
    }

    /**
     * @return OK
     */
    apiSocialFollowMePost(followeeId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Social/follow/{followeeId}/me";
        if (followeeId === undefined || followeeId === null)
            throw new globalThis.Error("The parameter 'followeeId' must be defined.");
        url_ = url_.replace("{followeeId}", encodeURIComponent("" + followeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialFollowMePost(_response);
        });
    }

    protected processApiSocialFollowMePost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    apiSocialFollowMeDelete(followeeId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Social/follow/{followeeId}/me";
        if (followeeId === undefined || followeeId === null)
            throw new globalThis.Error("The parameter 'followeeId' must be defined.");
        url_ = url_.replace("{followeeId}", encodeURIComponent("" + followeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSocialFollowMeDelete(_response);
        });
    }

    protected processApiSocialFollowMeDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiPaymentsStripeWebhook(): Promise<void> {
        let url_ = this.baseUrl + "/api/payments/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiPaymentsStripeWebhook(_response);
        });
    }

    protected processApiPaymentsStripeWebhook(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Lists active subscription plans with explicit pre-tax and tax-inclusive pricing.
     * @param currency (optional) Optional ISO 4217 currency code used to filter available plans.
     * @return OK
     */
    apiSubscriptionPlans(currency: string | undefined): Promise<SubscriptionPlanListItemDto[]> {
        let url_ = this.baseUrl + "/api/Subscription/plans?";
        if (currency === null)
            throw new globalThis.Error("The parameter 'currency' cannot be null.");
        else if (currency !== undefined)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscriptionPlans(_response);
        });
    }

    protected processApiSubscriptionPlans(response: Response): Promise<SubscriptionPlanListItemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionPlanListItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionPlanListItemDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiSubscription(): Promise<UserSubscription> {
        let url_ = this.baseUrl + "/api/Subscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscription(_response);
        });
    }

    protected processApiSubscription(response: Response): Promise<UserSubscription> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSubscription.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSubscription>(null as any);
    }

    /**
     * @return OK
     */
    apiSubscriptionAccess(): Promise<SubscriptionAccessSnapshotDto> {
        let url_ = this.baseUrl + "/api/Subscription/access";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscriptionAccess(_response);
        });
    }

    protected processApiSubscriptionAccess(response: Response): Promise<SubscriptionAccessSnapshotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionAccessSnapshotDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionAccessSnapshotDto>(null as any);
    }

    /**
     * @return OK
     */
    apiSubscriptionRefundRequestGet(): Promise<SubscriptionRefundRequestEligibilityDto> {
        let url_ = this.baseUrl + "/api/Subscription/refund-request";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscriptionRefundRequestGet(_response);
        });
    }

    protected processApiSubscriptionRefundRequestGet(response: Response): Promise<SubscriptionRefundRequestEligibilityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionRefundRequestEligibilityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionRefundRequestEligibilityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiSubscriptionRefundRequestPost(body: CreateSubscriptionRefundRequestDto | undefined): Promise<SubscriptionRefundRequestSummaryDto> {
        let url_ = this.baseUrl + "/api/Subscription/refund-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscriptionRefundRequestPost(_response);
        });
    }

    protected processApiSubscriptionRefundRequestPost(response: Response): Promise<SubscriptionRefundRequestSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionRefundRequestSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionRefundRequestSummaryDto>(null as any);
    }

    /**
     * Creates a draft subscription order and returns the persisted fiscal and commercial checkout snapshot that will be charged.
     * @param body (optional) Requested subscription plan code for checkout.
     * @return OK
     */
    apiSubscriptionCheckout(body: SubscriptionCheckoutRequestDto | undefined): Promise<SubscriptionCheckoutResponseDto> {
        let url_ = this.baseUrl + "/api/Subscription/checkout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiSubscriptionCheckout(_response);
        });
    }

    protected processApiSubscriptionCheckout(response: Response): Promise<SubscriptionCheckoutResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionCheckoutResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionCheckoutResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiTextRecognizerParseTemporal(body: TemporalParseRequest | undefined): Promise<TemporalParseResult> {
        let url_ = this.baseUrl + "/api/TextRecognizer/parse-temporal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiTextRecognizerParseTemporal(_response);
        });
    }

    protected processApiTextRecognizerParseTemporal(response: Response): Promise<TemporalParseResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemporalParseResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemporalParseResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiUsersPost(body: CreateUserDto | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUsersPost(_response);
        });
    }

    protected processApiUsersPost(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiUsersPut(body: UpdateUserDto | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUsersPut(_response);
        });
    }

    protected processApiUsersPut(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    /**
     * @param idempotency_Key (optional) 
     * @param body (optional) 
     * @return OK
     */
    apiUsersBirthRecordRecalculate(idempotency_Key: string | undefined, body: RecalculateBirthRecordDto | undefined): Promise<RecalculateBirthRecordResponseDto> {
        let url_ = this.baseUrl + "/api/Users/birth-record/recalculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Idempotency-Key": idempotency_Key !== undefined && idempotency_Key !== null ? "" + idempotency_Key : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUsersBirthRecordRecalculate(_response);
        });
    }

    protected processApiUsersBirthRecordRecalculate(response: Response): Promise<RecalculateBirthRecordResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecalculateBirthRecordResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 402) {
            return response.text().then((_responseText) => {
            let result402: any = null;
            let resultData402 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result402 = ProblemDetails.fromJS(resultData402);
            return throwException("Payment Required", status, _responseText, _headers, result402);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecalculateBirthRecordResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiUsersAuth(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiUsersAuth(_response);
        });
    }

    protected processApiUsersAuth(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class AcquisitionAttributionDto implements IAcquisitionAttributionDto {
    source?: string | undefined;
    medium?: string | undefined;
    campaign?: string | undefined;
    content?: string | undefined;
    recordedAtUtc?: Date;
    isFirstTouch?: boolean;

    constructor(data?: IAcquisitionAttributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.medium = _data["medium"];
            this.campaign = _data["campaign"];
            this.content = _data["content"];
            this.recordedAtUtc = _data["recordedAtUtc"] ? new Date(_data["recordedAtUtc"].toString()) : undefined as any;
            this.isFirstTouch = _data["isFirstTouch"];
        }
    }

    static fromJS(data: any): AcquisitionAttributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcquisitionAttributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["medium"] = this.medium;
        data["campaign"] = this.campaign;
        data["content"] = this.content;
        data["recordedAtUtc"] = this.recordedAtUtc ? this.recordedAtUtc.toISOString() : undefined as any;
        data["isFirstTouch"] = this.isFirstTouch;
        return data;
    }
}

export interface IAcquisitionAttributionDto {
    source?: string | undefined;
    medium?: string | undefined;
    campaign?: string | undefined;
    content?: string | undefined;
    recordedAtUtc?: Date;
    isFirstTouch?: boolean;
}

export class AdminAiBudgetContextSummaryDto implements IAdminAiBudgetContextSummaryDto {
    context?: string | undefined;
    planTier?: SubscriptionTier;
    requests?: number;
    estimatedTokens?: number;
    estimatedCostUsd?: number;

    constructor(data?: IAdminAiBudgetContextSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"];
            this.planTier = _data["planTier"];
            this.requests = _data["requests"];
            this.estimatedTokens = _data["estimatedTokens"];
            this.estimatedCostUsd = _data["estimatedCostUsd"];
        }
    }

    static fromJS(data: any): AdminAiBudgetContextSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminAiBudgetContextSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context;
        data["planTier"] = this.planTier;
        data["requests"] = this.requests;
        data["estimatedTokens"] = this.estimatedTokens;
        data["estimatedCostUsd"] = this.estimatedCostUsd;
        return data;
    }
}

export interface IAdminAiBudgetContextSummaryDto {
    context?: string | undefined;
    planTier?: SubscriptionTier;
    requests?: number;
    estimatedTokens?: number;
    estimatedCostUsd?: number;
}

export class AdminAiBudgetSnapshotDto implements IAdminAiBudgetSnapshotDto {
    date?: Date;
    totalRequests?: number;
    basicRequests?: number;
    hasBasicRequests?: boolean;
    estimatedCostUsd?: number;
    dailyBudgetUsd?: number;
    isOverBudget?: boolean;
    overBudgetUsers?: number;
    contexts?: AdminAiBudgetContextSummaryDto[] | undefined;
    users?: AdminAiBudgetUserSummaryDto[] | undefined;

    constructor(data?: IAdminAiBudgetSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.totalRequests = _data["totalRequests"];
            this.basicRequests = _data["basicRequests"];
            this.hasBasicRequests = _data["hasBasicRequests"];
            this.estimatedCostUsd = _data["estimatedCostUsd"];
            this.dailyBudgetUsd = _data["dailyBudgetUsd"];
            this.isOverBudget = _data["isOverBudget"];
            this.overBudgetUsers = _data["overBudgetUsers"];
            if (Array.isArray(_data["contexts"])) {
                this.contexts = [] as any;
                for (let item of _data["contexts"])
                    this.contexts!.push(AdminAiBudgetContextSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AdminAiBudgetUserSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminAiBudgetSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminAiBudgetSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["totalRequests"] = this.totalRequests;
        data["basicRequests"] = this.basicRequests;
        data["hasBasicRequests"] = this.hasBasicRequests;
        data["estimatedCostUsd"] = this.estimatedCostUsd;
        data["dailyBudgetUsd"] = this.dailyBudgetUsd;
        data["isOverBudget"] = this.isOverBudget;
        data["overBudgetUsers"] = this.overBudgetUsers;
        if (Array.isArray(this.contexts)) {
            data["contexts"] = [];
            for (let item of this.contexts)
                data["contexts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminAiBudgetSnapshotDto {
    date?: Date;
    totalRequests?: number;
    basicRequests?: number;
    hasBasicRequests?: boolean;
    estimatedCostUsd?: number;
    dailyBudgetUsd?: number;
    isOverBudget?: boolean;
    overBudgetUsers?: number;
    contexts?: AdminAiBudgetContextSummaryDto[] | undefined;
    users?: AdminAiBudgetUserSummaryDto[] | undefined;
}

export class AdminAiBudgetUserSummaryDto implements IAdminAiBudgetUserSummaryDto {
    userIdHash?: string | undefined;
    planTier?: SubscriptionTier;
    requests?: number;
    estimatedTokens?: number;
    estimatedCostUsd?: number;
    dailyBudgetUsd?: number;
    hasDailyBudget?: boolean;
    isOverBudget?: boolean;

    constructor(data?: IAdminAiBudgetUserSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdHash = _data["userIdHash"];
            this.planTier = _data["planTier"];
            this.requests = _data["requests"];
            this.estimatedTokens = _data["estimatedTokens"];
            this.estimatedCostUsd = _data["estimatedCostUsd"];
            this.dailyBudgetUsd = _data["dailyBudgetUsd"];
            this.hasDailyBudget = _data["hasDailyBudget"];
            this.isOverBudget = _data["isOverBudget"];
        }
    }

    static fromJS(data: any): AdminAiBudgetUserSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminAiBudgetUserSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdHash"] = this.userIdHash;
        data["planTier"] = this.planTier;
        data["requests"] = this.requests;
        data["estimatedTokens"] = this.estimatedTokens;
        data["estimatedCostUsd"] = this.estimatedCostUsd;
        data["dailyBudgetUsd"] = this.dailyBudgetUsd;
        data["hasDailyBudget"] = this.hasDailyBudget;
        data["isOverBudget"] = this.isOverBudget;
        return data;
    }
}

export interface IAdminAiBudgetUserSummaryDto {
    userIdHash?: string | undefined;
    planTier?: SubscriptionTier;
    requests?: number;
    estimatedTokens?: number;
    estimatedCostUsd?: number;
    dailyBudgetUsd?: number;
    hasDailyBudget?: boolean;
    isOverBudget?: boolean;
}

export class AdminAiReadingJobDto implements IAdminAiReadingJobDto {
    id?: string;
    natalChartId?: string;
    context?: string | undefined;
    profileKey?: string | undefined;
    date?: Date | undefined;
    startDay?: Date | undefined;
    endDay?: Date | undefined;
    language?: string | undefined;
    schemaVersion?: string | undefined;
    status?: AiReadingJobStatus;
    batchId?: string | undefined;
    error?: string | undefined;
    attempts?: number;
    treatmentPreference?: UserTreatmentPreference;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;

    constructor(data?: IAdminAiReadingJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.natalChartId = _data["natalChartId"];
            this.context = _data["context"];
            this.profileKey = _data["profileKey"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.startDay = _data["startDay"] ? new Date(_data["startDay"].toString()) : undefined as any;
            this.endDay = _data["endDay"] ? new Date(_data["endDay"].toString()) : undefined as any;
            this.language = _data["language"];
            this.schemaVersion = _data["schemaVersion"];
            this.status = _data["status"];
            this.batchId = _data["batchId"];
            this.error = _data["error"];
            this.attempts = _data["attempts"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminAiReadingJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminAiReadingJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["natalChartId"] = this.natalChartId;
        data["context"] = this.context;
        data["profileKey"] = this.profileKey;
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["startDay"] = this.startDay ? formatDate(this.startDay) : undefined as any;
        data["endDay"] = this.endDay ? formatDate(this.endDay) : undefined as any;
        data["language"] = this.language;
        data["schemaVersion"] = this.schemaVersion;
        data["status"] = this.status;
        data["batchId"] = this.batchId;
        data["error"] = this.error;
        data["attempts"] = this.attempts;
        data["treatmentPreference"] = this.treatmentPreference;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminAiReadingJobDto {
    id?: string;
    natalChartId?: string;
    context?: string | undefined;
    profileKey?: string | undefined;
    date?: Date | undefined;
    startDay?: Date | undefined;
    endDay?: Date | undefined;
    language?: string | undefined;
    schemaVersion?: string | undefined;
    status?: AiReadingJobStatus;
    batchId?: string | undefined;
    error?: string | undefined;
    attempts?: number;
    treatmentPreference?: UserTreatmentPreference;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
}

export class AdminAiReadingJobDtoPagedResultDto implements IAdminAiReadingJobDtoPagedResultDto {
    items!: AdminAiReadingJobDto[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;

    constructor(data?: IAdminAiReadingJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminAiReadingJobDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdminAiReadingJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminAiReadingJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAdminAiReadingJobDtoPagedResultDto {
    items: AdminAiReadingJobDto[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
}

export class AdminCreateSubscriptionDto implements IAdminCreateSubscriptionDto {
    userId?: string;
    planCode?: string | undefined;

    constructor(data?: IAdminCreateSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.planCode = _data["planCode"];
        }
    }

    static fromJS(data: any): AdminCreateSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCreateSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["planCode"] = this.planCode;
        return data;
    }
}

export interface IAdminCreateSubscriptionDto {
    userId?: string;
    planCode?: string | undefined;
}

export class AdminSubscriptionRefundRequestDto implements IAdminSubscriptionRefundRequestDto {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    userPublicId?: string | undefined;
    contactEmail?: string | undefined;
    reason?: string | undefined;
    status?: SubscriptionRefundRequestStatus;
    userSubscriptionId?: string;
    planCode?: string | undefined;
    planName?: string | undefined;
    orderId?: string | undefined;
    paymentId?: string | undefined;
    subscriptionStatusAtRequest?: UserSubscriptionStatus;
    subscriptionStartedAtUtc?: Date | undefined;
    subscriptionEndsAtUtc?: Date | undefined;
    paidAtUtc?: Date | undefined;
    legalAcceptanceId?: string | undefined;
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    immediateStartConsentRequired?: boolean | undefined;
    immediateStartConsentAccepted?: boolean | undefined;
    createdAtUtc?: Date;
    eligibleUntilUtc?: Date;
    eligibilityWindowDaysAtRequest?: number | undefined;
    refundPolicyUrl?: string | undefined;
    processedAtUtc?: Date | undefined;
    adminNotes?: string | undefined;

    constructor(data?: IAdminSubscriptionRefundRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userPublicId = _data["userPublicId"];
            this.contactEmail = _data["contactEmail"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.userSubscriptionId = _data["userSubscriptionId"];
            this.planCode = _data["planCode"];
            this.planName = _data["planName"];
            this.orderId = _data["orderId"];
            this.paymentId = _data["paymentId"];
            this.subscriptionStatusAtRequest = _data["subscriptionStatusAtRequest"];
            this.subscriptionStartedAtUtc = _data["subscriptionStartedAtUtc"] ? new Date(_data["subscriptionStartedAtUtc"].toString()) : undefined as any;
            this.subscriptionEndsAtUtc = _data["subscriptionEndsAtUtc"] ? new Date(_data["subscriptionEndsAtUtc"].toString()) : undefined as any;
            this.paidAtUtc = _data["paidAtUtc"] ? new Date(_data["paidAtUtc"].toString()) : undefined as any;
            this.legalAcceptanceId = _data["legalAcceptanceId"];
            this.legalVersion = _data["legalVersion"];
            this.legalLastUpdated = _data["legalLastUpdated"];
            this.immediateStartConsentRequired = _data["immediateStartConsentRequired"];
            this.immediateStartConsentAccepted = _data["immediateStartConsentAccepted"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.eligibleUntilUtc = _data["eligibleUntilUtc"] ? new Date(_data["eligibleUntilUtc"].toString()) : undefined as any;
            this.eligibilityWindowDaysAtRequest = _data["eligibilityWindowDaysAtRequest"];
            this.refundPolicyUrl = _data["refundPolicyUrl"];
            this.processedAtUtc = _data["processedAtUtc"] ? new Date(_data["processedAtUtc"].toString()) : undefined as any;
            this.adminNotes = _data["adminNotes"];
        }
    }

    static fromJS(data: any): AdminSubscriptionRefundRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSubscriptionRefundRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userPublicId"] = this.userPublicId;
        data["contactEmail"] = this.contactEmail;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["userSubscriptionId"] = this.userSubscriptionId;
        data["planCode"] = this.planCode;
        data["planName"] = this.planName;
        data["orderId"] = this.orderId;
        data["paymentId"] = this.paymentId;
        data["subscriptionStatusAtRequest"] = this.subscriptionStatusAtRequest;
        data["subscriptionStartedAtUtc"] = this.subscriptionStartedAtUtc ? this.subscriptionStartedAtUtc.toISOString() : undefined as any;
        data["subscriptionEndsAtUtc"] = this.subscriptionEndsAtUtc ? this.subscriptionEndsAtUtc.toISOString() : undefined as any;
        data["paidAtUtc"] = this.paidAtUtc ? this.paidAtUtc.toISOString() : undefined as any;
        data["legalAcceptanceId"] = this.legalAcceptanceId;
        data["legalVersion"] = this.legalVersion;
        data["legalLastUpdated"] = this.legalLastUpdated;
        data["immediateStartConsentRequired"] = this.immediateStartConsentRequired;
        data["immediateStartConsentAccepted"] = this.immediateStartConsentAccepted;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["eligibleUntilUtc"] = this.eligibleUntilUtc ? this.eligibleUntilUtc.toISOString() : undefined as any;
        data["eligibilityWindowDaysAtRequest"] = this.eligibilityWindowDaysAtRequest;
        data["refundPolicyUrl"] = this.refundPolicyUrl;
        data["processedAtUtc"] = this.processedAtUtc ? this.processedAtUtc.toISOString() : undefined as any;
        data["adminNotes"] = this.adminNotes;
        return data;
    }
}

export interface IAdminSubscriptionRefundRequestDto {
    id?: string;
    userId?: string;
    userName?: string | undefined;
    userPublicId?: string | undefined;
    contactEmail?: string | undefined;
    reason?: string | undefined;
    status?: SubscriptionRefundRequestStatus;
    userSubscriptionId?: string;
    planCode?: string | undefined;
    planName?: string | undefined;
    orderId?: string | undefined;
    paymentId?: string | undefined;
    subscriptionStatusAtRequest?: UserSubscriptionStatus;
    subscriptionStartedAtUtc?: Date | undefined;
    subscriptionEndsAtUtc?: Date | undefined;
    paidAtUtc?: Date | undefined;
    legalAcceptanceId?: string | undefined;
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    immediateStartConsentRequired?: boolean | undefined;
    immediateStartConsentAccepted?: boolean | undefined;
    createdAtUtc?: Date;
    eligibleUntilUtc?: Date;
    eligibilityWindowDaysAtRequest?: number | undefined;
    refundPolicyUrl?: string | undefined;
    processedAtUtc?: Date | undefined;
    adminNotes?: string | undefined;
}

export class AdminSubscriptionRefundRequestDtoPagedResultDto implements IAdminSubscriptionRefundRequestDtoPagedResultDto {
    items!: AdminSubscriptionRefundRequestDto[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;

    constructor(data?: IAdminSubscriptionRefundRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdminSubscriptionRefundRequestDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdminSubscriptionRefundRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSubscriptionRefundRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IAdminSubscriptionRefundRequestDtoPagedResultDto {
    items: AdminSubscriptionRefundRequestDto[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
}

export class AdminUpdateSubscriptionDto implements IAdminUpdateSubscriptionDto {
    userId?: string;
    planCode?: string | undefined;

    constructor(data?: IAdminUpdateSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.planCode = _data["planCode"];
        }
    }

    static fromJS(data: any): AdminUpdateSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpdateSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["planCode"] = this.planCode;
        return data;
    }
}

export interface IAdminUpdateSubscriptionDto {
    userId?: string;
    planCode?: string | undefined;
}

export class AdminUpdateSubscriptionRefundRequestDto implements IAdminUpdateSubscriptionRefundRequestDto {
    status?: SubscriptionRefundRequestStatus;
    adminNotes?: string | undefined;

    constructor(data?: IAdminUpdateSubscriptionRefundRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.adminNotes = _data["adminNotes"];
        }
    }

    static fromJS(data: any): AdminUpdateSubscriptionRefundRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpdateSubscriptionRefundRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["adminNotes"] = this.adminNotes;
        return data;
    }
}

export interface IAdminUpdateSubscriptionRefundRequestDto {
    status?: SubscriptionRefundRequestStatus;
    adminNotes?: string | undefined;
}

export class AdminUserListItemDto implements IAdminUserListItemDto {
    id?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.AdminUserListItemDto.BirthLocalDate and AstroAI.Api.Dtos.AdminUserListItemDto.BirthLocalTime to show it. */
    birthDateTime?: Date | undefined;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    birthPlace?: string | undefined;
    birthLatitude?: number | undefined;
    birthLongitude?: number | undefined;
    role?: UserRole;
    status?: UserStatus;
    includedCredits?: number | undefined;
    usedCredits?: number | undefined;
    remainingCredits?: number | undefined;
    creditCycleEndsAtUtc?: Date | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IAdminUserListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthLocalDate = _data["birthLocalDate"];
            this.birthLocalTime = _data["birthLocalTime"];
            this.birthPlace = _data["birthPlace"];
            this.birthLatitude = _data["birthLatitude"];
            this.birthLongitude = _data["birthLongitude"];
            this.role = _data["role"];
            this.status = _data["status"];
            this.includedCredits = _data["includedCredits"];
            this.usedCredits = _data["usedCredits"];
            this.remainingCredits = _data["remainingCredits"];
            this.creditCycleEndsAtUtc = _data["creditCycleEndsAtUtc"] ? new Date(_data["creditCycleEndsAtUtc"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminUserListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthLocalDate"] = this.birthLocalDate;
        data["birthLocalTime"] = this.birthLocalTime;
        data["birthPlace"] = this.birthPlace;
        data["birthLatitude"] = this.birthLatitude;
        data["birthLongitude"] = this.birthLongitude;
        data["role"] = this.role;
        data["status"] = this.status;
        data["includedCredits"] = this.includedCredits;
        data["usedCredits"] = this.usedCredits;
        data["remainingCredits"] = this.remainingCredits;
        data["creditCycleEndsAtUtc"] = this.creditCycleEndsAtUtc ? this.creditCycleEndsAtUtc.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminUserListItemDto {
    id?: string | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.AdminUserListItemDto.BirthLocalDate and AstroAI.Api.Dtos.AdminUserListItemDto.BirthLocalTime to show it. */
    birthDateTime?: Date | undefined;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    birthPlace?: string | undefined;
    birthLatitude?: number | undefined;
    birthLongitude?: number | undefined;
    role?: UserRole;
    status?: UserStatus;
    includedCredits?: number | undefined;
    usedCredits?: number | undefined;
    remainingCredits?: number | undefined;
    creditCycleEndsAtUtc?: Date | undefined;
    createdAt?: Date | undefined;
}

export class AdminUserUpdateDto implements IAdminUserUpdateDto {
    authId?: string | undefined;
    name?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    bio?: string | undefined;
    isPrivate?: boolean;

    constructor(data?: IAdminUserUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.birthLatitude = _data["birthLatitude"];
            this.birthLongitude = _data["birthLongitude"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.bio = _data["bio"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): AdminUserUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["birthLatitude"] = this.birthLatitude;
        data["birthLongitude"] = this.birthLongitude;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        data["bio"] = this.bio;
        data["isPrivate"] = this.isPrivate;
        return data;
    }
}

export interface IAdminUserUpdateDto {
    authId?: string | undefined;
    name?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    bio?: string | undefined;
    isPrivate?: boolean;
}

export enum AiReadingJobStatus {
    Pending = "Pending",
    Queued = "Queued",
    Submitted = "Submitted",
    Completed = "Completed",
    Failed = "Failed",
    Canceled = "Canceled",
}

export class AspectForecast implements IAspectForecast {
    transit?: Planets;
    natal?: Planets;
    aspect?: Aspects;
    applying?: boolean;
    strength?: number;
    polarity?: number;
    contribution?: number;
    forecast?: string | undefined;

    constructor(data?: IAspectForecast) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transit = _data["transit"];
            this.natal = _data["natal"];
            this.aspect = _data["aspect"];
            this.applying = _data["applying"];
            this.strength = _data["strength"];
            this.polarity = _data["polarity"];
            this.contribution = _data["contribution"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): AspectForecast {
        data = typeof data === 'object' ? data : {};
        let result = new AspectForecast();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transit"] = this.transit;
        data["natal"] = this.natal;
        data["aspect"] = this.aspect;
        data["applying"] = this.applying;
        data["strength"] = this.strength;
        data["polarity"] = this.polarity;
        data["contribution"] = this.contribution;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IAspectForecast {
    transit?: Planets;
    natal?: Planets;
    aspect?: Aspects;
    applying?: boolean;
    strength?: number;
    polarity?: number;
    contribution?: number;
    forecast?: string | undefined;
}

export class AspectInfo implements IAspectInfo {
    id?: number;
    planet1?: Planets;
    planet2?: Planets;
    aspect?: Aspects;
    orb?: number;
    angle?: number;
    applying?: boolean;
    strength?: number;
    forecast?: string | undefined;

    constructor(data?: IAspectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planet1 = _data["planet1"];
            this.planet2 = _data["planet2"];
            this.aspect = _data["aspect"];
            this.orb = _data["orb"];
            this.angle = _data["angle"];
            this.applying = _data["applying"];
            this.strength = _data["strength"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): AspectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AspectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planet1"] = this.planet1;
        data["planet2"] = this.planet2;
        data["aspect"] = this.aspect;
        data["orb"] = this.orb;
        data["angle"] = this.angle;
        data["applying"] = this.applying;
        data["strength"] = this.strength;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IAspectInfo {
    id?: number;
    planet1?: Planets;
    planet2?: Planets;
    aspect?: Aspects;
    orb?: number;
    angle?: number;
    applying?: boolean;
    strength?: number;
    forecast?: string | undefined;
}

export class AspectInfoDto implements IAspectInfoDto {
    id?: number;
    planet1?: Planets;
    planet2?: Planets;
    aspect?: Aspects;
    orb?: number;
    angle?: number;
    applying?: boolean;
    strength?: number;
    forecast?: string | undefined;

    constructor(data?: IAspectInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planet1 = _data["planet1"];
            this.planet2 = _data["planet2"];
            this.aspect = _data["aspect"];
            this.orb = _data["orb"];
            this.angle = _data["angle"];
            this.applying = _data["applying"];
            this.strength = _data["strength"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): AspectInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new AspectInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planet1"] = this.planet1;
        data["planet2"] = this.planet2;
        data["aspect"] = this.aspect;
        data["orb"] = this.orb;
        data["angle"] = this.angle;
        data["applying"] = this.applying;
        data["strength"] = this.strength;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IAspectInfoDto {
    id?: number;
    planet1?: Planets;
    planet2?: Planets;
    aspect?: Aspects;
    orb?: number;
    angle?: number;
    applying?: boolean;
    strength?: number;
    forecast?: string | undefined;
}

export enum Aspects {
    Conjunction = "Conjunction",
    Opposition = "Opposition",
    Square = "Square",
    Sextile = "Sextile",
    Trine = "Trine",
    SemiSextile = "SemiSextile",
    Quincunx = "Quincunx",
    Quintile = "Quintile",
    None = "None",
}

export class Asset implements IAsset {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    type?: string | undefined;
    natalChart?: NatalChartResult;
    ticker?: string | undefined;
    name?: string | undefined;
    assetType?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    active?: boolean;
    currencyName?: string | undefined;
    cik?: string | undefined;
    compositeFigi?: string | undefined;
    shareClassFigi?: string | undefined;
    marketCap?: number | undefined;
    phoneNumber?: string | undefined;
    address1?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    sicCode?: string | undefined;
    tickerRoot?: string | undefined;
    homepageUrl?: string | undefined;
    totalEmployees?: number | undefined;
    listDate?: Date | undefined;
    brandingLogoBase64?: string | undefined;
    brandingLogoMediaType?: string | undefined;
    brandingIconBase64?: string | undefined;
    brandingIconMediaType?: string | undefined;
    shareClassSharesOutstanding?: number | undefined;
    weightedSharesOutstanding?: number | undefined;
    roundLot?: number | undefined;
    translations?: AssetTranslation[] | undefined;
    favoritedByUsers?: UserFavoriteAsset[] | undefined;

    constructor(data?: IAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.type = _data["type"];
            this.natalChart = _data["natalChart"] ? NatalChartResult.fromJS(_data["natalChart"]) : undefined as any;
            this.ticker = _data["ticker"];
            this.name = _data["name"];
            this.assetType = _data["assetType"];
            this.market = _data["market"];
            this.locale = _data["locale"];
            this.primaryExchange = _data["primaryExchange"];
            this.active = _data["active"];
            this.currencyName = _data["currencyName"];
            this.cik = _data["cik"];
            this.compositeFigi = _data["compositeFigi"];
            this.shareClassFigi = _data["shareClassFigi"];
            this.marketCap = _data["marketCap"];
            this.phoneNumber = _data["phoneNumber"];
            this.address1 = _data["address1"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.sicCode = _data["sicCode"];
            this.tickerRoot = _data["tickerRoot"];
            this.homepageUrl = _data["homepageUrl"];
            this.totalEmployees = _data["totalEmployees"];
            this.listDate = _data["listDate"] ? new Date(_data["listDate"].toString()) : undefined as any;
            this.brandingLogoBase64 = _data["brandingLogoBase64"];
            this.brandingLogoMediaType = _data["brandingLogoMediaType"];
            this.brandingIconBase64 = _data["brandingIconBase64"];
            this.brandingIconMediaType = _data["brandingIconMediaType"];
            this.shareClassSharesOutstanding = _data["shareClassSharesOutstanding"];
            this.weightedSharesOutstanding = _data["weightedSharesOutstanding"];
            this.roundLot = _data["roundLot"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(AssetTranslation.fromJS(item));
            }
            if (Array.isArray(_data["favoritedByUsers"])) {
                this.favoritedByUsers = [] as any;
                for (let item of _data["favoritedByUsers"])
                    this.favoritedByUsers!.push(UserFavoriteAsset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Asset {
        data = typeof data === 'object' ? data : {};
        let result = new Asset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["type"] = this.type;
        data["natalChart"] = this.natalChart ? this.natalChart.toJSON() : undefined as any;
        data["ticker"] = this.ticker;
        data["name"] = this.name;
        data["assetType"] = this.assetType;
        data["market"] = this.market;
        data["locale"] = this.locale;
        data["primaryExchange"] = this.primaryExchange;
        data["active"] = this.active;
        data["currencyName"] = this.currencyName;
        data["cik"] = this.cik;
        data["compositeFigi"] = this.compositeFigi;
        data["shareClassFigi"] = this.shareClassFigi;
        data["marketCap"] = this.marketCap;
        data["phoneNumber"] = this.phoneNumber;
        data["address1"] = this.address1;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["sicCode"] = this.sicCode;
        data["tickerRoot"] = this.tickerRoot;
        data["homepageUrl"] = this.homepageUrl;
        data["totalEmployees"] = this.totalEmployees;
        data["listDate"] = this.listDate ? this.listDate.toISOString() : undefined as any;
        data["brandingLogoBase64"] = this.brandingLogoBase64;
        data["brandingLogoMediaType"] = this.brandingLogoMediaType;
        data["brandingIconBase64"] = this.brandingIconBase64;
        data["brandingIconMediaType"] = this.brandingIconMediaType;
        data["shareClassSharesOutstanding"] = this.shareClassSharesOutstanding;
        data["weightedSharesOutstanding"] = this.weightedSharesOutstanding;
        data["roundLot"] = this.roundLot;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.favoritedByUsers)) {
            data["favoritedByUsers"] = [];
            for (let item of this.favoritedByUsers)
                data["favoritedByUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAsset {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    type?: string | undefined;
    natalChart?: NatalChartResult;
    ticker?: string | undefined;
    name?: string | undefined;
    assetType?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    active?: boolean;
    currencyName?: string | undefined;
    cik?: string | undefined;
    compositeFigi?: string | undefined;
    shareClassFigi?: string | undefined;
    marketCap?: number | undefined;
    phoneNumber?: string | undefined;
    address1?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
    sicCode?: string | undefined;
    tickerRoot?: string | undefined;
    homepageUrl?: string | undefined;
    totalEmployees?: number | undefined;
    listDate?: Date | undefined;
    brandingLogoBase64?: string | undefined;
    brandingLogoMediaType?: string | undefined;
    brandingIconBase64?: string | undefined;
    brandingIconMediaType?: string | undefined;
    shareClassSharesOutstanding?: number | undefined;
    weightedSharesOutstanding?: number | undefined;
    roundLot?: number | undefined;
    translations?: AssetTranslation[] | undefined;
    favoritedByUsers?: UserFavoriteAsset[] | undefined;
}

export class AssetDetailDto implements IAssetDetailDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    currencyName?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    type?: string | undefined;
    active?: boolean;
    isFavorite?: boolean;
    listDate?: Date | undefined;
    natalChart?: NatalChartResultDto;
    translations?: AssetTranslationDto[] | undefined;

    constructor(data?: IAssetDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticker = _data["ticker"];
            this.name = _data["name"];
            this.market = _data["market"];
            this.locale = _data["locale"];
            this.primaryExchange = _data["primaryExchange"];
            this.currencyName = _data["currencyName"];
            this.logoBase64 = _data["logoBase64"];
            this.logoMediaType = _data["logoMediaType"];
            this.type = _data["type"];
            this.active = _data["active"];
            this.isFavorite = _data["isFavorite"];
            this.listDate = _data["listDate"] ? new Date(_data["listDate"].toString()) : undefined as any;
            this.natalChart = _data["natalChart"] ? NatalChartResultDto.fromJS(_data["natalChart"]) : undefined as any;
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(AssetTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticker"] = this.ticker;
        data["name"] = this.name;
        data["market"] = this.market;
        data["locale"] = this.locale;
        data["primaryExchange"] = this.primaryExchange;
        data["currencyName"] = this.currencyName;
        data["logoBase64"] = this.logoBase64;
        data["logoMediaType"] = this.logoMediaType;
        data["type"] = this.type;
        data["active"] = this.active;
        data["isFavorite"] = this.isFavorite;
        data["listDate"] = this.listDate ? this.listDate.toISOString() : undefined as any;
        data["natalChart"] = this.natalChart ? this.natalChart.toJSON() : undefined as any;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetDetailDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    currencyName?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    type?: string | undefined;
    active?: boolean;
    isFavorite?: boolean;
    listDate?: Date | undefined;
    natalChart?: NatalChartResultDto;
    translations?: AssetTranslationDto[] | undefined;
}

export class AssetListDto implements IAssetListDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    market?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    locale?: string | undefined;
    active?: boolean;
    score?: number;

    constructor(data?: IAssetListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticker = _data["ticker"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.market = _data["market"];
            this.logoBase64 = _data["logoBase64"];
            this.logoMediaType = _data["logoMediaType"];
            this.locale = _data["locale"];
            this.active = _data["active"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): AssetListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticker"] = this.ticker;
        data["name"] = this.name;
        data["type"] = this.type;
        data["market"] = this.market;
        data["logoBase64"] = this.logoBase64;
        data["logoMediaType"] = this.logoMediaType;
        data["locale"] = this.locale;
        data["active"] = this.active;
        data["score"] = this.score;
        return data;
    }
}

export interface IAssetListDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    market?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    locale?: string | undefined;
    active?: boolean;
    score?: number;
}

export class AssetModelTrainingMetricsDto implements IAssetModelTrainingMetricsDto {
    accuracy?: number | undefined;
    areaUnderRocCurve?: number | undefined;
    f1Score?: number | undefined;
    lossFunction?: number | undefined;
    meanAbsoluteError?: number | undefined;
    meanSquaredError?: number | undefined;
    rootMeanSquaredError?: number | undefined;
    rSquared?: number | undefined;

    constructor(data?: IAssetModelTrainingMetricsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accuracy = _data["accuracy"];
            this.areaUnderRocCurve = _data["areaUnderRocCurve"];
            this.f1Score = _data["f1Score"];
            this.lossFunction = _data["lossFunction"];
            this.meanAbsoluteError = _data["meanAbsoluteError"];
            this.meanSquaredError = _data["meanSquaredError"];
            this.rootMeanSquaredError = _data["rootMeanSquaredError"];
            this.rSquared = _data["rSquared"];
        }
    }

    static fromJS(data: any): AssetModelTrainingMetricsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetModelTrainingMetricsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accuracy"] = this.accuracy;
        data["areaUnderRocCurve"] = this.areaUnderRocCurve;
        data["f1Score"] = this.f1Score;
        data["lossFunction"] = this.lossFunction;
        data["meanAbsoluteError"] = this.meanAbsoluteError;
        data["meanSquaredError"] = this.meanSquaredError;
        data["rootMeanSquaredError"] = this.rootMeanSquaredError;
        data["rSquared"] = this.rSquared;
        return data;
    }
}

export interface IAssetModelTrainingMetricsDto {
    accuracy?: number | undefined;
    areaUnderRocCurve?: number | undefined;
    f1Score?: number | undefined;
    lossFunction?: number | undefined;
    meanAbsoluteError?: number | undefined;
    meanSquaredError?: number | undefined;
    rootMeanSquaredError?: number | undefined;
    rSquared?: number | undefined;
}

export class AssetModelTrainingResponseDto implements IAssetModelTrainingResponseDto {
    modelPath?: string | undefined;
    metadataPath?: string | undefined;
    featureCount?: number;
    trainingExamples?: number;
    testingExamples?: number;
    metrics?: AssetModelTrainingMetricsDto;
    featureKeys?: string[] | undefined;

    constructor(data?: IAssetModelTrainingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelPath = _data["modelPath"];
            this.metadataPath = _data["metadataPath"];
            this.featureCount = _data["featureCount"];
            this.trainingExamples = _data["trainingExamples"];
            this.testingExamples = _data["testingExamples"];
            this.metrics = _data["metrics"] ? AssetModelTrainingMetricsDto.fromJS(_data["metrics"]) : undefined as any;
            if (Array.isArray(_data["featureKeys"])) {
                this.featureKeys = [] as any;
                for (let item of _data["featureKeys"])
                    this.featureKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetModelTrainingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetModelTrainingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelPath"] = this.modelPath;
        data["metadataPath"] = this.metadataPath;
        data["featureCount"] = this.featureCount;
        data["trainingExamples"] = this.trainingExamples;
        data["testingExamples"] = this.testingExamples;
        data["metrics"] = this.metrics ? this.metrics.toJSON() : undefined as any;
        if (Array.isArray(this.featureKeys)) {
            data["featureKeys"] = [];
            for (let item of this.featureKeys)
                data["featureKeys"].push(item);
        }
        return data;
    }
}

export interface IAssetModelTrainingResponseDto {
    modelPath?: string | undefined;
    metadataPath?: string | undefined;
    featureCount?: number;
    trainingExamples?: number;
    testingExamples?: number;
    metrics?: AssetModelTrainingMetricsDto;
    featureKeys?: string[] | undefined;
}

export class AssetTransitScoreDto implements IAssetTransitScoreDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    locale?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    type?: string | undefined;

    constructor(data?: IAssetTransitScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ticker = _data["ticker"];
            this.name = _data["name"];
            this.logoBase64 = _data["logoBase64"];
            this.logoMediaType = _data["logoMediaType"];
            this.locale = _data["locale"];
            this.percentAbsolute = _data["percentAbsolute"];
            this.percentRelative = _data["percentRelative"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AssetTransitScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTransitScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ticker"] = this.ticker;
        data["name"] = this.name;
        data["logoBase64"] = this.logoBase64;
        data["logoMediaType"] = this.logoMediaType;
        data["locale"] = this.locale;
        data["percentAbsolute"] = this.percentAbsolute;
        data["percentRelative"] = this.percentRelative;
        data["type"] = this.type;
        return data;
    }
}

export interface IAssetTransitScoreDto {
    id?: string;
    ticker?: string | undefined;
    name?: string | undefined;
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    locale?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    type?: string | undefined;
}

export class AssetTransitScoreSummaryDto implements IAssetTransitScoreSummaryDto {
    date?: Date;
    profileKey?: string | undefined;
    topPositive?: AssetTransitScoreDto[] | undefined;
    topNegative?: AssetTransitScoreDto[] | undefined;

    constructor(data?: IAssetTransitScoreSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.profileKey = _data["profileKey"];
            if (Array.isArray(_data["topPositive"])) {
                this.topPositive = [] as any;
                for (let item of _data["topPositive"])
                    this.topPositive!.push(AssetTransitScoreDto.fromJS(item));
            }
            if (Array.isArray(_data["topNegative"])) {
                this.topNegative = [] as any;
                for (let item of _data["topNegative"])
                    this.topNegative!.push(AssetTransitScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetTransitScoreSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTransitScoreSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["profileKey"] = this.profileKey;
        if (Array.isArray(this.topPositive)) {
            data["topPositive"] = [];
            for (let item of this.topPositive)
                data["topPositive"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.topNegative)) {
            data["topNegative"] = [];
            for (let item of this.topNegative)
                data["topNegative"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssetTransitScoreSummaryDto {
    date?: Date;
    profileKey?: string | undefined;
    topPositive?: AssetTransitScoreDto[] | undefined;
    topNegative?: AssetTransitScoreDto[] | undefined;
}

export class AssetTranslation implements IAssetTranslation {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    assetId?: string;
    asset?: Asset;
    locale?: string | undefined;
    description?: string | undefined;
    sicDescription?: string | undefined;

    constructor(data?: IAssetTranslation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
            this.locale = _data["locale"];
            this.description = _data["description"];
            this.sicDescription = _data["sicDescription"];
        }
    }

    static fromJS(data: any): AssetTranslation {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTranslation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["locale"] = this.locale;
        data["description"] = this.description;
        data["sicDescription"] = this.sicDescription;
        return data;
    }
}

export interface IAssetTranslation {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    assetId?: string;
    asset?: Asset;
    locale?: string | undefined;
    description?: string | undefined;
    sicDescription?: string | undefined;
}

export class AssetTranslationDto implements IAssetTranslationDto {
    locale?: string | undefined;
    description?: string | undefined;
    sicDescription?: string | undefined;

    constructor(data?: IAssetTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locale = _data["locale"];
            this.description = _data["description"];
            this.sicDescription = _data["sicDescription"];
        }
    }

    static fromJS(data: any): AssetTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locale"] = this.locale;
        data["description"] = this.description;
        data["sicDescription"] = this.sicDescription;
        return data;
    }
}

export interface IAssetTranslationDto {
    locale?: string | undefined;
    description?: string | undefined;
    sicDescription?: string | undefined;
}

export class BanRequestDto implements IBanRequestDto {
    days?: number;

    constructor(data?: IBanRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
        }
    }

    static fromJS(data: any): BanRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BanRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        return data;
    }
}

export interface IBanRequestDto {
    days?: number;
}

export class BreathingPatternDto implements IBreathingPatternDto {
    inhaleSeconds?: number | undefined;
    holdSeconds?: number | undefined;
    exhaleSeconds?: number | undefined;
    holdOutSeconds?: number | undefined;
    cycles?: number | undefined;

    constructor(data?: IBreathingPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inhaleSeconds = _data["inhaleSeconds"];
            this.holdSeconds = _data["holdSeconds"];
            this.exhaleSeconds = _data["exhaleSeconds"];
            this.holdOutSeconds = _data["holdOutSeconds"];
            this.cycles = _data["cycles"];
        }
    }

    static fromJS(data: any): BreathingPatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new BreathingPatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inhaleSeconds"] = this.inhaleSeconds;
        data["holdSeconds"] = this.holdSeconds;
        data["exhaleSeconds"] = this.exhaleSeconds;
        data["holdOutSeconds"] = this.holdOutSeconds;
        data["cycles"] = this.cycles;
        return data;
    }
}

export interface IBreathingPatternDto {
    inhaleSeconds?: number | undefined;
    holdSeconds?: number | undefined;
    exhaleSeconds?: number | undefined;
    holdOutSeconds?: number | undefined;
    cycles?: number | undefined;
}

export class CancelPaymentRequest implements ICancelPaymentRequest {
    paymentId?: string;
    reason?: string | undefined;

    constructor(data?: ICancelPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CancelPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICancelPaymentRequest {
    paymentId?: string;
    reason?: string | undefined;
}

export class CancelPaymentResponse implements ICancelPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;

    constructor(data?: ICancelPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.status = _data["status"];
            this.error = _data["error"] ? PaymentError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): CancelPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface ICancelPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;
}

export class ChatCompanionRequestDto implements IChatCompanionRequestDto {
    natalChartId!: string;

    constructor(data?: IChatCompanionRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.natalChartId = _data["natalChartId"];
        }
    }

    static fromJS(data: any): ChatCompanionRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatCompanionRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["natalChartId"] = this.natalChartId;
        return data;
    }
}

export interface IChatCompanionRequestDto {
    natalChartId: string;
}

export class ChatCompanionResponseDto implements IChatCompanionResponseDto {
    natalChartId?: string;
    name?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.ChatCompanionResponseDto.BirthLocalDate and AstroAI.Api.Dtos.ChatCompanionResponseDto.BirthLocalTime to show it. */
    birthDateTime?: Date;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    timeZone?: string | undefined;

    constructor(data?: IChatCompanionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.natalChartId = _data["natalChartId"];
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthLocalDate = _data["birthLocalDate"];
            this.birthLocalTime = _data["birthLocalTime"];
            this.timeZone = _data["timeZone"];
        }
    }

    static fromJS(data: any): ChatCompanionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatCompanionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["natalChartId"] = this.natalChartId;
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthLocalDate"] = this.birthLocalDate;
        data["birthLocalTime"] = this.birthLocalTime;
        data["timeZone"] = this.timeZone;
        return data;
    }
}

export interface IChatCompanionResponseDto {
    natalChartId?: string;
    name?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.ChatCompanionResponseDto.BirthLocalDate and AstroAI.Api.Dtos.ChatCompanionResponseDto.BirthLocalTime to show it. */
    birthDateTime?: Date;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    timeZone?: string | undefined;
}

export class ChatRequestDto implements IChatRequestDto {
    question!: string;
    companionChartId?: string | undefined;

    constructor(data?: IChatRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.companionChartId = _data["companionChartId"];
        }
    }

    static fromJS(data: any): ChatRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["companionChartId"] = this.companionChartId;
        return data;
    }
}

export interface IChatRequestDto {
    question: string;
    companionChartId?: string | undefined;
}

export class ChatResponseDto implements IChatResponseDto {
    answer?: string | undefined;
    activeCompanion?: ChatCompanionResponseDto;
    disclaimer?: string | undefined;

    constructor(data?: IChatResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.activeCompanion = _data["activeCompanion"] ? ChatCompanionResponseDto.fromJS(_data["activeCompanion"]) : undefined as any;
            this.disclaimer = _data["disclaimer"];
        }
    }

    static fromJS(data: any): ChatResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["activeCompanion"] = this.activeCompanion ? this.activeCompanion.toJSON() : undefined as any;
        data["disclaimer"] = this.disclaimer;
        return data;
    }
}

export interface IChatResponseDto {
    answer?: string | undefined;
    activeCompanion?: ChatCompanionResponseDto;
    disclaimer?: string | undefined;
}

export class CompatibilityLiteReportDto implements ICompatibilityLiteReportDto {
    finalScore?: number;
    sectionScores?: { [key: string]: number; } | undefined;
    significantAspects?: string[] | undefined;
    activatedHouses?: string[] | undefined;

    constructor(data?: ICompatibilityLiteReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalScore = _data["finalScore"];
            if (_data["sectionScores"]) {
                this.sectionScores = {} as any;
                for (let key in _data["sectionScores"]) {
                    if (_data["sectionScores"].hasOwnProperty(key))
                        (this.sectionScores as any)![key] = _data["sectionScores"][key];
                }
            }
            if (Array.isArray(_data["significantAspects"])) {
                this.significantAspects = [] as any;
                for (let item of _data["significantAspects"])
                    this.significantAspects!.push(item);
            }
            if (Array.isArray(_data["activatedHouses"])) {
                this.activatedHouses = [] as any;
                for (let item of _data["activatedHouses"])
                    this.activatedHouses!.push(item);
            }
        }
    }

    static fromJS(data: any): CompatibilityLiteReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompatibilityLiteReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalScore"] = this.finalScore;
        if (this.sectionScores) {
            data["sectionScores"] = {};
            for (let key in this.sectionScores) {
                if (this.sectionScores.hasOwnProperty(key))
                    (data["sectionScores"] as any)[key] = (this.sectionScores as any)[key];
            }
        }
        if (Array.isArray(this.significantAspects)) {
            data["significantAspects"] = [];
            for (let item of this.significantAspects)
                data["significantAspects"].push(item);
        }
        if (Array.isArray(this.activatedHouses)) {
            data["activatedHouses"] = [];
            for (let item of this.activatedHouses)
                data["activatedHouses"].push(item);
        }
        return data;
    }
}

export interface ICompatibilityLiteReportDto {
    finalScore?: number;
    sectionScores?: { [key: string]: number; } | undefined;
    significantAspects?: string[] | undefined;
    activatedHouses?: string[] | undefined;
}

export class CompatibilityReportDto implements ICompatibilityReportDto {
    finalScore?: number;
    sectionScores?: { [key: string]: number; } | undefined;
    significantAspects?: string[] | undefined;
    activatedHouses?: string[] | undefined;
    summaryText?: string | undefined;

    constructor(data?: ICompatibilityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalScore = _data["finalScore"];
            if (_data["sectionScores"]) {
                this.sectionScores = {} as any;
                for (let key in _data["sectionScores"]) {
                    if (_data["sectionScores"].hasOwnProperty(key))
                        (this.sectionScores as any)![key] = _data["sectionScores"][key];
                }
            }
            if (Array.isArray(_data["significantAspects"])) {
                this.significantAspects = [] as any;
                for (let item of _data["significantAspects"])
                    this.significantAspects!.push(item);
            }
            if (Array.isArray(_data["activatedHouses"])) {
                this.activatedHouses = [] as any;
                for (let item of _data["activatedHouses"])
                    this.activatedHouses!.push(item);
            }
            this.summaryText = _data["summaryText"];
        }
    }

    static fromJS(data: any): CompatibilityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompatibilityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalScore"] = this.finalScore;
        if (this.sectionScores) {
            data["sectionScores"] = {};
            for (let key in this.sectionScores) {
                if (this.sectionScores.hasOwnProperty(key))
                    (data["sectionScores"] as any)[key] = (this.sectionScores as any)[key];
            }
        }
        if (Array.isArray(this.significantAspects)) {
            data["significantAspects"] = [];
            for (let item of this.significantAspects)
                data["significantAspects"].push(item);
        }
        if (Array.isArray(this.activatedHouses)) {
            data["activatedHouses"] = [];
            for (let item of this.activatedHouses)
                data["activatedHouses"].push(item);
        }
        data["summaryText"] = this.summaryText;
        return data;
    }
}

export interface ICompatibilityReportDto {
    finalScore?: number;
    sectionScores?: { [key: string]: number; } | undefined;
    significantAspects?: string[] | undefined;
    activatedHouses?: string[] | undefined;
    summaryText?: string | undefined;
}

export class CompatibilityRequestDto implements ICompatibilityRequestDto {
    chartA!: NatalChartResultDto;
    chartB!: NatalChartResultDto;

    constructor(data?: ICompatibilityRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.chartA = new NatalChartResultDto();
            this.chartB = new NatalChartResultDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartA = _data["chartA"] ? NatalChartResultDto.fromJS(_data["chartA"]) : new NatalChartResultDto();
            this.chartB = _data["chartB"] ? NatalChartResultDto.fromJS(_data["chartB"]) : new NatalChartResultDto();
        }
    }

    static fromJS(data: any): CompatibilityRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompatibilityRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartA"] = this.chartA ? this.chartA.toJSON() : undefined as any;
        data["chartB"] = this.chartB ? this.chartB.toJSON() : undefined as any;
        return data;
    }
}

export interface ICompatibilityRequestDto {
    chartA: NatalChartResultDto;
    chartB: NatalChartResultDto;
}

export class CreateAssociatedNatalChartDto implements ICreateAssociatedNatalChartDto {
    name?: string | undefined;
    birthDateTime?: Date;
    birthLatitude?: number;
    birthLongitude?: number;
    treatmentPreference?: UserTreatmentPreference;

    constructor(data?: ICreateAssociatedNatalChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthLatitude = _data["birthLatitude"];
            this.birthLongitude = _data["birthLongitude"];
            this.treatmentPreference = _data["treatmentPreference"];
        }
    }

    static fromJS(data: any): CreateAssociatedNatalChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssociatedNatalChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthLatitude"] = this.birthLatitude;
        data["birthLongitude"] = this.birthLongitude;
        data["treatmentPreference"] = this.treatmentPreference;
        return data;
    }
}

export interface ICreateAssociatedNatalChartDto {
    name?: string | undefined;
    birthDateTime?: Date;
    birthLatitude?: number;
    birthLongitude?: number;
    treatmentPreference?: UserTreatmentPreference;
}

export class CreatePaymentLegalAcceptanceDto implements ICreatePaymentLegalAcceptanceDto {
    legalVersion?: string | undefined;
    termsAndConditionsUrl?: string | undefined;
    purchaseConditionsUrl?: string | undefined;
    privacyPolicyUrl?: string | undefined;
    disputeResolutionUrl?: string | undefined;
    termsAndConditionsAccepted?: boolean;
    purchaseConditionsAccepted?: boolean;
    immediateStartConsentAccepted?: boolean;

    constructor(data?: ICreatePaymentLegalAcceptanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalVersion = _data["legalVersion"];
            this.termsAndConditionsUrl = _data["termsAndConditionsUrl"];
            this.purchaseConditionsUrl = _data["purchaseConditionsUrl"];
            this.privacyPolicyUrl = _data["privacyPolicyUrl"];
            this.disputeResolutionUrl = _data["disputeResolutionUrl"];
            this.termsAndConditionsAccepted = _data["termsAndConditionsAccepted"];
            this.purchaseConditionsAccepted = _data["purchaseConditionsAccepted"];
            this.immediateStartConsentAccepted = _data["immediateStartConsentAccepted"];
        }
    }

    static fromJS(data: any): CreatePaymentLegalAcceptanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentLegalAcceptanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalVersion"] = this.legalVersion;
        data["termsAndConditionsUrl"] = this.termsAndConditionsUrl;
        data["purchaseConditionsUrl"] = this.purchaseConditionsUrl;
        data["privacyPolicyUrl"] = this.privacyPolicyUrl;
        data["disputeResolutionUrl"] = this.disputeResolutionUrl;
        data["termsAndConditionsAccepted"] = this.termsAndConditionsAccepted;
        data["purchaseConditionsAccepted"] = this.purchaseConditionsAccepted;
        data["immediateStartConsentAccepted"] = this.immediateStartConsentAccepted;
        return data;
    }
}

export interface ICreatePaymentLegalAcceptanceDto {
    legalVersion?: string | undefined;
    termsAndConditionsUrl?: string | undefined;
    purchaseConditionsUrl?: string | undefined;
    privacyPolicyUrl?: string | undefined;
    disputeResolutionUrl?: string | undefined;
    termsAndConditionsAccepted?: boolean;
    purchaseConditionsAccepted?: boolean;
    immediateStartConsentAccepted?: boolean;
}

export class CreatePaymentRequestDto implements ICreatePaymentRequestDto {
    orderId?: string;
    methodCode!: string | undefined;
    providerCode!: string | undefined;
    returnUrl?: string | undefined;
    cancelUrl?: string | undefined;
    legalAcceptance?: CreatePaymentLegalAcceptanceDto;

    constructor(data?: ICreatePaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.methodCode = _data["methodCode"];
            this.providerCode = _data["providerCode"];
            this.returnUrl = _data["returnUrl"];
            this.cancelUrl = _data["cancelUrl"];
            this.legalAcceptance = _data["legalAcceptance"] ? CreatePaymentLegalAcceptanceDto.fromJS(_data["legalAcceptance"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["methodCode"] = this.methodCode;
        data["providerCode"] = this.providerCode;
        data["returnUrl"] = this.returnUrl;
        data["cancelUrl"] = this.cancelUrl;
        data["legalAcceptance"] = this.legalAcceptance ? this.legalAcceptance.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreatePaymentRequestDto {
    orderId?: string;
    methodCode: string | undefined;
    providerCode: string | undefined;
    returnUrl?: string | undefined;
    cancelUrl?: string | undefined;
    legalAcceptance?: CreatePaymentLegalAcceptanceDto;
}

export class CreatePaymentResponse implements ICreatePaymentResponse {
    orderId?: string;
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;

    constructor(data?: ICreatePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.paymentId = _data["paymentId"];
            this.status = _data["status"];
            this.error = _data["error"] ? PaymentError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreatePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["paymentId"] = this.paymentId;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreatePaymentResponse {
    orderId?: string;
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;
}

export class CreateSubscriptionRefundRequestDto implements ICreateSubscriptionRefundRequestDto {
    contactEmail?: string | undefined;
    reason?: string | undefined;

    constructor(data?: ICreateSubscriptionRefundRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactEmail = _data["contactEmail"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreateSubscriptionRefundRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionRefundRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactEmail"] = this.contactEmail;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICreateSubscriptionRefundRequestDto {
    contactEmail?: string | undefined;
    reason?: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    authId?: string | undefined;
    name?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    bio?: string | undefined;
    isPrivate?: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.birthLatitude = _data["birthLatitude"];
            this.birthLongitude = _data["birthLongitude"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.bio = _data["bio"];
            this.isPrivate = _data["isPrivate"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["birthLatitude"] = this.birthLatitude;
        data["birthLongitude"] = this.birthLongitude;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        data["bio"] = this.bio;
        data["isPrivate"] = this.isPrivate;
        return data;
    }
}

export interface ICreateUserDto {
    authId?: string | undefined;
    name?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    bio?: string | undefined;
    isPrivate?: boolean;
}

export class CreditBalanceDto implements ICreditBalanceDto {
    includedCredits?: number;
    usedCredits?: number;
    remainingCredits?: number;
    cycleStartsAtUtc?: Date | undefined;
    cycleEndsAtUtc?: Date | undefined;

    constructor(data?: ICreditBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.includedCredits = _data["includedCredits"];
            this.usedCredits = _data["usedCredits"];
            this.remainingCredits = _data["remainingCredits"];
            this.cycleStartsAtUtc = _data["cycleStartsAtUtc"] ? new Date(_data["cycleStartsAtUtc"].toString()) : undefined as any;
            this.cycleEndsAtUtc = _data["cycleEndsAtUtc"] ? new Date(_data["cycleEndsAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreditBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["includedCredits"] = this.includedCredits;
        data["usedCredits"] = this.usedCredits;
        data["remainingCredits"] = this.remainingCredits;
        data["cycleStartsAtUtc"] = this.cycleStartsAtUtc ? this.cycleStartsAtUtc.toISOString() : undefined as any;
        data["cycleEndsAtUtc"] = this.cycleEndsAtUtc ? this.cycleEndsAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreditBalanceDto {
    includedCredits?: number;
    usedCredits?: number;
    remainingCredits?: number;
    cycleStartsAtUtc?: Date | undefined;
    cycleEndsAtUtc?: Date | undefined;
}

export class CreditCostDto implements ICreditCostDto {
    reason?: UserCreditTransactionReason;
    amount?: number;

    constructor(data?: ICreditCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreditCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ICreditCostDto {
    reason?: UserCreditTransactionReason;
    amount?: number;
}

export class DailyAstroContextDto implements IDailyAstroContextDto {
    date?: Date;
    sunSign?: Zodiac;
    moonSign?: Zodiac;
    venusSign?: Zodiac;
    marsSign?: Zodiac;
    lunarPhase?: LunarPhase;
    retrogradePlanets?: Planets[] | undefined;
    hasNatalChart?: boolean;
    averageProfileScore?: number | undefined;
    profileScores?: DailyAstroProfileScoreDto[] | undefined;

    constructor(data?: IDailyAstroContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.sunSign = _data["sunSign"];
            this.moonSign = _data["moonSign"];
            this.venusSign = _data["venusSign"];
            this.marsSign = _data["marsSign"];
            this.lunarPhase = _data["lunarPhase"];
            if (Array.isArray(_data["retrogradePlanets"])) {
                this.retrogradePlanets = [] as any;
                for (let item of _data["retrogradePlanets"])
                    this.retrogradePlanets!.push(item);
            }
            this.hasNatalChart = _data["hasNatalChart"];
            this.averageProfileScore = _data["averageProfileScore"];
            if (Array.isArray(_data["profileScores"])) {
                this.profileScores = [] as any;
                for (let item of _data["profileScores"])
                    this.profileScores!.push(DailyAstroProfileScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DailyAstroContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAstroContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["sunSign"] = this.sunSign;
        data["moonSign"] = this.moonSign;
        data["venusSign"] = this.venusSign;
        data["marsSign"] = this.marsSign;
        data["lunarPhase"] = this.lunarPhase;
        if (Array.isArray(this.retrogradePlanets)) {
            data["retrogradePlanets"] = [];
            for (let item of this.retrogradePlanets)
                data["retrogradePlanets"].push(item);
        }
        data["hasNatalChart"] = this.hasNatalChart;
        data["averageProfileScore"] = this.averageProfileScore;
        if (Array.isArray(this.profileScores)) {
            data["profileScores"] = [];
            for (let item of this.profileScores)
                data["profileScores"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDailyAstroContextDto {
    date?: Date;
    sunSign?: Zodiac;
    moonSign?: Zodiac;
    venusSign?: Zodiac;
    marsSign?: Zodiac;
    lunarPhase?: LunarPhase;
    retrogradePlanets?: Planets[] | undefined;
    hasNatalChart?: boolean;
    averageProfileScore?: number | undefined;
    profileScores?: DailyAstroProfileScoreDto[] | undefined;
}

export class DailyAstroProfileScoreDto implements IDailyAstroProfileScoreDto {
    profileKey?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    aspectCount?: number;

    constructor(data?: IDailyAstroProfileScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileKey = _data["profileKey"];
            this.percentAbsolute = _data["percentAbsolute"];
            this.percentRelative = _data["percentRelative"];
            this.aspectCount = _data["aspectCount"];
        }
    }

    static fromJS(data: any): DailyAstroProfileScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyAstroProfileScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileKey"] = this.profileKey;
        data["percentAbsolute"] = this.percentAbsolute;
        data["percentRelative"] = this.percentRelative;
        data["aspectCount"] = this.aspectCount;
        return data;
    }
}

export interface IDailyAstroProfileScoreDto {
    profileKey?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    aspectCount?: number;
}

export class DailyMeditationDto implements IDailyMeditationDto {
    title?: string | undefined;
    subtitle?: string | undefined;
    preparation?: MeditationPhaseDto;
    breathing?: MeditationPhaseDto;
    intention?: MeditationPhaseDto;
    closing?: MeditationPhaseDto;
    /** Total session length, derived from the phases that declare a duration.
Null while no phase carries timing information. */
    readonly totalDurationSeconds?: number | undefined;

    constructor(data?: IDailyMeditationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.preparation = _data["preparation"] ? MeditationPhaseDto.fromJS(_data["preparation"]) : undefined as any;
            this.breathing = _data["breathing"] ? MeditationPhaseDto.fromJS(_data["breathing"]) : undefined as any;
            this.intention = _data["intention"] ? MeditationPhaseDto.fromJS(_data["intention"]) : undefined as any;
            this.closing = _data["closing"] ? MeditationPhaseDto.fromJS(_data["closing"]) : undefined as any;
            (this as any).totalDurationSeconds = _data["totalDurationSeconds"];
        }
    }

    static fromJS(data: any): DailyMeditationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyMeditationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : undefined as any;
        data["breathing"] = this.breathing ? this.breathing.toJSON() : undefined as any;
        data["intention"] = this.intention ? this.intention.toJSON() : undefined as any;
        data["closing"] = this.closing ? this.closing.toJSON() : undefined as any;
        data["totalDurationSeconds"] = this.totalDurationSeconds;
        return data;
    }
}

export interface IDailyMeditationDto {
    title?: string | undefined;
    subtitle?: string | undefined;
    preparation?: MeditationPhaseDto;
    breathing?: MeditationPhaseDto;
    intention?: MeditationPhaseDto;
    closing?: MeditationPhaseDto;
    /** Total session length, derived from the phases that declare a duration.
Null while no phase carries timing information. */
    totalDurationSeconds?: number | undefined;
}

export class DailyReportDto implements IDailyReportDto {
    sunSign?: Zodiac;
    moonSign?: Zodiac;
    venusSign?: Zodiac;
    marsSign?: Zodiac;
    lunarPhase?: LunarPhase;
    phaseMessage?: string | undefined;
    message?: string | undefined;
    venusMessage?: string | undefined;
    marsMessage?: string | undefined;
    moonMessage?: string | undefined;
    meditation?: DailyMeditationDto;

    constructor(data?: IDailyReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sunSign = _data["sunSign"];
            this.moonSign = _data["moonSign"];
            this.venusSign = _data["venusSign"];
            this.marsSign = _data["marsSign"];
            this.lunarPhase = _data["lunarPhase"];
            this.phaseMessage = _data["phaseMessage"];
            this.message = _data["message"];
            this.venusMessage = _data["venusMessage"];
            this.marsMessage = _data["marsMessage"];
            this.moonMessage = _data["moonMessage"];
            this.meditation = _data["meditation"] ? DailyMeditationDto.fromJS(_data["meditation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DailyReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sunSign"] = this.sunSign;
        data["moonSign"] = this.moonSign;
        data["venusSign"] = this.venusSign;
        data["marsSign"] = this.marsSign;
        data["lunarPhase"] = this.lunarPhase;
        data["phaseMessage"] = this.phaseMessage;
        data["message"] = this.message;
        data["venusMessage"] = this.venusMessage;
        data["marsMessage"] = this.marsMessage;
        data["moonMessage"] = this.moonMessage;
        data["meditation"] = this.meditation ? this.meditation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDailyReportDto {
    sunSign?: Zodiac;
    moonSign?: Zodiac;
    venusSign?: Zodiac;
    marsSign?: Zodiac;
    lunarPhase?: LunarPhase;
    phaseMessage?: string | undefined;
    message?: string | undefined;
    venusMessage?: string | undefined;
    marsMessage?: string | undefined;
    moonMessage?: string | undefined;
    meditation?: DailyMeditationDto;
}

export class FeatureAccessDto implements IFeatureAccessDto {
    feature?: PlatformFeature;
    requiredTier?: SubscriptionTier;
    isEnabled?: boolean;

    constructor(data?: IFeatureAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feature = _data["feature"];
            this.requiredTier = _data["requiredTier"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): FeatureAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feature"] = this.feature;
        data["requiredTier"] = this.requiredTier;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IFeatureAccessDto {
    feature?: PlatformFeature;
    requiredTier?: SubscriptionTier;
    isEnabled?: boolean;
}

export class GeoLocation implements IGeoLocation {
    latitude?: number;
    longitude?: number;

    constructor(data?: IGeoLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GeoLocation {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IGeoLocation {
    latitude?: number;
    longitude?: number;
}

export class GeoLocationDto implements IGeoLocationDto {
    latitude?: number;
    longitude?: number;

    constructor(data?: IGeoLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): GeoLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeoLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IGeoLocationDto {
    latitude?: number;
    longitude?: number;
}

export class GetNatalReadingResponseDto implements IGetNatalReadingResponseDto {
    reading?: string | undefined;

    constructor(data?: IGetNatalReadingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reading = _data["reading"];
        }
    }

    static fromJS(data: any): GetNatalReadingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetNatalReadingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reading"] = this.reading;
        return data;
    }
}

export interface IGetNatalReadingResponseDto {
    reading?: string | undefined;
}

export class GetPaymentResponse implements IGetPaymentResponse {
    paymentId?: string;
    orderId?: string;
    status?: PaymentStatus;
    amount?: number;
    currency?: string | undefined;
    methodCode?: string | undefined;
    providerCode?: string | undefined;
    providerReference?: string | undefined;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;

    constructor(data?: IGetPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.orderId = _data["orderId"];
            this.status = _data["status"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.methodCode = _data["methodCode"];
            this.providerCode = _data["providerCode"];
            this.providerReference = _data["providerReference"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["methodCode"] = this.methodCode;
        data["providerCode"] = this.providerCode;
        data["providerReference"] = this.providerReference;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetPaymentResponse {
    paymentId?: string;
    orderId?: string;
    status?: PaymentStatus;
    amount?: number;
    currency?: string | undefined;
    methodCode?: string | undefined;
    providerCode?: string | undefined;
    providerReference?: string | undefined;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
}

export class HidePostResponseDto implements IHidePostResponseDto {
    postId?: string;
    reporterId?: string;
    reason?: string | undefined;
    createdAt?: Date;

    constructor(data?: IHidePostResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postId = _data["postId"];
            this.reporterId = _data["reporterId"];
            this.reason = _data["reason"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HidePostResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HidePostResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postId"] = this.postId;
        data["reporterId"] = this.reporterId;
        data["reason"] = this.reason;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IHidePostResponseDto {
    postId?: string;
    reporterId?: string;
    reason?: string | undefined;
    createdAt?: Date;
}

export class HouseInfo implements IHouseInfo {
    id?: number;
    number?: number;
    sign?: Zodiac;
    cuspDegree?: number;
    forecast?: string | undefined;

    constructor(data?: IHouseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.sign = _data["sign"];
            this.cuspDegree = _data["cuspDegree"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): HouseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new HouseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["sign"] = this.sign;
        data["cuspDegree"] = this.cuspDegree;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IHouseInfo {
    id?: number;
    number?: number;
    sign?: Zodiac;
    cuspDegree?: number;
    forecast?: string | undefined;
}

export class HouseInfoDto implements IHouseInfoDto {
    id?: number;
    number?: number;
    sign?: Zodiac;
    cuspDegree?: number;
    forecast?: string | undefined;

    constructor(data?: IHouseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.sign = _data["sign"];
            this.cuspDegree = _data["cuspDegree"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): HouseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new HouseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["sign"] = this.sign;
        data["cuspDegree"] = this.cuspDegree;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IHouseInfoDto {
    id?: number;
    number?: number;
    sign?: Zodiac;
    cuspDegree?: number;
    forecast?: string | undefined;
}

export class InsightsLiteAspectDto implements IInsightsLiteAspectDto {
    transit?: Planets;
    natal?: Planets;
    aspect?: Aspects;
    applying?: boolean;
    strength?: number;
    polarity?: number;
    contribution?: number;

    constructor(data?: IInsightsLiteAspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transit = _data["transit"];
            this.natal = _data["natal"];
            this.aspect = _data["aspect"];
            this.applying = _data["applying"];
            this.strength = _data["strength"];
            this.polarity = _data["polarity"];
            this.contribution = _data["contribution"];
        }
    }

    static fromJS(data: any): InsightsLiteAspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteAspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transit"] = this.transit;
        data["natal"] = this.natal;
        data["aspect"] = this.aspect;
        data["applying"] = this.applying;
        data["strength"] = this.strength;
        data["polarity"] = this.polarity;
        data["contribution"] = this.contribution;
        return data;
    }
}

export interface IInsightsLiteAspectDto {
    transit?: Planets;
    natal?: Planets;
    aspect?: Aspects;
    applying?: boolean;
    strength?: number;
    polarity?: number;
    contribution?: number;
}

export class InsightsLiteCalendarDayDto implements IInsightsLiteCalendarDayDto {
    date?: Date;
    bestProfileKey?: string | undefined;
    bestProfileScore?: number | undefined;
    cautionProfileKey?: string | undefined;
    cautionProfileScore?: number | undefined;
    averageScore?: number | undefined;

    constructor(data?: IInsightsLiteCalendarDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.bestProfileKey = _data["bestProfileKey"];
            this.bestProfileScore = _data["bestProfileScore"];
            this.cautionProfileKey = _data["cautionProfileKey"];
            this.cautionProfileScore = _data["cautionProfileScore"];
            this.averageScore = _data["averageScore"];
        }
    }

    static fromJS(data: any): InsightsLiteCalendarDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteCalendarDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["bestProfileKey"] = this.bestProfileKey;
        data["bestProfileScore"] = this.bestProfileScore;
        data["cautionProfileKey"] = this.cautionProfileKey;
        data["cautionProfileScore"] = this.cautionProfileScore;
        data["averageScore"] = this.averageScore;
        return data;
    }
}

export interface IInsightsLiteCalendarDayDto {
    date?: Date;
    bestProfileKey?: string | undefined;
    bestProfileScore?: number | undefined;
    cautionProfileKey?: string | undefined;
    cautionProfileScore?: number | undefined;
    averageScore?: number | undefined;
}

export class InsightsLiteDayDto implements IInsightsLiteDayDto {
    date?: Date;
    profiles?: InsightsLiteProfileScoreDto[] | undefined;

    constructor(data?: IInsightsLiteDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(InsightsLiteProfileScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsightsLiteDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsightsLiteDayDto {
    date?: Date;
    profiles?: InsightsLiteProfileScoreDto[] | undefined;
}

export class InsightsLiteDto implements IInsightsLiteDto {
    date?: Date;
    daily?: InsightsLiteDayDto;
    week?: InsightsLiteWindowDto;
    month?: InsightsLiteWindowDto;

    constructor(data?: IInsightsLiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.daily = _data["daily"] ? InsightsLiteDayDto.fromJS(_data["daily"]) : undefined as any;
            this.week = _data["week"] ? InsightsLiteWindowDto.fromJS(_data["week"]) : undefined as any;
            this.month = _data["month"] ? InsightsLiteWindowDto.fromJS(_data["month"]) : undefined as any;
        }
    }

    static fromJS(data: any): InsightsLiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["daily"] = this.daily ? this.daily.toJSON() : undefined as any;
        data["week"] = this.week ? this.week.toJSON() : undefined as any;
        data["month"] = this.month ? this.month.toJSON() : undefined as any;
        return data;
    }
}

export interface IInsightsLiteDto {
    date?: Date;
    daily?: InsightsLiteDayDto;
    week?: InsightsLiteWindowDto;
    month?: InsightsLiteWindowDto;
}

export class InsightsLiteProfileDayDto implements IInsightsLiteProfileDayDto {
    date?: Date;
    percentAbsolute?: number;
    percentRelative?: number;
    aspects?: InsightsLiteAspectDto[] | undefined;

    constructor(data?: IInsightsLiteProfileDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.percentAbsolute = _data["percentAbsolute"];
            this.percentRelative = _data["percentRelative"];
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(InsightsLiteAspectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsightsLiteProfileDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteProfileDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["percentAbsolute"] = this.percentAbsolute;
        data["percentRelative"] = this.percentRelative;
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsightsLiteProfileDayDto {
    date?: Date;
    percentAbsolute?: number;
    percentRelative?: number;
    aspects?: InsightsLiteAspectDto[] | undefined;
}

export class InsightsLiteProfileScoreDto implements IInsightsLiteProfileScoreDto {
    profileKey?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    aspects?: InsightsLiteAspectDto[] | undefined;

    constructor(data?: IInsightsLiteProfileScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileKey = _data["profileKey"];
            this.percentAbsolute = _data["percentAbsolute"];
            this.percentRelative = _data["percentRelative"];
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(InsightsLiteAspectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsightsLiteProfileScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteProfileScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileKey"] = this.profileKey;
        data["percentAbsolute"] = this.percentAbsolute;
        data["percentRelative"] = this.percentRelative;
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsightsLiteProfileScoreDto {
    profileKey?: string | undefined;
    percentAbsolute?: number;
    percentRelative?: number;
    aspects?: InsightsLiteAspectDto[] | undefined;
}

export class InsightsLiteProfileWindowDto implements IInsightsLiteProfileWindowDto {
    profileKey?: string | undefined;
    avgPercentAbsolute?: number;
    avgPercentRelative?: number;
    days?: InsightsLiteProfileDayDto[] | undefined;

    constructor(data?: IInsightsLiteProfileWindowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileKey = _data["profileKey"];
            this.avgPercentAbsolute = _data["avgPercentAbsolute"];
            this.avgPercentRelative = _data["avgPercentRelative"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(InsightsLiteProfileDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsightsLiteProfileWindowDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteProfileWindowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileKey"] = this.profileKey;
        data["avgPercentAbsolute"] = this.avgPercentAbsolute;
        data["avgPercentRelative"] = this.avgPercentRelative;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsightsLiteProfileWindowDto {
    profileKey?: string | undefined;
    avgPercentAbsolute?: number;
    avgPercentRelative?: number;
    days?: InsightsLiteProfileDayDto[] | undefined;
}

export class InsightsLiteWindowDto implements IInsightsLiteWindowDto {
    startDate?: Date;
    endDate?: Date;
    profiles?: InsightsLiteProfileWindowDto[] | undefined;
    calendar?: InsightsLiteCalendarDayDto[] | undefined;

    constructor(data?: IInsightsLiteWindowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["profiles"])) {
                this.profiles = [] as any;
                for (let item of _data["profiles"])
                    this.profiles!.push(InsightsLiteProfileWindowDto.fromJS(item));
            }
            if (Array.isArray(_data["calendar"])) {
                this.calendar = [] as any;
                for (let item of _data["calendar"])
                    this.calendar!.push(InsightsLiteCalendarDayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsightsLiteWindowDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsightsLiteWindowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? formatDate(this.startDate) : undefined as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : undefined as any;
        if (Array.isArray(this.profiles)) {
            data["profiles"] = [];
            for (let item of this.profiles)
                data["profiles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calendar)) {
            data["calendar"] = [];
            for (let item of this.calendar)
                data["calendar"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInsightsLiteWindowDto {
    startDate?: Date;
    endDate?: Date;
    profiles?: InsightsLiteProfileWindowDto[] | undefined;
    calendar?: InsightsLiteCalendarDayDto[] | undefined;
}

export class InvestmentOptimizeResult implements IInvestmentOptimizeResult {
    bestSettings?: TransitProfileSettings;
    pearson?: number;
    spearman?: number;
    lagDays?: number | undefined;
    sampleSize?: number;

    constructor(data?: IInvestmentOptimizeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bestSettings = _data["bestSettings"] ? TransitProfileSettings.fromJS(_data["bestSettings"]) : undefined as any;
            this.pearson = _data["pearson"];
            this.spearman = _data["spearman"];
            this.lagDays = _data["lagDays"];
            this.sampleSize = _data["sampleSize"];
        }
    }

    static fromJS(data: any): InvestmentOptimizeResult {
        data = typeof data === 'object' ? data : {};
        let result = new InvestmentOptimizeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bestSettings"] = this.bestSettings ? this.bestSettings.toJSON() : undefined as any;
        data["pearson"] = this.pearson;
        data["spearman"] = this.spearman;
        data["lagDays"] = this.lagDays;
        data["sampleSize"] = this.sampleSize;
        return data;
    }
}

export interface IInvestmentOptimizeResult {
    bestSettings?: TransitProfileSettings;
    pearson?: number;
    spearman?: number;
    lagDays?: number | undefined;
    sampleSize?: number;
}

export class Location implements ILocation {
    place?: string | undefined;
    country?: string | undefined;
    latitude!: number;
    longitude!: number;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.place = _data["place"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["place"] = this.place;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocation {
    place?: string | undefined;
    country?: string | undefined;
    latitude: number;
    longitude: number;
}

export class LocationSuggestionDto implements ILocationSuggestionDto {
    city?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;

    constructor(data?: ILocationSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.city = _data["city"];
            this.country = _data["country"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): LocationSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ILocationSuggestionDto {
    city?: string | undefined;
    country?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export enum LunarPhase {
    NewMoon = "NewMoon",
    WaxingCrescent = "WaxingCrescent",
    FirstQuarter = "FirstQuarter",
    WaxingGibbous = "WaxingGibbous",
    FullMoon = "FullMoon",
    WaningGibbous = "WaningGibbous",
    LastQuarter = "LastQuarter",
    WaningCrescent = "WaningCrescent",
}

export class MeditationPhaseDto implements IMeditationPhaseDto {
    title?: string | undefined;
    text?: string | undefined;
    focus?: string | undefined;
    durationSeconds?: number | undefined;
    breathingPattern?: BreathingPatternDto;

    constructor(data?: IMeditationPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.text = _data["text"];
            this.focus = _data["focus"];
            this.durationSeconds = _data["durationSeconds"];
            this.breathingPattern = _data["breathingPattern"] ? BreathingPatternDto.fromJS(_data["breathingPattern"]) : undefined as any;
        }
    }

    static fromJS(data: any): MeditationPhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeditationPhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["text"] = this.text;
        data["focus"] = this.focus;
        data["durationSeconds"] = this.durationSeconds;
        data["breathingPattern"] = this.breathingPattern ? this.breathingPattern.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeditationPhaseDto {
    title?: string | undefined;
    text?: string | undefined;
    focus?: string | undefined;
    durationSeconds?: number | undefined;
    breathingPattern?: BreathingPatternDto;
}

export enum MovingAverageType {
    None = "None",
    SMA = "SMA",
    EMA = "EMA",
}

/** State of the AI forecast for a natal chart as exposed by read endpoints (RM-013). */
export enum NatalChartForecastStatus {
    Ready = "Ready",
    Pending = "Pending",
    Failed = "Failed",
}

export class NatalChartRequestDto implements INatalChartRequestDto {
    name!: string | undefined;
    birthDate!: string | undefined;
    birthTime!: string | undefined;
    birthLocation!: Location;
    language!: string | undefined;
    treatmentPreference?: UserTreatmentPreference;

    constructor(data?: INatalChartRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.birthLocation = new Location();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.birthDate = _data["birthDate"];
            this.birthTime = _data["birthTime"];
            this.birthLocation = _data["birthLocation"] ? Location.fromJS(_data["birthLocation"]) : new Location();
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
        }
    }

    static fromJS(data: any): NatalChartRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NatalChartRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["birthDate"] = this.birthDate;
        data["birthTime"] = this.birthTime;
        data["birthLocation"] = this.birthLocation ? this.birthLocation.toJSON() : undefined as any;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        return data;
    }
}

export interface INatalChartRequestDto {
    name: string | undefined;
    birthDate: string | undefined;
    birthTime: string | undefined;
    birthLocation: Location;
    language: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
}

export class NatalChartResult implements INatalChartResult {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    chartSubjectId?: string;
    ownerUserId?: string | undefined;
    name?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    birthDateTime?: Date;
    timeZone?: string | undefined;
    location?: GeoLocation;
    ascendantSign?: Zodiac;
    ascendantDegree?: number;
    ascendantForecast?: string | undefined;
    descendantSign?: Zodiac;
    descendantDegree?: number;
    descendantForecast?: string | undefined;
    mediumCoeliSign?: Zodiac;
    mediumCoeliDegree?: number;
    mediumCoeliForecast?: string | undefined;
    imumCoeliSign?: Zodiac;
    imumCoeliDegree?: number;
    imumCoeliForecast?: string | undefined;
    planets?: PlanetInfo[] | undefined;
    houses?: HouseInfo[] | undefined;
    aspects?: AspectInfo[] | undefined;
    globalForecast?: string | undefined;
    forecastedAtUtc?: Date | undefined;

    constructor(data?: INatalChartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.chartSubjectId = _data["chartSubjectId"];
            this.ownerUserId = _data["ownerUserId"];
            this.name = _data["name"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.location = _data["location"] ? GeoLocation.fromJS(_data["location"]) : undefined as any;
            this.ascendantSign = _data["ascendantSign"];
            this.ascendantDegree = _data["ascendantDegree"];
            this.ascendantForecast = _data["ascendantForecast"];
            this.descendantSign = _data["descendantSign"];
            this.descendantDegree = _data["descendantDegree"];
            this.descendantForecast = _data["descendantForecast"];
            this.mediumCoeliSign = _data["mediumCoeliSign"];
            this.mediumCoeliDegree = _data["mediumCoeliDegree"];
            this.mediumCoeliForecast = _data["mediumCoeliForecast"];
            this.imumCoeliSign = _data["imumCoeliSign"];
            this.imumCoeliDegree = _data["imumCoeliDegree"];
            this.imumCoeliForecast = _data["imumCoeliForecast"];
            if (Array.isArray(_data["planets"])) {
                this.planets = [] as any;
                for (let item of _data["planets"])
                    this.planets!.push(PlanetInfo.fromJS(item));
            }
            if (Array.isArray(_data["houses"])) {
                this.houses = [] as any;
                for (let item of _data["houses"])
                    this.houses!.push(HouseInfo.fromJS(item));
            }
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(AspectInfo.fromJS(item));
            }
            this.globalForecast = _data["globalForecast"];
            this.forecastedAtUtc = _data["forecastedAtUtc"] ? new Date(_data["forecastedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NatalChartResult {
        data = typeof data === 'object' ? data : {};
        let result = new NatalChartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["chartSubjectId"] = this.chartSubjectId;
        data["ownerUserId"] = this.ownerUserId;
        data["name"] = this.name;
        data["treatmentPreference"] = this.treatmentPreference;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["ascendantSign"] = this.ascendantSign;
        data["ascendantDegree"] = this.ascendantDegree;
        data["ascendantForecast"] = this.ascendantForecast;
        data["descendantSign"] = this.descendantSign;
        data["descendantDegree"] = this.descendantDegree;
        data["descendantForecast"] = this.descendantForecast;
        data["mediumCoeliSign"] = this.mediumCoeliSign;
        data["mediumCoeliDegree"] = this.mediumCoeliDegree;
        data["mediumCoeliForecast"] = this.mediumCoeliForecast;
        data["imumCoeliSign"] = this.imumCoeliSign;
        data["imumCoeliDegree"] = this.imumCoeliDegree;
        data["imumCoeliForecast"] = this.imumCoeliForecast;
        if (Array.isArray(this.planets)) {
            data["planets"] = [];
            for (let item of this.planets)
                data["planets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.houses)) {
            data["houses"] = [];
            for (let item of this.houses)
                data["houses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalForecast"] = this.globalForecast;
        data["forecastedAtUtc"] = this.forecastedAtUtc ? this.forecastedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface INatalChartResult {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    chartSubjectId?: string;
    ownerUserId?: string | undefined;
    name?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    birthDateTime?: Date;
    timeZone?: string | undefined;
    location?: GeoLocation;
    ascendantSign?: Zodiac;
    ascendantDegree?: number;
    ascendantForecast?: string | undefined;
    descendantSign?: Zodiac;
    descendantDegree?: number;
    descendantForecast?: string | undefined;
    mediumCoeliSign?: Zodiac;
    mediumCoeliDegree?: number;
    mediumCoeliForecast?: string | undefined;
    imumCoeliSign?: Zodiac;
    imumCoeliDegree?: number;
    imumCoeliForecast?: string | undefined;
    planets?: PlanetInfo[] | undefined;
    houses?: HouseInfo[] | undefined;
    aspects?: AspectInfo[] | undefined;
    globalForecast?: string | undefined;
    forecastedAtUtc?: Date | undefined;
}

export class NatalChartResultDto implements INatalChartResultDto {
    id?: string;
    chartSubjectId?: string;
    name?: string | undefined;
    birthDateTime?: Date;
    timeZone?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    location?: GeoLocationDto;
    ascendantSign?: Zodiac;
    ascendantDegree?: number;
    ascendantForecast?: string | undefined;
    descendantSign?: Zodiac;
    descendantDegree?: number;
    descendantForecast?: string | undefined;
    mediumCoeliSign?: Zodiac;
    mediumCoeliDegree?: number;
    mediumCoeliForecast?: string | undefined;
    imumCoeliSign?: Zodiac;
    imumCoeliDegree?: number;
    imumCoeliForecast?: string | undefined;
    planets?: PlanetInfoDto[] | undefined;
    houses?: HouseInfoDto[] | undefined;
    aspects?: AspectInfoDto[] | undefined;
    globalForecast?: string | undefined;
    forecastStatus?: NatalChartForecastStatus;

    constructor(data?: INatalChartResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chartSubjectId = _data["chartSubjectId"];
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.timeZone = _data["timeZone"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.location = _data["location"] ? GeoLocationDto.fromJS(_data["location"]) : undefined as any;
            this.ascendantSign = _data["ascendantSign"];
            this.ascendantDegree = _data["ascendantDegree"];
            this.ascendantForecast = _data["ascendantForecast"];
            this.descendantSign = _data["descendantSign"];
            this.descendantDegree = _data["descendantDegree"];
            this.descendantForecast = _data["descendantForecast"];
            this.mediumCoeliSign = _data["mediumCoeliSign"];
            this.mediumCoeliDegree = _data["mediumCoeliDegree"];
            this.mediumCoeliForecast = _data["mediumCoeliForecast"];
            this.imumCoeliSign = _data["imumCoeliSign"];
            this.imumCoeliDegree = _data["imumCoeliDegree"];
            this.imumCoeliForecast = _data["imumCoeliForecast"];
            if (Array.isArray(_data["planets"])) {
                this.planets = [] as any;
                for (let item of _data["planets"])
                    this.planets!.push(PlanetInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["houses"])) {
                this.houses = [] as any;
                for (let item of _data["houses"])
                    this.houses!.push(HouseInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(AspectInfoDto.fromJS(item));
            }
            this.globalForecast = _data["globalForecast"];
            this.forecastStatus = _data["forecastStatus"];
        }
    }

    static fromJS(data: any): NatalChartResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NatalChartResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chartSubjectId"] = this.chartSubjectId;
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["timeZone"] = this.timeZone;
        data["treatmentPreference"] = this.treatmentPreference;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["ascendantSign"] = this.ascendantSign;
        data["ascendantDegree"] = this.ascendantDegree;
        data["ascendantForecast"] = this.ascendantForecast;
        data["descendantSign"] = this.descendantSign;
        data["descendantDegree"] = this.descendantDegree;
        data["descendantForecast"] = this.descendantForecast;
        data["mediumCoeliSign"] = this.mediumCoeliSign;
        data["mediumCoeliDegree"] = this.mediumCoeliDegree;
        data["mediumCoeliForecast"] = this.mediumCoeliForecast;
        data["imumCoeliSign"] = this.imumCoeliSign;
        data["imumCoeliDegree"] = this.imumCoeliDegree;
        data["imumCoeliForecast"] = this.imumCoeliForecast;
        if (Array.isArray(this.planets)) {
            data["planets"] = [];
            for (let item of this.planets)
                data["planets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.houses)) {
            data["houses"] = [];
            for (let item of this.houses)
                data["houses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalForecast"] = this.globalForecast;
        data["forecastStatus"] = this.forecastStatus;
        return data;
    }
}

export interface INatalChartResultDto {
    id?: string;
    chartSubjectId?: string;
    name?: string | undefined;
    birthDateTime?: Date;
    timeZone?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    location?: GeoLocationDto;
    ascendantSign?: Zodiac;
    ascendantDegree?: number;
    ascendantForecast?: string | undefined;
    descendantSign?: Zodiac;
    descendantDegree?: number;
    descendantForecast?: string | undefined;
    mediumCoeliSign?: Zodiac;
    mediumCoeliDegree?: number;
    mediumCoeliForecast?: string | undefined;
    imumCoeliSign?: Zodiac;
    imumCoeliDegree?: number;
    imumCoeliForecast?: string | undefined;
    planets?: PlanetInfoDto[] | undefined;
    houses?: HouseInfoDto[] | undefined;
    aspects?: AspectInfoDto[] | undefined;
    globalForecast?: string | undefined;
    forecastStatus?: NatalChartForecastStatus;
}

export enum OrderLineProductType {
    SubscriptionPlan = "SubscriptionPlan",
}

export enum OrderPaymentStatus {
    Unpaid = "Unpaid",
    Pending = "Pending",
    Paid = "Paid",
    Refunded = "Refunded",
}

export enum OrderStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    Confirmed = "Confirmed",
    Cancelled = "Cancelled",
    Fulfilled = "Fulfilled",
}

export class PaymentAction implements IPaymentAction {
    type?: PaymentActionType;
    url?: string | undefined;
    qrCodeBase64?: string | undefined;
    displayText?: string | undefined;
    expiresAtUtc?: Date | undefined;

    constructor(data?: IPaymentAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.url = _data["url"];
            this.qrCodeBase64 = _data["qrCodeBase64"];
            this.displayText = _data["displayText"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaymentAction {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        data["qrCodeBase64"] = this.qrCodeBase64;
        data["displayText"] = this.displayText;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IPaymentAction {
    type?: PaymentActionType;
    url?: string | undefined;
    qrCodeBase64?: string | undefined;
    displayText?: string | undefined;
    expiresAtUtc?: Date | undefined;
}

export enum PaymentActionType {
    None = "None",
    Redirect = "Redirect",
    ShowQrCode = "ShowQrCode",
    ShowReference = "ShowReference",
    OpenApp = "OpenApp",
}

export class PaymentError implements IPaymentError {
    code!: string | undefined;
    message!: string | undefined;
    isTransient?: boolean;
    details?: { [key: string]: string; } | undefined;

    constructor(data?: IPaymentError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.isTransient = _data["isTransient"];
            if (_data["details"]) {
                this.details = {} as any;
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        (this.details as any)![key] = _data["details"][key];
                }
            }
        }
    }

    static fromJS(data: any): PaymentError {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["isTransient"] = this.isTransient;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    (data["details"] as any)[key] = (this.details as any)[key];
            }
        }
        return data;
    }
}

export interface IPaymentError {
    code: string | undefined;
    message: string | undefined;
    isTransient?: boolean;
    details?: { [key: string]: string; } | undefined;
}

export enum PaymentStatus {
    Created = "Created",
    Pending = "Pending",
    Authorized = "Authorized",
    Paid = "Paid",
    Failed = "Failed",
    Expired = "Expired",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
}

export class PlanetInfo implements IPlanetInfo {
    id?: number;
    planet?: Planets;
    sign?: Zodiac;
    degree?: number;
    houseNumber?: number;
    forecast?: string | undefined;

    constructor(data?: IPlanetInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planet = _data["planet"];
            this.sign = _data["sign"];
            this.degree = _data["degree"];
            this.houseNumber = _data["houseNumber"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): PlanetInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PlanetInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planet"] = this.planet;
        data["sign"] = this.sign;
        data["degree"] = this.degree;
        data["houseNumber"] = this.houseNumber;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IPlanetInfo {
    id?: number;
    planet?: Planets;
    sign?: Zodiac;
    degree?: number;
    houseNumber?: number;
    forecast?: string | undefined;
}

export class PlanetInfoDto implements IPlanetInfoDto {
    id?: number;
    planet?: Planets;
    sign?: Zodiac;
    degree?: number;
    houseNumber?: number;
    forecast?: string | undefined;

    constructor(data?: IPlanetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.planet = _data["planet"];
            this.sign = _data["sign"];
            this.degree = _data["degree"];
            this.houseNumber = _data["houseNumber"];
            this.forecast = _data["forecast"];
        }
    }

    static fromJS(data: any): PlanetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["planet"] = this.planet;
        data["sign"] = this.sign;
        data["degree"] = this.degree;
        data["houseNumber"] = this.houseNumber;
        data["forecast"] = this.forecast;
        return data;
    }
}

export interface IPlanetInfoDto {
    id?: number;
    planet?: Planets;
    sign?: Zodiac;
    degree?: number;
    houseNumber?: number;
    forecast?: string | undefined;
}

export enum Planets {
    Sun = "Sun",
    Moon = "Moon",
    Mercury = "Mercury",
    Venus = "Venus",
    Mars = "Mars",
    Jupiter = "Jupiter",
    Saturn = "Saturn",
    Uranus = "Uranus",
    Neptune = "Neptune",
    Pluto = "Pluto",
    NorthNode = "NorthNode",
    SouthNode = "SouthNode",
    Chiron = "Chiron",
    Earth = "Earth",
    Pholus = "Pholus",
    Ceres = "Ceres",
    Pallas = "Pallas",
    Juno = "Juno",
    Vesta = "Vesta",
    Lilith = "Lilith",
}

export enum PlatformFeature {
    Dashboard = "Dashboard",
    NatalChart = "NatalChart",
    Insights = "Insights",
    AiChat = "AiChat",
    Compatibility = "Compatibility",
    Social = "Social",
    Investments = "Investments",
    NatalReading = "NatalReading",
    DailyReport = "DailyReport",
    TransitReading = "TransitReading",
    CompatibilityLite = "CompatibilityLite",
}

export class Post implements IPost {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    imageUrl?: string | undefined;
    caption?: string | undefined;
    isPublic?: boolean;

    constructor(data?: IPost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.imageUrl = _data["imageUrl"];
            this.caption = _data["caption"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): Post {
        data = typeof data === 'object' ? data : {};
        let result = new Post();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["imageUrl"] = this.imageUrl;
        data["caption"] = this.caption;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IPost {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    imageUrl?: string | undefined;
    caption?: string | undefined;
    isPublic?: boolean;
}

export class PostDto implements IPostDto {
    id?: string;
    userId?: string;
    imageUrl?: string | undefined;
    caption?: string | undefined;
    isPublic?: boolean;
    createdAt?: Date;

    constructor(data?: IPostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.imageUrl = _data["imageUrl"];
            this.caption = _data["caption"];
            this.isPublic = _data["isPublic"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PostDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["imageUrl"] = this.imageUrl;
        data["caption"] = this.caption;
        data["isPublic"] = this.isPublic;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPostDto {
    id?: string;
    userId?: string;
    imageUrl?: string | undefined;
    caption?: string | undefined;
    isPublic?: boolean;
    createdAt?: Date;
}

export class PostReportDto implements IPostReportDto {
    id?: string;
    postId?: string;
    reporterId?: string;
    reason?: string | undefined;
    createdAt?: Date;

    constructor(data?: IPostReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.postId = _data["postId"];
            this.reporterId = _data["reporterId"];
            this.reason = _data["reason"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PostReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PostReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["postId"] = this.postId;
        data["reporterId"] = this.reporterId;
        data["reason"] = this.reason;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPostReportDto {
    id?: string;
    postId?: string;
    reporterId?: string;
    reason?: string | undefined;
    createdAt?: Date;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProfileHighlightSummary implements IProfileHighlightSummary {
    positive?: WindowProfileResult;
    negative?: WindowProfileResult;

    constructor(data?: IProfileHighlightSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positive = _data["positive"] ? WindowProfileResult.fromJS(_data["positive"]) : undefined as any;
            this.negative = _data["negative"] ? WindowProfileResult.fromJS(_data["negative"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileHighlightSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileHighlightSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positive"] = this.positive ? this.positive.toJSON() : undefined as any;
        data["negative"] = this.negative ? this.negative.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileHighlightSummary {
    positive?: WindowProfileResult;
    negative?: WindowProfileResult;
}

export class ProfileMetadata implements IProfileMetadata {
    houseBoosts?: { [key: string]: number; } | undefined;
    retroMultipliers?: RetroMultipliers | undefined;
    goodThresholdRaw?: number;
    badThresholdRaw?: number;
    rawRange?: Range;

    constructor(data?: IProfileMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["houseBoosts"]) {
                this.houseBoosts = {} as any;
                for (let key in _data["houseBoosts"]) {
                    if (_data["houseBoosts"].hasOwnProperty(key))
                        (this.houseBoosts as any)![key] = _data["houseBoosts"][key];
                }
            }
            this.retroMultipliers = _data["retroMultipliers"] ? RetroMultipliers.fromJS(_data["retroMultipliers"]) : undefined as any;
            this.goodThresholdRaw = _data["goodThresholdRaw"];
            this.badThresholdRaw = _data["badThresholdRaw"];
            this.rawRange = _data["rawRange"] ? Range.fromJS(_data["rawRange"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.houseBoosts) {
            data["houseBoosts"] = {};
            for (let key in this.houseBoosts) {
                if (this.houseBoosts.hasOwnProperty(key))
                    (data["houseBoosts"] as any)[key] = (this.houseBoosts as any)[key];
            }
        }
        data["retroMultipliers"] = this.retroMultipliers ? this.retroMultipliers.toJSON() : undefined as any;
        data["goodThresholdRaw"] = this.goodThresholdRaw;
        data["badThresholdRaw"] = this.badThresholdRaw;
        data["rawRange"] = this.rawRange ? this.rawRange.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileMetadata {
    houseBoosts?: { [key: string]: number; } | undefined;
    retroMultipliers?: RetroMultipliers | undefined;
    goodThresholdRaw?: number;
    badThresholdRaw?: number;
    rawRange?: Range;
}

export class ProfilePublicDto implements IProfilePublicDto {
    displayName?: string | undefined;
    bio?: string | undefined;
    isPrivate?: boolean;
    isFollowing?: boolean;

    constructor(data?: IProfilePublicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.bio = _data["bio"];
            this.isPrivate = _data["isPrivate"];
            this.isFollowing = _data["isFollowing"];
        }
    }

    static fromJS(data: any): ProfilePublicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePublicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["bio"] = this.bio;
        data["isPrivate"] = this.isPrivate;
        data["isFollowing"] = this.isFollowing;
        return data;
    }
}

export interface IProfilePublicDto {
    displayName?: string | undefined;
    bio?: string | undefined;
    isPrivate?: boolean;
    isFollowing?: boolean;
}

export class ProfileSummaries implements IProfileSummaries {
    summaries?: ProfileSummary[] | undefined;

    constructor(data?: IProfileSummaries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [] as any;
                for (let item of _data["summaries"])
                    this.summaries!.push(ProfileSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileSummaries {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSummaries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (let item of this.summaries)
                data["summaries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfileSummaries {
    summaries?: ProfileSummary[] | undefined;
}

export class ProfileSummary implements IProfileSummary {
    profileKey?: string | undefined;
    transitEvaluation?: TransitEvaluation;

    constructor(data?: IProfileSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileKey = _data["profileKey"];
            this.transitEvaluation = _data["transitEvaluation"] ? TransitEvaluation.fromJS(_data["transitEvaluation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileKey"] = this.profileKey;
        data["transitEvaluation"] = this.transitEvaluation ? this.transitEvaluation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileSummary {
    profileKey?: string | undefined;
    transitEvaluation?: TransitEvaluation;
}

export class PublicNatalChartRequestDto implements IPublicNatalChartRequestDto {
    birthDate!: string | undefined;
    birthTime!: string | undefined;
    latitude!: number;
    longitude!: number;

    constructor(data?: IPublicNatalChartRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"];
            this.birthTime = _data["birthTime"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PublicNatalChartRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicNatalChartRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate;
        data["birthTime"] = this.birthTime;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPublicNatalChartRequestDto {
    birthDate: string | undefined;
    birthTime: string | undefined;
    latitude: number;
    longitude: number;
}

export class Range implements IRange {
    min?: number;
    max?: number;

    constructor(data?: IRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static fromJS(data: any): Range {
        data = typeof data === 'object' ? data : {};
        let result = new Range();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        return data;
    }
}

export interface IRange {
    min?: number;
    max?: number;
}

export class RecalculateBirthRecordDto implements IRecalculateBirthRecordDto {
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;

    constructor(data?: IRecalculateBirthRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.birthLatitude = _data["birthLatitude"];
            this.birthLongitude = _data["birthLongitude"];
        }
    }

    static fromJS(data: any): RecalculateBirthRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateBirthRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["birthLatitude"] = this.birthLatitude;
        data["birthLongitude"] = this.birthLongitude;
        return data;
    }
}

export interface IRecalculateBirthRecordDto {
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    birthLatitude?: number;
    birthLongitude?: number;
}

export class RecalculateBirthRecordResponseDto implements IRecalculateBirthRecordResponseDto {
    idempotencyKey?: string | undefined;
    alreadyApplied?: boolean;
    debitedCredits?: number;
    remainingCredits?: number;
    queuedAtUtc?: Date;

    constructor(data?: IRecalculateBirthRecordResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idempotencyKey = _data["idempotencyKey"];
            this.alreadyApplied = _data["alreadyApplied"];
            this.debitedCredits = _data["debitedCredits"];
            this.remainingCredits = _data["remainingCredits"];
            this.queuedAtUtc = _data["queuedAtUtc"] ? new Date(_data["queuedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RecalculateBirthRecordResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateBirthRecordResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idempotencyKey"] = this.idempotencyKey;
        data["alreadyApplied"] = this.alreadyApplied;
        data["debitedCredits"] = this.debitedCredits;
        data["remainingCredits"] = this.remainingCredits;
        data["queuedAtUtc"] = this.queuedAtUtc ? this.queuedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IRecalculateBirthRecordResponseDto {
    idempotencyKey?: string | undefined;
    alreadyApplied?: boolean;
    debitedCredits?: number;
    remainingCredits?: number;
    queuedAtUtc?: Date;
}

export class ReconcilePaymentResponse implements IReconcilePaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;

    constructor(data?: IReconcilePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.status = _data["status"];
            this.error = _data["error"] ? PaymentError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReconcilePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReconcilePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IReconcilePaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;
}

export class RecordAcquisitionAttributionDto implements IRecordAcquisitionAttributionDto {
    source?: string | undefined;
    medium?: string | undefined;
    campaign?: string | undefined;
    content?: string | undefined;

    constructor(data?: IRecordAcquisitionAttributionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.medium = _data["medium"];
            this.campaign = _data["campaign"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): RecordAcquisitionAttributionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordAcquisitionAttributionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["medium"] = this.medium;
        data["campaign"] = this.campaign;
        data["content"] = this.content;
        return data;
    }
}

export interface IRecordAcquisitionAttributionDto {
    source?: string | undefined;
    medium?: string | undefined;
    campaign?: string | undefined;
    content?: string | undefined;
}

export class RefundPaymentRequest implements IRefundPaymentRequest {
    paymentId?: string;
    amount?: number;
    currency!: string | undefined;
    reason?: string | undefined;

    constructor(data?: IRefundPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): RefundPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefundPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IRefundPaymentRequest {
    paymentId?: string;
    amount?: number;
    currency: string | undefined;
    reason?: string | undefined;
}

export class RefundPaymentResponse implements IRefundPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;

    constructor(data?: IRefundPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.status = _data["status"];
            this.error = _data["error"] ? PaymentError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): RefundPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefundPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["status"] = this.status;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IRefundPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    error?: PaymentError;
}

export class SearchUsersResponseDto implements ISearchUsersResponseDto {
    id?: string;
    name?: string | undefined;
    publicId?: string | undefined;

    constructor(data?: ISearchUsersResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.publicId = _data["publicId"];
        }
    }

    static fromJS(data: any): SearchUsersResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchUsersResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["publicId"] = this.publicId;
        return data;
    }
}

export interface ISearchUsersResponseDto {
    id?: string;
    name?: string | undefined;
    publicId?: string | undefined;
}

export class StartPaymentRequest implements IStartPaymentRequest {
    paymentId?: string;
    methodDataJson?: string | undefined;

    constructor(data?: IStartPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.methodDataJson = _data["methodDataJson"];
        }
    }

    static fromJS(data: any): StartPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["methodDataJson"] = this.methodDataJson;
        return data;
    }
}

export interface IStartPaymentRequest {
    paymentId?: string;
    methodDataJson?: string | undefined;
}

export class StartPaymentResponse implements IStartPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    providerReference?: string | undefined;
    expiresAtUtc?: Date | undefined;
    action?: PaymentAction;
    error?: PaymentError;

    constructor(data?: IStartPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.status = _data["status"];
            this.providerReference = _data["providerReference"];
            this.expiresAtUtc = _data["expiresAtUtc"] ? new Date(_data["expiresAtUtc"].toString()) : undefined as any;
            this.action = _data["action"] ? PaymentAction.fromJS(_data["action"]) : undefined as any;
            this.error = _data["error"] ? PaymentError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): StartPaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartPaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["status"] = this.status;
        data["providerReference"] = this.providerReference;
        data["expiresAtUtc"] = this.expiresAtUtc ? this.expiresAtUtc.toISOString() : undefined as any;
        data["action"] = this.action ? this.action.toJSON() : undefined as any;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IStartPaymentResponse {
    paymentId?: string;
    status?: PaymentStatus;
    providerReference?: string | undefined;
    expiresAtUtc?: Date | undefined;
    action?: PaymentAction;
    error?: PaymentError;
}

export class SubscriptionAccessSnapshotDto implements ISubscriptionAccessSnapshotDto {
    currentTier?: SubscriptionTier;
    hasActiveSubscription?: boolean;
    hasActiveProSubscription?: boolean;
    expirationWarning?: SubscriptionExpirationWarningDto;
    credits?: CreditBalanceDto;
    creditCosts?: CreditCostDto[] | undefined;
    features?: FeatureAccessDto[] | undefined;

    constructor(data?: ISubscriptionAccessSnapshotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentTier = _data["currentTier"];
            this.hasActiveSubscription = _data["hasActiveSubscription"];
            this.hasActiveProSubscription = _data["hasActiveProSubscription"];
            this.expirationWarning = _data["expirationWarning"] ? SubscriptionExpirationWarningDto.fromJS(_data["expirationWarning"]) : undefined as any;
            this.credits = _data["credits"] ? CreditBalanceDto.fromJS(_data["credits"]) : undefined as any;
            if (Array.isArray(_data["creditCosts"])) {
                this.creditCosts = [] as any;
                for (let item of _data["creditCosts"])
                    this.creditCosts!.push(CreditCostDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FeatureAccessDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionAccessSnapshotDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionAccessSnapshotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentTier"] = this.currentTier;
        data["hasActiveSubscription"] = this.hasActiveSubscription;
        data["hasActiveProSubscription"] = this.hasActiveProSubscription;
        data["expirationWarning"] = this.expirationWarning ? this.expirationWarning.toJSON() : undefined as any;
        data["credits"] = this.credits ? this.credits.toJSON() : undefined as any;
        if (Array.isArray(this.creditCosts)) {
            data["creditCosts"] = [];
            for (let item of this.creditCosts)
                data["creditCosts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISubscriptionAccessSnapshotDto {
    currentTier?: SubscriptionTier;
    hasActiveSubscription?: boolean;
    hasActiveProSubscription?: boolean;
    expirationWarning?: SubscriptionExpirationWarningDto;
    credits?: CreditBalanceDto;
    creditCosts?: CreditCostDto[] | undefined;
    features?: FeatureAccessDto[] | undefined;
}

/** Legal document snapshot required for checkout acceptance. */
export class SubscriptionCheckoutLegalAcceptanceDto implements ISubscriptionCheckoutLegalAcceptanceDto {
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    termsAndConditionsUrl?: string | undefined;
    purchaseConditionsUrl?: string | undefined;
    privacyPolicyUrl?: string | undefined;
    disputeResolutionUrl?: string | undefined;
    immediateStartConsentRequired?: boolean;

    constructor(data?: ISubscriptionCheckoutLegalAcceptanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalVersion = _data["legalVersion"];
            this.legalLastUpdated = _data["legalLastUpdated"];
            this.termsAndConditionsUrl = _data["termsAndConditionsUrl"];
            this.purchaseConditionsUrl = _data["purchaseConditionsUrl"];
            this.privacyPolicyUrl = _data["privacyPolicyUrl"];
            this.disputeResolutionUrl = _data["disputeResolutionUrl"];
            this.immediateStartConsentRequired = _data["immediateStartConsentRequired"];
        }
    }

    static fromJS(data: any): SubscriptionCheckoutLegalAcceptanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCheckoutLegalAcceptanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalVersion"] = this.legalVersion;
        data["legalLastUpdated"] = this.legalLastUpdated;
        data["termsAndConditionsUrl"] = this.termsAndConditionsUrl;
        data["purchaseConditionsUrl"] = this.purchaseConditionsUrl;
        data["privacyPolicyUrl"] = this.privacyPolicyUrl;
        data["disputeResolutionUrl"] = this.disputeResolutionUrl;
        data["immediateStartConsentRequired"] = this.immediateStartConsentRequired;
        return data;
    }
}

/** Legal document snapshot required for checkout acceptance. */
export interface ISubscriptionCheckoutLegalAcceptanceDto {
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    termsAndConditionsUrl?: string | undefined;
    purchaseConditionsUrl?: string | undefined;
    privacyPolicyUrl?: string | undefined;
    disputeResolutionUrl?: string | undefined;
    immediateStartConsentRequired?: boolean;
}

/** Persisted order line included in a subscription checkout snapshot. */
export class SubscriptionCheckoutLineItemDto implements ISubscriptionCheckoutLineItemDto {
    productType?: OrderLineProductType;
    /** Identifier of the product captured in the order line. */
    productRefId?: string;
    /** Stable product code captured in the order line. */
    productCode?: string | undefined;
    /** Product description captured in the order line. */
    description?: string | undefined;
    /** Quantity captured in the order line. */
    quantity?: number;
    /** Unit price before tax captured in the order line. */
    unitPrice?: number;
    /** Line subtotal before tax. */
    subtotalAmount?: number;
    /** Tax rate captured in the order line as a decimal fraction. */
    taxRate?: number;
    /** Tax amount captured in the order line. */
    taxAmount?: number;
    /** Final line total after tax. */
    totalAmount?: number;

    constructor(data?: ISubscriptionCheckoutLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productType = _data["productType"];
            this.productRefId = _data["productRefId"];
            this.productCode = _data["productCode"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.subtotalAmount = _data["subtotalAmount"];
            this.taxRate = _data["taxRate"];
            this.taxAmount = _data["taxAmount"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): SubscriptionCheckoutLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCheckoutLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productType"] = this.productType;
        data["productRefId"] = this.productRefId;
        data["productCode"] = this.productCode;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["subtotalAmount"] = this.subtotalAmount;
        data["taxRate"] = this.taxRate;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

/** Persisted order line included in a subscription checkout snapshot. */
export interface ISubscriptionCheckoutLineItemDto {
    productType?: OrderLineProductType;
    /** Identifier of the product captured in the order line. */
    productRefId?: string;
    /** Stable product code captured in the order line. */
    productCode?: string | undefined;
    /** Product description captured in the order line. */
    description?: string | undefined;
    /** Quantity captured in the order line. */
    quantity?: number;
    /** Unit price before tax captured in the order line. */
    unitPrice?: number;
    /** Line subtotal before tax. */
    subtotalAmount?: number;
    /** Tax rate captured in the order line as a decimal fraction. */
    taxRate?: number;
    /** Tax amount captured in the order line. */
    taxAmount?: number;
    /** Final line total after tax. */
    totalAmount?: number;
}

/** Payment method option available for a subscription checkout. */
export class SubscriptionCheckoutPaymentMethodDto implements ISubscriptionCheckoutPaymentMethodDto {
    /** Payment method code to use when creating the payment. */
    methodCode?: string | undefined;
    /** Payment provider code to use when creating the payment. */
    providerCode?: string | undefined;
    /** Human-readable payment method name for display. */
    displayName?: string | undefined;
    /** Indicates whether this is the default payment method for the checkout. */
    isDefault?: boolean;

    constructor(data?: ISubscriptionCheckoutPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.methodCode = _data["methodCode"];
            this.providerCode = _data["providerCode"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): SubscriptionCheckoutPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCheckoutPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodCode"] = this.methodCode;
        data["providerCode"] = this.providerCode;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

/** Payment method option available for a subscription checkout. */
export interface ISubscriptionCheckoutPaymentMethodDto {
    /** Payment method code to use when creating the payment. */
    methodCode?: string | undefined;
    /** Payment provider code to use when creating the payment. */
    providerCode?: string | undefined;
    /** Human-readable payment method name for display. */
    displayName?: string | undefined;
    /** Indicates whether this is the default payment method for the checkout. */
    isDefault?: boolean;
}

export class SubscriptionCheckoutRequestDto implements ISubscriptionCheckoutRequestDto {
    planCode?: string | undefined;

    constructor(data?: ISubscriptionCheckoutRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planCode = _data["planCode"];
        }
    }

    static fromJS(data: any): SubscriptionCheckoutRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCheckoutRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planCode"] = this.planCode;
        return data;
    }
}

export interface ISubscriptionCheckoutRequestDto {
    planCode?: string | undefined;
}

/** Persisted subscription checkout fiscal and commercial snapshot used to create and charge an order. */
export class SubscriptionCheckoutResponseDto implements ISubscriptionCheckoutResponseDto {
    /** Unique identifier of the draft order created for the subscription checkout. */
    orderId?: string;
    /** Stable order number persisted for the checkout snapshot. */
    orderNumber?: string | undefined;
    /** Stable code of the subscription plan selected at checkout. */
    planCode?: string | undefined;
    /** Display name of the subscription plan selected at checkout. */
    planName?: string | undefined;
    /** Optional description of the subscription plan selected at checkout. */
    planDescription?: string | undefined;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    /** Number of interval units covered by the subscription plan selected at checkout. */
    intervalCount?: number;
    /** Monthly credit allowance included in the selected plan. */
    monthlyCreditsIncluded?: number;
    /** Order subtotal before tax. */
    subtotalAmount?: number;
    /** Effective tax rate applied to the order subtotal, expressed as a decimal fraction. For example, 0.23 represents 23%. */
    taxRate?: number;
    /** Tax amount calculated for the order. */
    taxAmount?: number;
    /** Discount amount applied to the order, if any. */
    discountAmount?: number;
    /** Final order total charged to the customer after tax and discounts. */
    totalAmount?: number;
    /** ISO 4217 currency code used by all monetary fields in this response. */
    currency?: string | undefined;
    status?: OrderStatus;
    orderPaymentStatus?: OrderPaymentStatus;
    /** Payment identifier associated with the checkout, when a payment has already been created. */
    paymentId?: string | undefined;
    /** Selected payment method code associated with the checkout, when a payment has already been created. */
    selectedPaymentMethodCode?: string | undefined;
    /** Selected payment provider code associated with the checkout, when a payment has already been created. */
    selectedPaymentProviderCode?: string | undefined;
    paymentStatus?: PaymentStatus;
    legalAcceptance?: SubscriptionCheckoutLegalAcceptanceDto;
    /** Available payment methods that can be used to pay this checkout. */
    availablePaymentMethods?: SubscriptionCheckoutPaymentMethodDto[] | undefined;
    /** Persisted order lines used to calculate the checkout fiscal snapshot. */
    lines?: SubscriptionCheckoutLineItemDto[] | undefined;

    constructor(data?: ISubscriptionCheckoutResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderNumber = _data["orderNumber"];
            this.planCode = _data["planCode"];
            this.planName = _data["planName"];
            this.planDescription = _data["planDescription"];
            this.tier = _data["tier"];
            this.interval = _data["interval"];
            this.intervalCount = _data["intervalCount"];
            this.monthlyCreditsIncluded = _data["monthlyCreditsIncluded"];
            this.subtotalAmount = _data["subtotalAmount"];
            this.taxRate = _data["taxRate"];
            this.taxAmount = _data["taxAmount"];
            this.discountAmount = _data["discountAmount"];
            this.totalAmount = _data["totalAmount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.orderPaymentStatus = _data["orderPaymentStatus"];
            this.paymentId = _data["paymentId"];
            this.selectedPaymentMethodCode = _data["selectedPaymentMethodCode"];
            this.selectedPaymentProviderCode = _data["selectedPaymentProviderCode"];
            this.paymentStatus = _data["paymentStatus"];
            this.legalAcceptance = _data["legalAcceptance"] ? SubscriptionCheckoutLegalAcceptanceDto.fromJS(_data["legalAcceptance"]) : undefined as any;
            if (Array.isArray(_data["availablePaymentMethods"])) {
                this.availablePaymentMethods = [] as any;
                for (let item of _data["availablePaymentMethods"])
                    this.availablePaymentMethods!.push(SubscriptionCheckoutPaymentMethodDto.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SubscriptionCheckoutLineItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionCheckoutResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCheckoutResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderNumber"] = this.orderNumber;
        data["planCode"] = this.planCode;
        data["planName"] = this.planName;
        data["planDescription"] = this.planDescription;
        data["tier"] = this.tier;
        data["interval"] = this.interval;
        data["intervalCount"] = this.intervalCount;
        data["monthlyCreditsIncluded"] = this.monthlyCreditsIncluded;
        data["subtotalAmount"] = this.subtotalAmount;
        data["taxRate"] = this.taxRate;
        data["taxAmount"] = this.taxAmount;
        data["discountAmount"] = this.discountAmount;
        data["totalAmount"] = this.totalAmount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["orderPaymentStatus"] = this.orderPaymentStatus;
        data["paymentId"] = this.paymentId;
        data["selectedPaymentMethodCode"] = this.selectedPaymentMethodCode;
        data["selectedPaymentProviderCode"] = this.selectedPaymentProviderCode;
        data["paymentStatus"] = this.paymentStatus;
        data["legalAcceptance"] = this.legalAcceptance ? this.legalAcceptance.toJSON() : undefined as any;
        if (Array.isArray(this.availablePaymentMethods)) {
            data["availablePaymentMethods"] = [];
            for (let item of this.availablePaymentMethods)
                data["availablePaymentMethods"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Persisted subscription checkout fiscal and commercial snapshot used to create and charge an order. */
export interface ISubscriptionCheckoutResponseDto {
    /** Unique identifier of the draft order created for the subscription checkout. */
    orderId?: string;
    /** Stable order number persisted for the checkout snapshot. */
    orderNumber?: string | undefined;
    /** Stable code of the subscription plan selected at checkout. */
    planCode?: string | undefined;
    /** Display name of the subscription plan selected at checkout. */
    planName?: string | undefined;
    /** Optional description of the subscription plan selected at checkout. */
    planDescription?: string | undefined;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    /** Number of interval units covered by the subscription plan selected at checkout. */
    intervalCount?: number;
    /** Monthly credit allowance included in the selected plan. */
    monthlyCreditsIncluded?: number;
    /** Order subtotal before tax. */
    subtotalAmount?: number;
    /** Effective tax rate applied to the order subtotal, expressed as a decimal fraction. For example, 0.23 represents 23%. */
    taxRate?: number;
    /** Tax amount calculated for the order. */
    taxAmount?: number;
    /** Discount amount applied to the order, if any. */
    discountAmount?: number;
    /** Final order total charged to the customer after tax and discounts. */
    totalAmount?: number;
    /** ISO 4217 currency code used by all monetary fields in this response. */
    currency?: string | undefined;
    status?: OrderStatus;
    orderPaymentStatus?: OrderPaymentStatus;
    /** Payment identifier associated with the checkout, when a payment has already been created. */
    paymentId?: string | undefined;
    /** Selected payment method code associated with the checkout, when a payment has already been created. */
    selectedPaymentMethodCode?: string | undefined;
    /** Selected payment provider code associated with the checkout, when a payment has already been created. */
    selectedPaymentProviderCode?: string | undefined;
    paymentStatus?: PaymentStatus;
    legalAcceptance?: SubscriptionCheckoutLegalAcceptanceDto;
    /** Available payment methods that can be used to pay this checkout. */
    availablePaymentMethods?: SubscriptionCheckoutPaymentMethodDto[] | undefined;
    /** Persisted order lines used to calculate the checkout fiscal snapshot. */
    lines?: SubscriptionCheckoutLineItemDto[] | undefined;
}

export class SubscriptionExpirationWarningDto implements ISubscriptionExpirationWarningDto {
    isEnabled?: boolean;
    daysBeforeExpiration?: number;
    daysRemaining?: number;
    endsAtUtc?: Date | undefined;

    constructor(data?: ISubscriptionExpirationWarningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.daysBeforeExpiration = _data["daysBeforeExpiration"];
            this.daysRemaining = _data["daysRemaining"];
            this.endsAtUtc = _data["endsAtUtc"] ? new Date(_data["endsAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubscriptionExpirationWarningDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionExpirationWarningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["daysBeforeExpiration"] = this.daysBeforeExpiration;
        data["daysRemaining"] = this.daysRemaining;
        data["endsAtUtc"] = this.endsAtUtc ? this.endsAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ISubscriptionExpirationWarningDto {
    isEnabled?: boolean;
    daysBeforeExpiration?: number;
    daysRemaining?: number;
    endsAtUtc?: Date | undefined;
}

export enum SubscriptionInterval {
    Days = "Days",
    Months = "Months",
    Years = "Years",
}

export class SubscriptionPlan implements ISubscriptionPlan {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    taxRate?: number;
    currency?: string | undefined;
    intervalCount?: number;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    monthlyCreditsIncluded?: number;
    isActive?: boolean;

    constructor(data?: ISubscriptionPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.taxRate = _data["taxRate"];
            this.currency = _data["currency"];
            this.intervalCount = _data["intervalCount"];
            this.tier = _data["tier"];
            this.interval = _data["interval"];
            this.monthlyCreditsIncluded = _data["monthlyCreditsIncluded"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SubscriptionPlan {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["taxRate"] = this.taxRate;
        data["currency"] = this.currency;
        data["intervalCount"] = this.intervalCount;
        data["tier"] = this.tier;
        data["interval"] = this.interval;
        data["monthlyCreditsIncluded"] = this.monthlyCreditsIncluded;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISubscriptionPlan {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    taxRate?: number;
    currency?: string | undefined;
    intervalCount?: number;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    monthlyCreditsIncluded?: number;
    isActive?: boolean;
}

/** Subscription plan data with explicit pre-tax and tax-inclusive pricing. */
export class SubscriptionPlanListItemDto implements ISubscriptionPlanListItemDto {
    /** Unique identifier of the subscription plan. */
    id?: string;
    /** Stable plan code used by the checkout flow. */
    code?: string | undefined;
    /** Display name of the subscription plan. */
    name?: string | undefined;
    /** Optional marketing description of the subscription plan. */
    description?: string | undefined;
    /** Recurring plan price before tax for one billing interval. */
    priceExcludingTax?: number;
    /** Applied tax rate as a decimal fraction. For example, 0.23 represents 23%. */
    taxRate?: number;
    /** Recurring plan price including tax for one billing interval. This is the final amount charged before discounts. */
    priceIncludingTax?: number;
    /** ISO 4217 currency code used by all monetary fields in this response. */
    currency?: string | undefined;
    /** Number of interval units between renewals. */
    intervalCount?: number;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    /** Monthly credit allowance included in the plan. */
    monthlyCreditsIncluded?: number;
    /** Indicates whether the plan is currently active and can be purchased. */
    isActive?: boolean;

    constructor(data?: ISubscriptionPlanListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.priceExcludingTax = _data["priceExcludingTax"];
            this.taxRate = _data["taxRate"];
            this.priceIncludingTax = _data["priceIncludingTax"];
            this.currency = _data["currency"];
            this.intervalCount = _data["intervalCount"];
            this.tier = _data["tier"];
            this.interval = _data["interval"];
            this.monthlyCreditsIncluded = _data["monthlyCreditsIncluded"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SubscriptionPlanListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPlanListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["priceExcludingTax"] = this.priceExcludingTax;
        data["taxRate"] = this.taxRate;
        data["priceIncludingTax"] = this.priceIncludingTax;
        data["currency"] = this.currency;
        data["intervalCount"] = this.intervalCount;
        data["tier"] = this.tier;
        data["interval"] = this.interval;
        data["monthlyCreditsIncluded"] = this.monthlyCreditsIncluded;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** Subscription plan data with explicit pre-tax and tax-inclusive pricing. */
export interface ISubscriptionPlanListItemDto {
    /** Unique identifier of the subscription plan. */
    id?: string;
    /** Stable plan code used by the checkout flow. */
    code?: string | undefined;
    /** Display name of the subscription plan. */
    name?: string | undefined;
    /** Optional marketing description of the subscription plan. */
    description?: string | undefined;
    /** Recurring plan price before tax for one billing interval. */
    priceExcludingTax?: number;
    /** Applied tax rate as a decimal fraction. For example, 0.23 represents 23%. */
    taxRate?: number;
    /** Recurring plan price including tax for one billing interval. This is the final amount charged before discounts. */
    priceIncludingTax?: number;
    /** ISO 4217 currency code used by all monetary fields in this response. */
    currency?: string | undefined;
    /** Number of interval units between renewals. */
    intervalCount?: number;
    tier?: SubscriptionTier;
    interval?: SubscriptionInterval;
    /** Monthly credit allowance included in the plan. */
    monthlyCreditsIncluded?: number;
    /** Indicates whether the plan is currently active and can be purchased. */
    isActive?: boolean;
}

export class SubscriptionRefundRequestEligibilityDto implements ISubscriptionRefundRequestEligibilityDto {
    canSubmit?: boolean;
    status?: SubscriptionRefundRequestEligibilityStatus;
    subscriptionId?: string | undefined;
    planCode?: string | undefined;
    planName?: string | undefined;
    startsAtUtc?: Date | undefined;
    eligibleUntilUtc?: Date | undefined;
    eligibilityWindowDays?: number;
    refundReasonRequired?: boolean;
    publicPolicyUrl?: string | undefined;
    officialContactEmail?: string | undefined;
    contact?: SupportContactDto;
    existingRequest?: SubscriptionRefundRequestSummaryDto;

    constructor(data?: ISubscriptionRefundRequestEligibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canSubmit = _data["canSubmit"];
            this.status = _data["status"];
            this.subscriptionId = _data["subscriptionId"];
            this.planCode = _data["planCode"];
            this.planName = _data["planName"];
            this.startsAtUtc = _data["startsAtUtc"] ? new Date(_data["startsAtUtc"].toString()) : undefined as any;
            this.eligibleUntilUtc = _data["eligibleUntilUtc"] ? new Date(_data["eligibleUntilUtc"].toString()) : undefined as any;
            this.eligibilityWindowDays = _data["eligibilityWindowDays"];
            this.refundReasonRequired = _data["refundReasonRequired"];
            this.publicPolicyUrl = _data["publicPolicyUrl"];
            this.officialContactEmail = _data["officialContactEmail"];
            this.contact = _data["contact"] ? SupportContactDto.fromJS(_data["contact"]) : undefined as any;
            this.existingRequest = _data["existingRequest"] ? SubscriptionRefundRequestSummaryDto.fromJS(_data["existingRequest"]) : undefined as any;
        }
    }

    static fromJS(data: any): SubscriptionRefundRequestEligibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRefundRequestEligibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canSubmit"] = this.canSubmit;
        data["status"] = this.status;
        data["subscriptionId"] = this.subscriptionId;
        data["planCode"] = this.planCode;
        data["planName"] = this.planName;
        data["startsAtUtc"] = this.startsAtUtc ? this.startsAtUtc.toISOString() : undefined as any;
        data["eligibleUntilUtc"] = this.eligibleUntilUtc ? this.eligibleUntilUtc.toISOString() : undefined as any;
        data["eligibilityWindowDays"] = this.eligibilityWindowDays;
        data["refundReasonRequired"] = this.refundReasonRequired;
        data["publicPolicyUrl"] = this.publicPolicyUrl;
        data["officialContactEmail"] = this.officialContactEmail;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["existingRequest"] = this.existingRequest ? this.existingRequest.toJSON() : undefined as any;
        return data;
    }
}

export interface ISubscriptionRefundRequestEligibilityDto {
    canSubmit?: boolean;
    status?: SubscriptionRefundRequestEligibilityStatus;
    subscriptionId?: string | undefined;
    planCode?: string | undefined;
    planName?: string | undefined;
    startsAtUtc?: Date | undefined;
    eligibleUntilUtc?: Date | undefined;
    eligibilityWindowDays?: number;
    refundReasonRequired?: boolean;
    publicPolicyUrl?: string | undefined;
    officialContactEmail?: string | undefined;
    contact?: SupportContactDto;
    existingRequest?: SubscriptionRefundRequestSummaryDto;
}

export enum SubscriptionRefundRequestEligibilityStatus {
    Eligible = "Eligible",
    AlreadyRequested = "AlreadyRequested",
    NoActiveProSubscription = "NoActiveProSubscription",
    WindowExpired = "WindowExpired",
    PaymentNotRefundable = "PaymentNotRefundable",
}

export enum SubscriptionRefundRequestStatus {
    Pending = "Pending",
    Processed = "Processed",
    Rejected = "Rejected",
}

export class SubscriptionRefundRequestSummaryDto implements ISubscriptionRefundRequestSummaryDto {
    id?: string;
    contactEmail?: string | undefined;
    reason?: string | undefined;
    status?: SubscriptionRefundRequestStatus;
    createdAtUtc?: Date;
    eligibleUntilUtc?: Date;
    eligibilityWindowDaysAtRequest?: number | undefined;
    refundPolicyUrl?: string | undefined;
    contact?: SupportContactDto;
    paidAtUtc?: Date | undefined;
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    immediateStartConsentRequired?: boolean | undefined;
    immediateStartConsentAccepted?: boolean | undefined;
    processedAtUtc?: Date | undefined;
    adminNotes?: string | undefined;

    constructor(data?: ISubscriptionRefundRequestSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactEmail = _data["contactEmail"];
            this.reason = _data["reason"];
            this.status = _data["status"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.eligibleUntilUtc = _data["eligibleUntilUtc"] ? new Date(_data["eligibleUntilUtc"].toString()) : undefined as any;
            this.eligibilityWindowDaysAtRequest = _data["eligibilityWindowDaysAtRequest"];
            this.refundPolicyUrl = _data["refundPolicyUrl"];
            this.contact = _data["contact"] ? SupportContactDto.fromJS(_data["contact"]) : undefined as any;
            this.paidAtUtc = _data["paidAtUtc"] ? new Date(_data["paidAtUtc"].toString()) : undefined as any;
            this.legalVersion = _data["legalVersion"];
            this.legalLastUpdated = _data["legalLastUpdated"];
            this.immediateStartConsentRequired = _data["immediateStartConsentRequired"];
            this.immediateStartConsentAccepted = _data["immediateStartConsentAccepted"];
            this.processedAtUtc = _data["processedAtUtc"] ? new Date(_data["processedAtUtc"].toString()) : undefined as any;
            this.adminNotes = _data["adminNotes"];
        }
    }

    static fromJS(data: any): SubscriptionRefundRequestSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRefundRequestSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactEmail"] = this.contactEmail;
        data["reason"] = this.reason;
        data["status"] = this.status;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["eligibleUntilUtc"] = this.eligibleUntilUtc ? this.eligibleUntilUtc.toISOString() : undefined as any;
        data["eligibilityWindowDaysAtRequest"] = this.eligibilityWindowDaysAtRequest;
        data["refundPolicyUrl"] = this.refundPolicyUrl;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["paidAtUtc"] = this.paidAtUtc ? this.paidAtUtc.toISOString() : undefined as any;
        data["legalVersion"] = this.legalVersion;
        data["legalLastUpdated"] = this.legalLastUpdated;
        data["immediateStartConsentRequired"] = this.immediateStartConsentRequired;
        data["immediateStartConsentAccepted"] = this.immediateStartConsentAccepted;
        data["processedAtUtc"] = this.processedAtUtc ? this.processedAtUtc.toISOString() : undefined as any;
        data["adminNotes"] = this.adminNotes;
        return data;
    }
}

export interface ISubscriptionRefundRequestSummaryDto {
    id?: string;
    contactEmail?: string | undefined;
    reason?: string | undefined;
    status?: SubscriptionRefundRequestStatus;
    createdAtUtc?: Date;
    eligibleUntilUtc?: Date;
    eligibilityWindowDaysAtRequest?: number | undefined;
    refundPolicyUrl?: string | undefined;
    contact?: SupportContactDto;
    paidAtUtc?: Date | undefined;
    legalVersion?: string | undefined;
    legalLastUpdated?: string | undefined;
    immediateStartConsentRequired?: boolean | undefined;
    immediateStartConsentAccepted?: boolean | undefined;
    processedAtUtc?: Date | undefined;
    adminNotes?: string | undefined;
}

export enum SubscriptionTier {
    Basic = "Basic",
    Pro = "Pro",
}

export class SupportContactDto implements ISupportContactDto {
    companyName?: string | undefined;
    supportEmail?: string | undefined;
    supportPhone?: string | undefined;
    websiteUrl?: string | undefined;

    constructor(data?: ISupportContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.supportEmail = _data["supportEmail"];
            this.supportPhone = _data["supportPhone"];
            this.websiteUrl = _data["websiteUrl"];
        }
    }

    static fromJS(data: any): SupportContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupportContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["supportEmail"] = this.supportEmail;
        data["supportPhone"] = this.supportPhone;
        data["websiteUrl"] = this.websiteUrl;
        return data;
    }
}

export interface ISupportContactDto {
    companyName?: string | undefined;
    supportEmail?: string | undefined;
    supportPhone?: string | undefined;
    websiteUrl?: string | undefined;
}

export class TemporalCandidate implements ITemporalCandidate {
    granularity?: TemporalGranularity;
    type?: string | undefined;
    timex?: string | undefined;
    startLocal?: Date | undefined;
    endLocal?: Date | undefined;
    sourceText?: string | undefined;

    constructor(data?: ITemporalCandidate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.granularity = _data["granularity"];
            this.type = _data["type"];
            this.timex = _data["timex"];
            this.startLocal = _data["startLocal"] ? new Date(_data["startLocal"].toString()) : undefined as any;
            this.endLocal = _data["endLocal"] ? new Date(_data["endLocal"].toString()) : undefined as any;
            this.sourceText = _data["sourceText"];
        }
    }

    static fromJS(data: any): TemporalCandidate {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalCandidate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["granularity"] = this.granularity;
        data["type"] = this.type;
        data["timex"] = this.timex;
        data["startLocal"] = this.startLocal ? this.startLocal.toISOString() : undefined as any;
        data["endLocal"] = this.endLocal ? this.endLocal.toISOString() : undefined as any;
        data["sourceText"] = this.sourceText;
        return data;
    }
}

export interface ITemporalCandidate {
    granularity?: TemporalGranularity;
    type?: string | undefined;
    timex?: string | undefined;
    startLocal?: Date | undefined;
    endLocal?: Date | undefined;
    sourceText?: string | undefined;
}

export enum TemporalGranularity {
    Instant = "Instant",
    Date = "Date",
    DateRange = "DateRange",
    DateTimeRange = "DateTimeRange",
}

export class TemporalParseRequest implements ITemporalParseRequest {
    text?: string | undefined;
    referenceLocalDateTime?: Date;
    culture?: string | undefined;

    constructor(data?: ITemporalParseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.referenceLocalDateTime = _data["referenceLocalDateTime"] ? new Date(_data["referenceLocalDateTime"].toString()) : undefined as any;
            this.culture = _data["culture"];
        }
    }

    static fromJS(data: any): TemporalParseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalParseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["referenceLocalDateTime"] = this.referenceLocalDateTime ? this.referenceLocalDateTime.toISOString() : undefined as any;
        data["culture"] = this.culture;
        return data;
    }
}

export interface ITemporalParseRequest {
    text?: string | undefined;
    referenceLocalDateTime?: Date;
    culture?: string | undefined;
}

export class TemporalParseResult implements ITemporalParseResult {
    candidates?: TemporalCandidate[] | undefined;

    constructor(data?: ITemporalParseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["candidates"])) {
                this.candidates = [] as any;
                for (let item of _data["candidates"])
                    this.candidates!.push(TemporalCandidate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemporalParseResult {
        data = typeof data === 'object' ? data : {};
        let result = new TemporalParseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.candidates)) {
            data["candidates"] = [];
            for (let item of this.candidates)
                data["candidates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITemporalParseResult {
    candidates?: TemporalCandidate[] | undefined;
}

export class TickerAddress implements ITickerAddress {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: ITickerAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): TickerAddress {
        data = typeof data === 'object' ? data : {};
        let result = new TickerAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface ITickerAddress {
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    postalCode?: string | undefined;
}

export class TickerBranding implements ITickerBranding {
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    iconBase64?: string | undefined;
    iconMediaType?: string | undefined;

    constructor(data?: ITickerBranding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoBase64 = _data["logoBase64"];
            this.logoMediaType = _data["logoMediaType"];
            this.iconBase64 = _data["iconBase64"];
            this.iconMediaType = _data["iconMediaType"];
        }
    }

    static fromJS(data: any): TickerBranding {
        data = typeof data === 'object' ? data : {};
        let result = new TickerBranding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoBase64"] = this.logoBase64;
        data["logoMediaType"] = this.logoMediaType;
        data["iconBase64"] = this.iconBase64;
        data["iconMediaType"] = this.iconMediaType;
        return data;
    }
}

export interface ITickerBranding {
    logoBase64?: string | undefined;
    logoMediaType?: string | undefined;
    iconBase64?: string | undefined;
    iconMediaType?: string | undefined;
}

export class TickerDetails implements ITickerDetails {
    ticker?: string | undefined;
    name?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
    currencyName?: string | undefined;
    cik?: string | undefined;
    compositeFigi?: string | undefined;
    shareClassFigi?: string | undefined;
    marketCap?: number | undefined;
    phoneNumber?: string | undefined;
    address?: TickerAddress;
    descriptions?: { [key: string]: string; } | undefined;
    sicCode?: string | undefined;
    sicDescriptions?: { [key: string]: string; } | undefined;
    tickerRoot?: string | undefined;
    homepageUrl?: string | undefined;
    totalEmployees?: number | undefined;
    listDate?: string | undefined;
    branding?: TickerBranding;
    shareClassSharesOutstanding?: number | undefined;
    weightedSharesOutstanding?: number | undefined;
    roundLot?: number | undefined;

    constructor(data?: ITickerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["ticker"];
            this.name = _data["name"];
            this.market = _data["market"];
            this.locale = _data["locale"];
            this.primaryExchange = _data["primaryExchange"];
            this.type = _data["type"];
            this.active = _data["active"];
            this.currencyName = _data["currencyName"];
            this.cik = _data["cik"];
            this.compositeFigi = _data["compositeFigi"];
            this.shareClassFigi = _data["shareClassFigi"];
            this.marketCap = _data["marketCap"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"] ? TickerAddress.fromJS(_data["address"]) : undefined as any;
            if (_data["descriptions"]) {
                this.descriptions = {} as any;
                for (let key in _data["descriptions"]) {
                    if (_data["descriptions"].hasOwnProperty(key))
                        (this.descriptions as any)![key] = _data["descriptions"][key];
                }
            }
            this.sicCode = _data["sicCode"];
            if (_data["sicDescriptions"]) {
                this.sicDescriptions = {} as any;
                for (let key in _data["sicDescriptions"]) {
                    if (_data["sicDescriptions"].hasOwnProperty(key))
                        (this.sicDescriptions as any)![key] = _data["sicDescriptions"][key];
                }
            }
            this.tickerRoot = _data["tickerRoot"];
            this.homepageUrl = _data["homepageUrl"];
            this.totalEmployees = _data["totalEmployees"];
            this.listDate = _data["listDate"];
            this.branding = _data["branding"] ? TickerBranding.fromJS(_data["branding"]) : undefined as any;
            this.shareClassSharesOutstanding = _data["shareClassSharesOutstanding"];
            this.weightedSharesOutstanding = _data["weightedSharesOutstanding"];
            this.roundLot = _data["roundLot"];
        }
    }

    static fromJS(data: any): TickerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TickerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticker"] = this.ticker;
        data["name"] = this.name;
        data["market"] = this.market;
        data["locale"] = this.locale;
        data["primaryExchange"] = this.primaryExchange;
        data["type"] = this.type;
        data["active"] = this.active;
        data["currencyName"] = this.currencyName;
        data["cik"] = this.cik;
        data["compositeFigi"] = this.compositeFigi;
        data["shareClassFigi"] = this.shareClassFigi;
        data["marketCap"] = this.marketCap;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        if (this.descriptions) {
            data["descriptions"] = {};
            for (let key in this.descriptions) {
                if (this.descriptions.hasOwnProperty(key))
                    (data["descriptions"] as any)[key] = (this.descriptions as any)[key];
            }
        }
        data["sicCode"] = this.sicCode;
        if (this.sicDescriptions) {
            data["sicDescriptions"] = {};
            for (let key in this.sicDescriptions) {
                if (this.sicDescriptions.hasOwnProperty(key))
                    (data["sicDescriptions"] as any)[key] = (this.sicDescriptions as any)[key];
            }
        }
        data["tickerRoot"] = this.tickerRoot;
        data["homepageUrl"] = this.homepageUrl;
        data["totalEmployees"] = this.totalEmployees;
        data["listDate"] = this.listDate;
        data["branding"] = this.branding ? this.branding.toJSON() : undefined as any;
        data["shareClassSharesOutstanding"] = this.shareClassSharesOutstanding;
        data["weightedSharesOutstanding"] = this.weightedSharesOutstanding;
        data["roundLot"] = this.roundLot;
        return data;
    }
}

export interface ITickerDetails {
    ticker?: string | undefined;
    name?: string | undefined;
    market?: string | undefined;
    locale?: string | undefined;
    primaryExchange?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
    currencyName?: string | undefined;
    cik?: string | undefined;
    compositeFigi?: string | undefined;
    shareClassFigi?: string | undefined;
    marketCap?: number | undefined;
    phoneNumber?: string | undefined;
    address?: TickerAddress;
    descriptions?: { [key: string]: string; } | undefined;
    sicCode?: string | undefined;
    sicDescriptions?: { [key: string]: string; } | undefined;
    tickerRoot?: string | undefined;
    homepageUrl?: string | undefined;
    totalEmployees?: number | undefined;
    listDate?: string | undefined;
    branding?: TickerBranding;
    shareClassSharesOutstanding?: number | undefined;
    weightedSharesOutstanding?: number | undefined;
    roundLot?: number | undefined;
}

export class TickerDetailsResponse implements ITickerDetailsResponse {
    requestId?: string | undefined;
    results?: TickerDetails;
    status?: string | undefined;

    constructor(data?: ITickerDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.results = _data["results"] ? TickerDetails.fromJS(_data["results"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TickerDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TickerDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["results"] = this.results ? this.results.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface ITickerDetailsResponse {
    requestId?: string | undefined;
    results?: TickerDetails;
    status?: string | undefined;
}

export class TrainAssetModelRequestDto implements ITrainAssetModelRequestDto {
    ticker!: string;
    csvPath!: string;
    days?: number | undefined;

    constructor(data?: ITrainAssetModelRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticker = _data["ticker"];
            this.csvPath = _data["csvPath"];
            this.days = _data["days"];
        }
    }

    static fromJS(data: any): TrainAssetModelRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainAssetModelRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticker"] = this.ticker;
        data["csvPath"] = this.csvPath;
        data["days"] = this.days;
        return data;
    }
}

export interface ITrainAssetModelRequestDto {
    ticker: string;
    csvPath: string;
    days?: number | undefined;
}

export class TransitAspectDto implements ITransitAspectDto {
    p1?: Planets;
    p2?: Planets;
    type?: Aspects;
    orb?: number;
    applying?: boolean;
    strength?: number;

    constructor(data?: ITransitAspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.p1 = _data["p1"];
            this.p2 = _data["p2"];
            this.type = _data["type"];
            this.orb = _data["orb"];
            this.applying = _data["applying"];
            this.strength = _data["strength"];
        }
    }

    static fromJS(data: any): TransitAspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitAspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["p1"] = this.p1;
        data["p2"] = this.p2;
        data["type"] = this.type;
        data["orb"] = this.orb;
        data["applying"] = this.applying;
        data["strength"] = this.strength;
        return data;
    }
}

export interface ITransitAspectDto {
    p1?: Planets;
    p2?: Planets;
    type?: Aspects;
    orb?: number;
    applying?: boolean;
    strength?: number;
}

export class TransitDayDto implements ITransitDayDto {
    date?: Date;
    aspects?: TransitAspectDto[] | undefined;

    constructor(data?: ITransitDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["aspects"])) {
                this.aspects = [] as any;
                for (let item of _data["aspects"])
                    this.aspects!.push(TransitAspectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransitDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        if (Array.isArray(this.aspects)) {
            data["aspects"] = [];
            for (let item of this.aspects)
                data["aspects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITransitDayDto {
    date?: Date;
    aspects?: TransitAspectDto[] | undefined;
}

export class TransitEvaluation implements ITransitEvaluation {
    date?: Date;
    percentAbsolute?: number;
    percentRelative?: number;
    aspectForecasts?: AspectForecast[] | undefined;
    globalForecast?: string | undefined;

    constructor(data?: ITransitEvaluation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.percentAbsolute = _data["percentAbsolute"];
            this.percentRelative = _data["percentRelative"];
            if (Array.isArray(_data["aspectForecasts"])) {
                this.aspectForecasts = [] as any;
                for (let item of _data["aspectForecasts"])
                    this.aspectForecasts!.push(AspectForecast.fromJS(item));
            }
            this.globalForecast = _data["globalForecast"];
        }
    }

    static fromJS(data: any): TransitEvaluation {
        data = typeof data === 'object' ? data : {};
        let result = new TransitEvaluation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["percentAbsolute"] = this.percentAbsolute;
        data["percentRelative"] = this.percentRelative;
        if (Array.isArray(this.aspectForecasts)) {
            data["aspectForecasts"] = [];
            for (let item of this.aspectForecasts)
                data["aspectForecasts"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalForecast"] = this.globalForecast;
        return data;
    }
}

export interface ITransitEvaluation {
    date?: Date;
    percentAbsolute?: number;
    percentRelative?: number;
    aspectForecasts?: AspectForecast[] | undefined;
    globalForecast?: string | undefined;
}

export class TransitProfileSettings implements ITransitProfileSettings {
    pairWeights?: { [key: string]: number; } | undefined;
    taggedPairWeights?: { [key: string]: { [key: string]: number; }; } | undefined;
    transitPlanetWeights?: TransitPlanetWeights | undefined;
    natalSensitivity?: NatalSensitivity | undefined;
    aspectWeights?: AspectWeights | undefined;
    applyingBoost?: number;
    moonAttenuation?: number;
    weightClamp?: Range;
    aspectPolarity?: AspectPolarity | undefined;
    conjunctionOverrides?: { [key: string]: number; } | undefined;
    profile?: ProfileMetadata;

    constructor(data?: ITransitProfileSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["pairWeights"]) {
                this.pairWeights = {} as any;
                for (let key in _data["pairWeights"]) {
                    if (_data["pairWeights"].hasOwnProperty(key))
                        (this.pairWeights as any)![key] = _data["pairWeights"][key];
                }
            }
            if (_data["taggedPairWeights"]) {
                this.taggedPairWeights = {} as any;
                for (let key in _data["taggedPairWeights"]) {
                    if (_data["taggedPairWeights"].hasOwnProperty(key))
                        (this.taggedPairWeights as any)![key] = _data["taggedPairWeights"][key] !== undefined ? _data["taggedPairWeights"][key] : {};
                }
            }
            this.transitPlanetWeights = _data["transitPlanetWeights"] ? TransitPlanetWeights.fromJS(_data["transitPlanetWeights"]) : undefined as any;
            this.natalSensitivity = _data["natalSensitivity"] ? NatalSensitivity.fromJS(_data["natalSensitivity"]) : undefined as any;
            this.aspectWeights = _data["aspectWeights"] ? AspectWeights.fromJS(_data["aspectWeights"]) : undefined as any;
            this.applyingBoost = _data["applyingBoost"];
            this.moonAttenuation = _data["moonAttenuation"];
            this.weightClamp = _data["weightClamp"] ? Range.fromJS(_data["weightClamp"]) : undefined as any;
            this.aspectPolarity = _data["aspectPolarity"] ? AspectPolarity.fromJS(_data["aspectPolarity"]) : undefined as any;
            if (_data["conjunctionOverrides"]) {
                this.conjunctionOverrides = {} as any;
                for (let key in _data["conjunctionOverrides"]) {
                    if (_data["conjunctionOverrides"].hasOwnProperty(key))
                        (this.conjunctionOverrides as any)![key] = _data["conjunctionOverrides"][key];
                }
            }
            this.profile = _data["profile"] ? ProfileMetadata.fromJS(_data["profile"]) : undefined as any;
        }
    }

    static fromJS(data: any): TransitProfileSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TransitProfileSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.pairWeights) {
            data["pairWeights"] = {};
            for (let key in this.pairWeights) {
                if (this.pairWeights.hasOwnProperty(key))
                    (data["pairWeights"] as any)[key] = (this.pairWeights as any)[key];
            }
        }
        if (this.taggedPairWeights) {
            data["taggedPairWeights"] = {};
            for (let key in this.taggedPairWeights) {
                if (this.taggedPairWeights.hasOwnProperty(key))
                    (data["taggedPairWeights"] as any)[key] = (this.taggedPairWeights as any)[key];
            }
        }
        data["transitPlanetWeights"] = this.transitPlanetWeights ? this.transitPlanetWeights.toJSON() : undefined as any;
        data["natalSensitivity"] = this.natalSensitivity ? this.natalSensitivity.toJSON() : undefined as any;
        data["aspectWeights"] = this.aspectWeights ? this.aspectWeights.toJSON() : undefined as any;
        data["applyingBoost"] = this.applyingBoost;
        data["moonAttenuation"] = this.moonAttenuation;
        data["weightClamp"] = this.weightClamp ? this.weightClamp.toJSON() : undefined as any;
        data["aspectPolarity"] = this.aspectPolarity ? this.aspectPolarity.toJSON() : undefined as any;
        if (this.conjunctionOverrides) {
            data["conjunctionOverrides"] = {};
            for (let key in this.conjunctionOverrides) {
                if (this.conjunctionOverrides.hasOwnProperty(key))
                    (data["conjunctionOverrides"] as any)[key] = (this.conjunctionOverrides as any)[key];
            }
        }
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        return data;
    }
}

export interface ITransitProfileSettings {
    pairWeights?: { [key: string]: number; } | undefined;
    taggedPairWeights?: { [key: string]: { [key: string]: number; }; } | undefined;
    transitPlanetWeights?: TransitPlanetWeights | undefined;
    natalSensitivity?: NatalSensitivity | undefined;
    aspectWeights?: AspectWeights | undefined;
    applyingBoost?: number;
    moonAttenuation?: number;
    weightClamp?: Range;
    aspectPolarity?: AspectPolarity | undefined;
    conjunctionOverrides?: { [key: string]: number; } | undefined;
    profile?: ProfileMetadata;
}

export class UpdateUserDto implements IUpdateUserDto {
    name?: string | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        return data;
    }
}

export interface IUpdateUserDto {
    name?: string | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
}

export class User implements IUser {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    type?: string | undefined;
    natalChart?: NatalChartResult;
    authId?: string | undefined;
    name?: string | undefined;
    publicId?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    latitude?: number;
    longitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    tzId?: string | undefined;
    natalReading?: string | undefined;
    isBanned?: boolean;
    bannedUntil?: Date | undefined;
    externalPaymentCustomerId?: string | undefined;
    favoriteAssets?: UserFavoriteAsset[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.type = _data["type"];
            this.natalChart = _data["natalChart"] ? NatalChartResult.fromJS(_data["natalChart"]) : undefined as any;
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.publicId = _data["publicId"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.tzId = _data["tzId"];
            this.natalReading = _data["natalReading"];
            this.isBanned = _data["isBanned"];
            this.bannedUntil = _data["bannedUntil"] ? new Date(_data["bannedUntil"].toString()) : undefined as any;
            this.externalPaymentCustomerId = _data["externalPaymentCustomerId"];
            if (Array.isArray(_data["favoriteAssets"])) {
                this.favoriteAssets = [] as any;
                for (let item of _data["favoriteAssets"])
                    this.favoriteAssets!.push(UserFavoriteAsset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["type"] = this.type;
        data["natalChart"] = this.natalChart ? this.natalChart.toJSON() : undefined as any;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["publicId"] = this.publicId;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        data["tzId"] = this.tzId;
        data["natalReading"] = this.natalReading;
        data["isBanned"] = this.isBanned;
        data["bannedUntil"] = this.bannedUntil ? this.bannedUntil.toISOString() : undefined as any;
        data["externalPaymentCustomerId"] = this.externalPaymentCustomerId;
        if (Array.isArray(this.favoriteAssets)) {
            data["favoriteAssets"] = [];
            for (let item of this.favoriteAssets)
                data["favoriteAssets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUser {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    type?: string | undefined;
    natalChart?: NatalChartResult;
    authId?: string | undefined;
    name?: string | undefined;
    publicId?: string | undefined;
    birthDateTime?: Date;
    birthPlace?: string | undefined;
    latitude?: number;
    longitude?: number;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    tzId?: string | undefined;
    natalReading?: string | undefined;
    isBanned?: boolean;
    bannedUntil?: Date | undefined;
    externalPaymentCustomerId?: string | undefined;
    favoriteAssets?: UserFavoriteAsset[] | undefined;
}

export enum UserCreditTransactionReason {
    AiChatQuestion = "AiChatQuestion",
    CreateAssociatedNatalChart = "CreateAssociatedNatalChart",
    UpdateBirthRecord = "UpdateBirthRecord",
}

export class UserDto implements IUserDto {
    id?: string;
    createdAtUtc?: Date | undefined;
    updatedAtUtc?: Date | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    publicId?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.UserDto.BirthLocalDate and AstroAI.Api.Dtos.UserDto.BirthLocalTime to show it. */
    birthDateTime?: Date | undefined;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    birthPlace?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    tzId?: string | undefined;
    natalReading?: string | undefined;
    isBanned?: boolean | undefined;
    bannedUntil?: Date | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.authId = _data["authId"];
            this.name = _data["name"];
            this.publicId = _data["publicId"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthLocalDate = _data["birthLocalDate"];
            this.birthLocalTime = _data["birthLocalTime"];
            this.birthPlace = _data["birthPlace"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.language = _data["language"];
            this.treatmentPreference = _data["treatmentPreference"];
            this.tzId = _data["tzId"];
            this.natalReading = _data["natalReading"];
            this.isBanned = _data["isBanned"];
            this.bannedUntil = _data["bannedUntil"] ? new Date(_data["bannedUntil"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["authId"] = this.authId;
        data["name"] = this.name;
        data["publicId"] = this.publicId;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthLocalDate"] = this.birthLocalDate;
        data["birthLocalTime"] = this.birthLocalTime;
        data["birthPlace"] = this.birthPlace;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["language"] = this.language;
        data["treatmentPreference"] = this.treatmentPreference;
        data["tzId"] = this.tzId;
        data["natalReading"] = this.natalReading;
        data["isBanned"] = this.isBanned;
        data["bannedUntil"] = this.bannedUntil ? this.bannedUntil.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserDto {
    id?: string;
    createdAtUtc?: Date | undefined;
    updatedAtUtc?: Date | undefined;
    authId?: string | undefined;
    name?: string | undefined;
    publicId?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.UserDto.BirthLocalDate and AstroAI.Api.Dtos.UserDto.BirthLocalTime to show it. */
    birthDateTime?: Date | undefined;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    birthPlace?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    language?: string | undefined;
    treatmentPreference?: UserTreatmentPreference;
    tzId?: string | undefined;
    natalReading?: string | undefined;
    isBanned?: boolean | undefined;
    bannedUntil?: Date | undefined;
}

export class UserFavoriteAsset implements IUserFavoriteAsset {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    assetId?: string;
    asset?: Asset;

    constructor(data?: IUserFavoriteAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? Asset.fromJS(_data["asset"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserFavoriteAsset {
        data = typeof data === 'object' ? data : {};
        let result = new UserFavoriteAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserFavoriteAsset {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    assetId?: string;
    asset?: Asset;
}

export class UserNatalChartListItemDto implements IUserNatalChartListItemDto {
    id?: string;
    name?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.UserNatalChartListItemDto.BirthLocalDate and AstroAI.Api.Dtos.UserNatalChartListItemDto.BirthLocalTime to show it. */
    birthDateTime?: Date;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    timeZone?: string | undefined;
    isPrimary?: boolean;

    constructor(data?: IUserNatalChartListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.birthDateTime = _data["birthDateTime"] ? new Date(_data["birthDateTime"].toString()) : undefined as any;
            this.birthLocalDate = _data["birthLocalDate"];
            this.birthLocalTime = _data["birthLocalTime"];
            this.timeZone = _data["timeZone"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): UserNatalChartListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNatalChartListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["birthDateTime"] = this.birthDateTime ? this.birthDateTime.toISOString() : undefined as any;
        data["birthLocalDate"] = this.birthLocalDate;
        data["birthLocalTime"] = this.birthLocalTime;
        data["timeZone"] = this.timeZone;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IUserNatalChartListItemDto {
    id?: string;
    name?: string | undefined;
    /** UTC instant of the birth. Not the civil clock: use AstroAI.Api.Dtos.UserNatalChartListItemDto.BirthLocalDate and AstroAI.Api.Dtos.UserNatalChartListItemDto.BirthLocalTime to show it. */
    birthDateTime?: Date;
    /** Civil birth date at the birth place (yyyy-MM-dd); null when the time zone cannot be resolved. */
    birthLocalDate?: string | undefined;
    /** Civil birth time at the birth place (HH:mm, 24 hour); null when the time zone cannot be resolved. */
    birthLocalTime?: string | undefined;
    timeZone?: string | undefined;
    isPrimary?: boolean;
}

export class UserNatalChartsResponseDto implements IUserNatalChartsResponseDto {
    maxAssociatedCharts?: number;
    associatedChartsCount?: number;
    charts?: UserNatalChartListItemDto[] | undefined;

    constructor(data?: IUserNatalChartsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAssociatedCharts = _data["maxAssociatedCharts"];
            this.associatedChartsCount = _data["associatedChartsCount"];
            if (Array.isArray(_data["charts"])) {
                this.charts = [] as any;
                for (let item of _data["charts"])
                    this.charts!.push(UserNatalChartListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserNatalChartsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserNatalChartsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAssociatedCharts"] = this.maxAssociatedCharts;
        data["associatedChartsCount"] = this.associatedChartsCount;
        if (Array.isArray(this.charts)) {
            data["charts"] = [];
            for (let item of this.charts)
                data["charts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserNatalChartsResponseDto {
    maxAssociatedCharts?: number;
    associatedChartsCount?: number;
    charts?: UserNatalChartListItemDto[] | undefined;
}

export enum UserRole {
    Admin = "Admin",
    User = "User",
}

export enum UserStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class UserSubscription implements IUserSubscription {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    planId?: string;
    plan?: SubscriptionPlan;
    status?: UserSubscriptionStatus;
    startsAtUtc?: Date;
    endsAtUtc?: Date | undefined;
    canceledAtUtc?: Date | undefined;
    sourceOrderId?: string | undefined;
    lastPaymentId?: string | undefined;

    constructor(data?: IUserSubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.updatedAtUtc = _data["updatedAtUtc"] ? new Date(_data["updatedAtUtc"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            this.planId = _data["planId"];
            this.plan = _data["plan"] ? SubscriptionPlan.fromJS(_data["plan"]) : undefined as any;
            this.status = _data["status"];
            this.startsAtUtc = _data["startsAtUtc"] ? new Date(_data["startsAtUtc"].toString()) : undefined as any;
            this.endsAtUtc = _data["endsAtUtc"] ? new Date(_data["endsAtUtc"].toString()) : undefined as any;
            this.canceledAtUtc = _data["canceledAtUtc"] ? new Date(_data["canceledAtUtc"].toString()) : undefined as any;
            this.sourceOrderId = _data["sourceOrderId"];
            this.lastPaymentId = _data["lastPaymentId"];
        }
    }

    static fromJS(data: any): UserSubscription {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["updatedAtUtc"] = this.updatedAtUtc ? this.updatedAtUtc.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["planId"] = this.planId;
        data["plan"] = this.plan ? this.plan.toJSON() : undefined as any;
        data["status"] = this.status;
        data["startsAtUtc"] = this.startsAtUtc ? this.startsAtUtc.toISOString() : undefined as any;
        data["endsAtUtc"] = this.endsAtUtc ? this.endsAtUtc.toISOString() : undefined as any;
        data["canceledAtUtc"] = this.canceledAtUtc ? this.canceledAtUtc.toISOString() : undefined as any;
        data["sourceOrderId"] = this.sourceOrderId;
        data["lastPaymentId"] = this.lastPaymentId;
        return data;
    }
}

export interface IUserSubscription {
    id?: string;
    createdAtUtc?: Date;
    updatedAtUtc?: Date | undefined;
    userId?: string;
    user?: User;
    planId?: string;
    plan?: SubscriptionPlan;
    status?: UserSubscriptionStatus;
    startsAtUtc?: Date;
    endsAtUtc?: Date | undefined;
    canceledAtUtc?: Date | undefined;
    sourceOrderId?: string | undefined;
    lastPaymentId?: string | undefined;
}

export class UserSubscriptionPagedResultDto implements IUserSubscriptionPagedResultDto {
    items!: UserSubscription[] | undefined;
    page!: number;
    pageSize!: number;
    totalCount!: number;

    constructor(data?: IUserSubscriptionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserSubscription.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserSubscriptionPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSubscriptionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IUserSubscriptionPagedResultDto {
    items: UserSubscription[] | undefined;
    page: number;
    pageSize: number;
    totalCount: number;
}

export enum UserSubscriptionStatus {
    Trial = "Trial",
    Active = "Active",
    Expired = "Expired",
    Canceled = "Canceled",
}

export enum UserTreatmentPreference {
    Masculine = "Masculine",
    Feminine = "Feminine",
}

export class WindowProfileResult implements IWindowProfileResult {
    profileKey?: string | undefined;
    transitEvaluations?: TransitEvaluation[] | undefined;
    avgPercentAbsolute?: number;
    avgPercentRelative?: number;
    globalForecast?: string | undefined;

    constructor(data?: IWindowProfileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileKey = _data["profileKey"];
            if (Array.isArray(_data["transitEvaluations"])) {
                this.transitEvaluations = [] as any;
                for (let item of _data["transitEvaluations"])
                    this.transitEvaluations!.push(TransitEvaluation.fromJS(item));
            }
            this.avgPercentAbsolute = _data["avgPercentAbsolute"];
            this.avgPercentRelative = _data["avgPercentRelative"];
            this.globalForecast = _data["globalForecast"];
        }
    }

    static fromJS(data: any): WindowProfileResult {
        data = typeof data === 'object' ? data : {};
        let result = new WindowProfileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileKey"] = this.profileKey;
        if (Array.isArray(this.transitEvaluations)) {
            data["transitEvaluations"] = [];
            for (let item of this.transitEvaluations)
                data["transitEvaluations"].push(item ? item.toJSON() : undefined as any);
        }
        data["avgPercentAbsolute"] = this.avgPercentAbsolute;
        data["avgPercentRelative"] = this.avgPercentRelative;
        data["globalForecast"] = this.globalForecast;
        return data;
    }
}

export interface IWindowProfileResult {
    profileKey?: string | undefined;
    transitEvaluations?: TransitEvaluation[] | undefined;
    avgPercentAbsolute?: number;
    avgPercentRelative?: number;
    globalForecast?: string | undefined;
}

export enum Zodiac {
    Aries = "Aries",
    Taurus = "Taurus",
    Gemini = "Gemini",
    Cancer = "Cancer",
    Leo = "Leo",
    Virgo = "Virgo",
    Libra = "Libra",
    Scorpio = "Scorpio",
    Sagittarius = "Sagittarius",
    Capricorn = "Capricorn",
    Aquarius = "Aquarius",
    Pisces = "Pisces",
}

export class RetroMultipliers implements IRetroMultipliers {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;

    constructor(data?: IRetroMultipliers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sun = _data["Sun"];
            this.moon = _data["Moon"];
            this.mercury = _data["Mercury"];
            this.venus = _data["Venus"];
            this.mars = _data["Mars"];
            this.jupiter = _data["Jupiter"];
            this.saturn = _data["Saturn"];
            this.uranus = _data["Uranus"];
            this.neptune = _data["Neptune"];
            this.pluto = _data["Pluto"];
            this.northNode = _data["NorthNode"];
            this.southNode = _data["SouthNode"];
            this.chiron = _data["Chiron"];
            this.earth = _data["Earth"];
            this.pholus = _data["Pholus"];
            this.ceres = _data["Ceres"];
            this.pallas = _data["Pallas"];
            this.juno = _data["Juno"];
            this.vesta = _data["Vesta"];
            this.lilith = _data["Lilith"];
        }
    }

    static fromJS(data: any): RetroMultipliers {
        data = typeof data === 'object' ? data : {};
        let result = new RetroMultipliers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sun"] = this.sun;
        data["Moon"] = this.moon;
        data["Mercury"] = this.mercury;
        data["Venus"] = this.venus;
        data["Mars"] = this.mars;
        data["Jupiter"] = this.jupiter;
        data["Saturn"] = this.saturn;
        data["Uranus"] = this.uranus;
        data["Neptune"] = this.neptune;
        data["Pluto"] = this.pluto;
        data["NorthNode"] = this.northNode;
        data["SouthNode"] = this.southNode;
        data["Chiron"] = this.chiron;
        data["Earth"] = this.earth;
        data["Pholus"] = this.pholus;
        data["Ceres"] = this.ceres;
        data["Pallas"] = this.pallas;
        data["Juno"] = this.juno;
        data["Vesta"] = this.vesta;
        data["Lilith"] = this.lilith;
        return data;
    }
}

export interface IRetroMultipliers {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;
}

export class TransitPlanetWeights implements ITransitPlanetWeights {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;

    constructor(data?: ITransitPlanetWeights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sun = _data["Sun"];
            this.moon = _data["Moon"];
            this.mercury = _data["Mercury"];
            this.venus = _data["Venus"];
            this.mars = _data["Mars"];
            this.jupiter = _data["Jupiter"];
            this.saturn = _data["Saturn"];
            this.uranus = _data["Uranus"];
            this.neptune = _data["Neptune"];
            this.pluto = _data["Pluto"];
            this.northNode = _data["NorthNode"];
            this.southNode = _data["SouthNode"];
            this.chiron = _data["Chiron"];
            this.earth = _data["Earth"];
            this.pholus = _data["Pholus"];
            this.ceres = _data["Ceres"];
            this.pallas = _data["Pallas"];
            this.juno = _data["Juno"];
            this.vesta = _data["Vesta"];
            this.lilith = _data["Lilith"];
        }
    }

    static fromJS(data: any): TransitPlanetWeights {
        data = typeof data === 'object' ? data : {};
        let result = new TransitPlanetWeights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sun"] = this.sun;
        data["Moon"] = this.moon;
        data["Mercury"] = this.mercury;
        data["Venus"] = this.venus;
        data["Mars"] = this.mars;
        data["Jupiter"] = this.jupiter;
        data["Saturn"] = this.saturn;
        data["Uranus"] = this.uranus;
        data["Neptune"] = this.neptune;
        data["Pluto"] = this.pluto;
        data["NorthNode"] = this.northNode;
        data["SouthNode"] = this.southNode;
        data["Chiron"] = this.chiron;
        data["Earth"] = this.earth;
        data["Pholus"] = this.pholus;
        data["Ceres"] = this.ceres;
        data["Pallas"] = this.pallas;
        data["Juno"] = this.juno;
        data["Vesta"] = this.vesta;
        data["Lilith"] = this.lilith;
        return data;
    }
}

export interface ITransitPlanetWeights {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;
}

export class NatalSensitivity implements INatalSensitivity {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;

    constructor(data?: INatalSensitivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sun = _data["Sun"];
            this.moon = _data["Moon"];
            this.mercury = _data["Mercury"];
            this.venus = _data["Venus"];
            this.mars = _data["Mars"];
            this.jupiter = _data["Jupiter"];
            this.saturn = _data["Saturn"];
            this.uranus = _data["Uranus"];
            this.neptune = _data["Neptune"];
            this.pluto = _data["Pluto"];
            this.northNode = _data["NorthNode"];
            this.southNode = _data["SouthNode"];
            this.chiron = _data["Chiron"];
            this.earth = _data["Earth"];
            this.pholus = _data["Pholus"];
            this.ceres = _data["Ceres"];
            this.pallas = _data["Pallas"];
            this.juno = _data["Juno"];
            this.vesta = _data["Vesta"];
            this.lilith = _data["Lilith"];
        }
    }

    static fromJS(data: any): NatalSensitivity {
        data = typeof data === 'object' ? data : {};
        let result = new NatalSensitivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sun"] = this.sun;
        data["Moon"] = this.moon;
        data["Mercury"] = this.mercury;
        data["Venus"] = this.venus;
        data["Mars"] = this.mars;
        data["Jupiter"] = this.jupiter;
        data["Saturn"] = this.saturn;
        data["Uranus"] = this.uranus;
        data["Neptune"] = this.neptune;
        data["Pluto"] = this.pluto;
        data["NorthNode"] = this.northNode;
        data["SouthNode"] = this.southNode;
        data["Chiron"] = this.chiron;
        data["Earth"] = this.earth;
        data["Pholus"] = this.pholus;
        data["Ceres"] = this.ceres;
        data["Pallas"] = this.pallas;
        data["Juno"] = this.juno;
        data["Vesta"] = this.vesta;
        data["Lilith"] = this.lilith;
        return data;
    }
}

export interface INatalSensitivity {
    sun?: number;
    moon?: number;
    mercury?: number;
    venus?: number;
    mars?: number;
    jupiter?: number;
    saturn?: number;
    uranus?: number;
    neptune?: number;
    pluto?: number;
    northNode?: number;
    southNode?: number;
    chiron?: number;
    earth?: number;
    pholus?: number;
    ceres?: number;
    pallas?: number;
    juno?: number;
    vesta?: number;
    lilith?: number;
}

export class AspectWeights implements IAspectWeights {
    conjunction?: number;
    opposition?: number;
    square?: number;
    sextile?: number;
    trine?: number;
    semiSextile?: number;
    quincunx?: number;
    quintile?: number;
    none?: number;

    constructor(data?: IAspectWeights) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conjunction = _data["Conjunction"];
            this.opposition = _data["Opposition"];
            this.square = _data["Square"];
            this.sextile = _data["Sextile"];
            this.trine = _data["Trine"];
            this.semiSextile = _data["SemiSextile"];
            this.quincunx = _data["Quincunx"];
            this.quintile = _data["Quintile"];
            this.none = _data["None"];
        }
    }

    static fromJS(data: any): AspectWeights {
        data = typeof data === 'object' ? data : {};
        let result = new AspectWeights();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Conjunction"] = this.conjunction;
        data["Opposition"] = this.opposition;
        data["Square"] = this.square;
        data["Sextile"] = this.sextile;
        data["Trine"] = this.trine;
        data["SemiSextile"] = this.semiSextile;
        data["Quincunx"] = this.quincunx;
        data["Quintile"] = this.quintile;
        data["None"] = this.none;
        return data;
    }
}

export interface IAspectWeights {
    conjunction?: number;
    opposition?: number;
    square?: number;
    sextile?: number;
    trine?: number;
    semiSextile?: number;
    quincunx?: number;
    quintile?: number;
    none?: number;
}

export class AspectPolarity implements IAspectPolarity {
    conjunction?: number;
    opposition?: number;
    square?: number;
    sextile?: number;
    trine?: number;
    semiSextile?: number;
    quincunx?: number;
    quintile?: number;
    none?: number;

    constructor(data?: IAspectPolarity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conjunction = _data["Conjunction"];
            this.opposition = _data["Opposition"];
            this.square = _data["Square"];
            this.sextile = _data["Sextile"];
            this.trine = _data["Trine"];
            this.semiSextile = _data["SemiSextile"];
            this.quincunx = _data["Quincunx"];
            this.quintile = _data["Quintile"];
            this.none = _data["None"];
        }
    }

    static fromJS(data: any): AspectPolarity {
        data = typeof data === 'object' ? data : {};
        let result = new AspectPolarity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Conjunction"] = this.conjunction;
        data["Opposition"] = this.opposition;
        data["Square"] = this.square;
        data["Sextile"] = this.sextile;
        data["Trine"] = this.trine;
        data["SemiSextile"] = this.semiSextile;
        data["Quincunx"] = this.quincunx;
        data["Quintile"] = this.quintile;
        data["None"] = this.none;
        return data;
    }
}

export interface IAspectPolarity {
    conjunction?: number;
    opposition?: number;
    square?: number;
    sextile?: number;
    trine?: number;
    semiSextile?: number;
    quincunx?: number;
    quintile?: number;
    none?: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}